import * as React from "react";
const SKillsSVG = (props) => (
  <svg
    className="animated"
    id="abhishek_stories-innovation"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <style>
      {
        "svg#abhishek_stories-innovation:not(.animated) .animable {opacity: 0;}svg#abhishek_stories-innovation.animated #abhishek--Background--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#abhishek_stories-innovation.animated #abhishek--Sparkles--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#abhishek_stories-innovation.animated #abhishek--gears-2--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#abhishek_stories-innovation.animated #abhishek--gears-1--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft,1.5s Infinite  linear wind;animation-delay: 0s,1s;}svg#abhishek_stories-innovation.animated #abhishek--Character--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#abhishek_stories-innovation.animated #abhishek--light-bulb--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown,1.5s Infinite  linear floating;animation-delay: 0s,1s;}            @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes wind {                0% {                    transform: rotate( 0deg );                }                25% {                    transform: rotate( 1deg );                }                75% {                    transform: rotate( -1deg );                }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        "
      }
    </style>
    <g
      id="abhishek--Background--inject-2"
      className="animable"
      style={{
        transformOrigin: "255.587px 252.708px",
      }}
    >
      <path
        id="abhishek--background--inject-2"
        d="M235.32,38.53c-59,36.36-51.15,70.07-79.58,114.63-26.7,41.85-44,46.28-89.36,79.74C25.16,263.32-3.36,336.05,46.07,404.1c52.8,72.7,168.27,94.82,264,72.7,121.86-28.14,191.32-145.39,180-260.39C479.82,111.73,417.47,51.06,368.78,32.26S268.4,18.15,235.32,38.53Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "255.587px 252.708px",
        }}
        className="animable"
      />
    </g>
    <g
      id="abhishek--Sparkles--inject-2"
      className="animable"
      style={{
        transformOrigin: "253.498px 245.012px",
      }}
    >
      <g
        id="abhishek--Shine--inject-2"
        className="animable"
        style={{
          transformOrigin: "253.498px 245.012px",
        }}
      >
        <g
          id="abhishek--shine--inject-2"
          className="animable"
          style={{
            transformOrigin: "49.9473px 348.041px",
          }}
        >
          <path
            d="M47.82,365.56a.21.21,0,0,1-.27-.13l-2.28-5.76a1.09,1.09,0,0,0-1.21-.68l-4.79.86a.22.22,0,0,1-.12-.43l4.49-1.88a1.1,1.1,0,0,0,.65-1.22l-1.21-6.08a.21.21,0,0,1,.15-.26.22.22,0,0,1,.27.13l2.28,5.77a1.1,1.1,0,0,0,1.21.67l4.79-.85a.24.24,0,0,1,.26.15.23.23,0,0,1-.13.27L47.42,358a1.1,1.1,0,0,0-.65,1.23L48,365.31A.22.22,0,0,1,47.82,365.56Zm-6.64-6.51,2.81-.5a1.54,1.54,0,0,1,1.7.95L47.06,363l-.73-3.66a1.54,1.54,0,0,1,.92-1.72l2.63-1.1-2.81.5a1.53,1.53,0,0,1-1.7-.95L44,352.58l.72,3.65h0a1.53,1.53,0,0,1-.91,1.72Zm3.33-2.78Z"
            style={{
              fill: "#213E60",
              transformOrigin: "45.5174px 357.771px",
            }}
            id="elbfpqmsa8gi4"
            className="animable"
          />
          <g id="elkw5k5yr41c">
            <g
              style={{
                opacity: 0.5,
                transformOrigin: "56.4005px 335.893px",
              }}
              className="animable"
              id="el7vy8zrpswh4"
            >
              <path
                d="M58,341.27a.23.23,0,0,1-.27-.14l-1.56-3.92a.67.67,0,0,0-.74-.42l-3.26.58a.22.22,0,0,1-.13-.42l3.06-1.28a.68.68,0,0,0,.4-.75l-.83-4.14a.23.23,0,0,1,.16-.26.22.22,0,0,1,.27.13l1.55,3.93a.68.68,0,0,0,.75.41l3.26-.58a.23.23,0,0,1,.13.43l-3.06,1.28a.67.67,0,0,0-.4.75l.82,4.14A.23.23,0,0,1,58,341.27Zm-3.93-4.69,1.28-.23a1.13,1.13,0,0,1,1.24.7l.64,1.62L56.92,337a1.14,1.14,0,0,1,.67-1.26l1.19-.5-1.27.23a1.12,1.12,0,0,1-1.24-.69l-.64-1.63.34,1.72h0a1.12,1.12,0,0,1-.67,1.25Zm1.65-1.71Z"
                style={{
                  fill: "#213E60",
                  transformOrigin: "56.4005px 335.893px",
                }}
                id="eld154a0p62u"
                className="animable"
              />
            </g>
          </g>
        </g>
        <g
          id="abhishek--shine--inject-2"
          className="animable"
          style={{
            transformOrigin: "357.265px 90.6303px",
          }}
        >
          <path
            d="M365.79,94.2a.29.29,0,0,1-.35-.17l-2.95-7.47a1.41,1.41,0,0,0-1.56-.87l-6.21,1.1a.29.29,0,0,1-.33-.2.29.29,0,0,1,.17-.35l5.81-2.43a1.42,1.42,0,0,0,.84-1.59l-1.56-7.87a.29.29,0,0,1,.2-.33.29.29,0,0,1,.35.17l2.95,7.46h0a1.41,1.41,0,0,0,1.57.88l6.2-1.11a.29.29,0,0,1,.33.21.28.28,0,0,1-.17.34l-5.81,2.44a1.4,1.4,0,0,0-.84,1.58L366,93.86A.29.29,0,0,1,365.79,94.2Zm-8.6-8.43,3.63-.65A2,2,0,0,1,363,86.35l1.77,4.49-.94-4.73a2,2,0,0,1,1.19-2.23l3.4-1.43-3.63.65a2,2,0,0,1-2.21-1.23l-1.77-4.49.94,4.73a2,2,0,0,1-1.18,2.23Z"
            style={{
              fill: "#213E60",
              transformOrigin: "362.82px 84.11px",
            }}
            id="elg9avhz1wlf"
            className="animable"
          />
          <g id="elp66gietsxsb">
            <g
              style={{
                opacity: 0.5,
                transformOrigin: "348.033px 101.582px",
              }}
              className="animable"
              id="elzpm7emuuj4"
            >
              <path
                d="M349.72,107.24a.23.23,0,0,1-.29-.14L347.79,103a.73.73,0,0,0-.79-.44l-3.45.62a.24.24,0,0,1-.27-.17.23.23,0,0,1,.13-.28l3.24-1.36a.71.71,0,0,0,.42-.8l-.87-4.37a.25.25,0,0,1,.17-.28h0a.24.24,0,0,1,.28.14l1.64,4.16a.73.73,0,0,0,.79.44l3.45-.62a.24.24,0,0,1,.14.45l-3.24,1.35a.71.71,0,0,0-.42.8l.87,4.38A.24.24,0,0,1,349.72,107.24Zm-4.15-4.95,1.35-.24a1.18,1.18,0,0,1,1.31.73l.68,1.71-.37-1.81a1.19,1.19,0,0,1,.71-1.32l1.27-.53-1.36.24a1.19,1.19,0,0,1-1.31-.73h0l-.67-1.72.36,1.81a1.2,1.2,0,0,1-.71,1.33Z"
                style={{
                  fill: "#213E60",
                  transformOrigin: "348.033px 101.582px",
                }}
                id="el8i543e5vcfo"
                className="animable"
              />
            </g>
          </g>
        </g>
        <g
          id="abhishek--shine--inject-2"
          className="animable"
          style={{
            transformOrigin: "120.328px 433.139px",
          }}
        >
          <path
            d="M116.77,438a.26.26,0,0,1-.32-.16l-2.73-6.89a1.31,1.31,0,0,0-1.45-.81l-5.73,1a.27.27,0,0,1-.3-.19.27.27,0,0,1,.15-.32l5.37-2.25a1.3,1.3,0,0,0,.78-1.46l-1.45-7.27a.28.28,0,0,1,.19-.31.26.26,0,0,1,.32.16l2.73,6.89h0a1.3,1.3,0,0,0,1.45.81l5.73-1a.27.27,0,0,1,.3.19.27.27,0,0,1-.15.32l-5.37,2.25a1.3,1.3,0,0,0-.78,1.46l1.45,7.27A.28.28,0,0,1,116.77,438Zm-8-7.79,3.36-.6a1.86,1.86,0,0,1,2,1.14l1.64,4.14-.88-4.37a1.85,1.85,0,0,1,1.1-2.06l3.15-1.31-3.36.6a1.86,1.86,0,0,1-2-1.14l-1.64-4.14.87,4.37a1.84,1.84,0,0,1-1.09,2.05Z"
            style={{
              fill: "#213E60",
              transformOrigin: "114.025px 428.67px",
            }}
            id="elcw20afwsaz"
            className="animable"
          />
          <g id="elyidgq7i55mj">
            <g
              style={{
                opacity: 0.5,
                transformOrigin: "130.008px 441.7px",
              }}
              className="animable"
              id="el7fjd989206d"
            >
              <path
                d="M131.54,446.94a.21.21,0,0,1-.26-.13L129.76,443a.67.67,0,0,0-.73-.41l-3.19.57a.21.21,0,0,1-.24-.15.22.22,0,0,1,.12-.27l3-1.25a.65.65,0,0,0,.39-.73l-.8-4.05a.21.21,0,0,1,.15-.25h0a.21.21,0,0,1,.26.13l1.52,3.83a.66.66,0,0,0,.73.41l3.18-.57a.22.22,0,0,1,.13.42l-3,1.25a.66.66,0,0,0-.39.74l.8,4A.21.21,0,0,1,131.54,446.94Zm-3.83-4.58,1.25-.22a1.1,1.1,0,0,1,1.21.68l.62,1.58-.33-1.67a1.09,1.09,0,0,1,.65-1.22l1.17-.49-1.25.22a1.1,1.1,0,0,1-1.21-.67h0l-.63-1.58.34,1.67a1.09,1.09,0,0,1-.65,1.22Z"
                style={{
                  fill: "#213E60",
                  transformOrigin: "130.008px 441.7px",
                }}
                id="elk2yx7lcpjzm"
                className="animable"
              />
            </g>
          </g>
        </g>
        <g
          id="abhishek--shine--inject-2"
          className="animable"
          style={{
            transformOrigin: "376.961px 157.832px",
          }}
        >
          <path
            d="M462,272.58a.25.25,0,0,1-.3-.14l-2.48-6.27a1.18,1.18,0,0,0-1.31-.74l-5.22.93a.24.24,0,0,1-.27-.17.23.23,0,0,1,.14-.29l4.88-2a1.19,1.19,0,0,0,.71-1.33l-1.32-6.61a.25.25,0,0,1,.47-.14l2.47,6.27h0a1.2,1.2,0,0,0,1.32.74l5.21-.93a.25.25,0,0,1,.28.17.25.25,0,0,1-.14.29l-4.88,2.05a1.19,1.19,0,0,0-.71,1.33l1.31,6.61A.24.24,0,0,1,462,272.58Zm-7.23-7.08,3-.55a1.68,1.68,0,0,1,1.85,1l1.49,3.77-.79-4a1.69,1.69,0,0,1,1-1.87l2.86-1.2-3.05.55a1.69,1.69,0,0,1-1.86-1l-1.49-3.77.8,4a1.69,1.69,0,0,1-1,1.87Z"
            style={{
              fill: "#213E60",
              transformOrigin: "459.498px 264.138px",
            }}
            id="elboos5wjxxiq"
            className="animable"
          />
          <path
            d="M290.82,51.71a.13.13,0,0,1-.15-.08l-1.27-3.21a.61.61,0,0,0-.68-.37l-2.66.47a.11.11,0,0,1-.14-.08.12.12,0,0,1,.07-.15l2.5-1a.62.62,0,0,0,.36-.68l-.68-3.39a.13.13,0,0,1,.09-.14.12.12,0,0,1,.15.07l1.27,3.21h0a.61.61,0,0,0,.67.38l2.67-.48a.13.13,0,0,1,.14.09.12.12,0,0,1-.07.15l-2.5,1a.61.61,0,0,0-.36.68l.67,3.38A.12.12,0,0,1,290.82,51.71Zm-3.7-3.63,1.56-.28a.86.86,0,0,1,.95.53l.76,1.93-.4-2a.86.86,0,0,1,.51-1l1.46-.61-1.56.27a.85.85,0,0,1-.95-.53l-.76-1.92.4,2a.86.86,0,0,1-.51,1Z"
            style={{
              fill: "#213E60",
              transformOrigin: "289.54px 47.3935px",
            }}
            id="elkn4036qbs0s"
            className="animable"
          />
          <g id="els3vvb0wzcd">
            <g
              style={{
                opacity: 0.5,
                transformOrigin: "464.006px 242.856px",
              }}
              className="animable"
              id="elyh4hu1bk2mo"
            >
              <path
                d="M465.41,247.65a.19.19,0,0,1-.24-.12L463.79,244a.59.59,0,0,0-.66-.36l-2.9.51a.2.2,0,0,1-.11-.38l2.71-1.13a.6.6,0,0,0,.36-.67l-.73-3.68a.2.2,0,0,1,.14-.23h0a.2.2,0,0,1,.24.12l1.37,3.49a.61.61,0,0,0,.67.36l2.9-.51a.19.19,0,0,1,.22.14.2.2,0,0,1-.11.24l-2.72,1.13a.62.62,0,0,0-.36.67l.74,3.68A.2.2,0,0,1,465.41,247.65Zm-3.49-4.16,1.14-.2a1,1,0,0,1,1.1.61l.57,1.44-.3-1.52a1,1,0,0,1,.59-1.11l1.06-.45-1.13.21a1,1,0,0,1-1.1-.62h0l-.56-1.44.3,1.52A1,1,0,0,1,463,243Z"
                style={{
                  fill: "#213E60",
                  transformOrigin: "464.006px 242.856px",
                }}
                id="el6rf9p60eckg"
                className="animable"
              />
            </g>
          </g>
          <g id="el5mgchu1x34j">
            <g
              style={{
                opacity: 0.5,
                transformOrigin: "451.208px 136.238px",
              }}
              className="animable"
              id="eleqkw3h4jplg"
            >
              <path
                d="M452.61,141a.2.2,0,0,1-.24-.12L451,137.42a.61.61,0,0,0-.66-.37l-2.9.52a.2.2,0,0,1-.12-.38l2.72-1.14a.61.61,0,0,0,.36-.67l-.73-3.68a.19.19,0,0,1,.13-.22h0a.19.19,0,0,1,.24.11l1.38,3.49a.62.62,0,0,0,.67.37l2.89-.52a.22.22,0,0,1,.23.14.2.2,0,0,1-.11.24l-2.72,1.14a.61.61,0,0,0-.36.67l.74,3.68A.2.2,0,0,1,452.61,141Zm-3.49-4.17,1.14-.2a1,1,0,0,1,1.1.61l.57,1.45-.31-1.52a1,1,0,0,1,.6-1.12l1.06-.44-1.14.2a1,1,0,0,1-1.1-.61h0l-.57-1.45.31,1.52a1,1,0,0,1-.59,1.12Z"
                style={{
                  fill: "#213E60",
                  transformOrigin: "451.208px 136.238px",
                }}
                id="elb63tn0f36ep"
                className="animable"
              />
            </g>
          </g>
        </g>
        <g
          id="abhishek--shine--inject-2"
          className="animable"
          style={{
            transformOrigin: "299.966px 329.248px",
          }}
        >
          <path
            d="M290.22,348.82a.21.21,0,0,1-.23-.12l-2-5a1,1,0,0,0-1.05-.59l-4.16.74a.2.2,0,0,1-.22-.13.19.19,0,0,1,.11-.23l3.9-1.64a1,1,0,0,0,.57-1.06l-1.06-5.27a.2.2,0,0,1,.14-.23.19.19,0,0,1,.23.12l2,5a1,1,0,0,0,1.05.59l4.16-.74a.19.19,0,0,1,.22.13.18.18,0,0,1-.11.23l-3.9,1.64a1,1,0,0,0-.56,1.06l1.05,5.27A.2.2,0,0,1,290.22,348.82Zm-5.76-5.65,2.43-.44a1.34,1.34,0,0,1,1.48.83l1.19,3-.63-3.17a1.33,1.33,0,0,1,.79-1.49l2.29-1-2.44.44a1.35,1.35,0,0,1-1.48-.83h0l-1.19-3,.63,3.17a1.33,1.33,0,0,1-.79,1.49Z"
            style={{
              fill: "#213E60",
              transformOrigin: "288.221px 342.053px",
            }}
            id="elehdjbkjbyjg"
            className="animable"
          />
          <g id="elgnjrni8a9vl">
            <g
              style={{
                opacity: 0.5,
                transformOrigin: "313.471px 337.332px",
              }}
              className="animable"
              id="el8gdb15t5iqf"
            >
              <path
                d="M314.84,342a.21.21,0,0,1-.23-.12l-1.35-3.4a.59.59,0,0,0-.64-.37l-2.83.51a.18.18,0,0,1-.22-.14.19.19,0,0,1,.11-.23l2.65-1.11a.59.59,0,0,0,.35-.65l-.72-3.6a.19.19,0,0,1,.14-.22.18.18,0,0,1,.23.12l1.35,3.4h0a.57.57,0,0,0,.64.36l2.84-.5a.18.18,0,0,1,.21.13.19.19,0,0,1-.11.24l-2.65,1.11a.59.59,0,0,0-.35.65l.72,3.59A.2.2,0,0,1,314.84,342Zm-3.4-4.07,1.11-.2a1,1,0,0,1,1.07.6l.56,1.41-.3-1.48a1,1,0,0,1,.58-1.09l1-.43-1.11.19a1,1,0,0,1-1.07-.6l-.56-1.41.3,1.49a1,1,0,0,1-.58,1.09Z"
                style={{
                  fill: "#213E60",
                  transformOrigin: "313.471px 337.332px",
                }}
                id="elf8h7mg20zj"
                className="animable"
              />
            </g>
          </g>
          <g id="elyloc0vo6xrd">
            <g
              style={{
                opacity: 0.5,
                transformOrigin: "312.457px 314.34px",
              }}
              className="animable"
              id="elqsibu05krsa"
            >
              <path
                d="M313.83,319a.19.19,0,0,1-.23-.11l-1.35-3.41a.59.59,0,0,0-.65-.36l-2.83.51a.2.2,0,0,1-.22-.14.2.2,0,0,1,.11-.23l2.66-1.11a.6.6,0,0,0,.35-.66l-.72-3.59a.19.19,0,0,1,.13-.22.2.2,0,0,1,.24.11l1.35,3.41h0a.57.57,0,0,0,.64.36l2.83-.5a.19.19,0,0,1,.22.13.18.18,0,0,1-.11.23l-2.65,1.12a.58.58,0,0,0-.35.65l.72,3.59A.18.18,0,0,1,313.83,319Zm-3.4-4.06,1.11-.2a1,1,0,0,1,1.07.6l.56,1.41-.3-1.49a1,1,0,0,1,.58-1.08l1-.44-1.11.2a1,1,0,0,1-1.07-.6l-.56-1.41.29,1.49a1,1,0,0,1-.57,1.08Z"
                style={{
                  fill: "#213E60",
                  transformOrigin: "312.457px 314.34px",
                }}
                id="elq13r0p2dk4"
                className="animable"
              />
            </g>
          </g>
        </g>
        <g id="abhishek--shine--inject-2">
          <g
            style={{
              opacity: 0.5,
              transformOrigin: "398.305px 400.625px",
            }}
            className="animable"
            id="elescjqe75cmo"
          >
            <path
              d="M399.89,406a.23.23,0,0,1-.27-.13l-1.55-3.93a.67.67,0,0,0-.75-.41l-3.26.58a.23.23,0,0,1-.13-.43l3.06-1.28a.68.68,0,0,0,.4-.75l-.82-4.14a.22.22,0,0,1,.15-.26.23.23,0,0,1,.27.14l1.55,3.92a.67.67,0,0,0,.75.41l3.26-.58a.23.23,0,0,1,.13.43l-3.06,1.28a.67.67,0,0,0-.4.75l.82,4.14A.22.22,0,0,1,399.89,406ZM396,401.27l1.27-.22a1.11,1.11,0,0,1,1.24.69l.64,1.62-.34-1.71a1.12,1.12,0,0,1,.67-1.25l1.19-.5-1.27.22a1.1,1.1,0,0,1-1.24-.69h0l-.64-1.62.34,1.71a1.12,1.12,0,0,1-.67,1.25Z"
              style={{
                fill: "#213E60",
                transformOrigin: "398.305px 400.625px",
              }}
              id="el77ov3ea8zrk"
              className="animable"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="abhishek--gears-2--inject-2"
      className="animable"
      style={{
        transformOrigin: "265.43px 260.855px",
      }}
    >
      <g
        id="abhishek--small-gears--inject-2"
        className="animable"
        style={{
          transformOrigin: "265.43px 260.855px",
        }}
      >
        <path
          d="M89.68,387.57H86.4a.67.67,0,0,1-.64-.6l-.32-2.91a.42.42,0,0,0-.26-.28,9.49,9.49,0,0,1-1.62-.66.53.53,0,0,0-.37-.07L80.77,385a.71.71,0,0,1-.91-.19l-2.11-2.11a.71.71,0,0,1-.19-.92l1.94-2.42a.51.51,0,0,0-.07-.36,10.42,10.42,0,0,1-.67-1.62.39.39,0,0,0-.27-.26l-2.92-.32a.67.67,0,0,1-.59-.65v-3.27a.63.63,0,0,1,.55-.64l3-.33a.26.26,0,0,0,.2-.16,10.25,10.25,0,0,1,.78-1.87.54.54,0,0,0-.14-.37l-1.68-2.1a.7.7,0,0,1-.09-.92L80,364.07a.71.71,0,0,1,.92.08l2.1,1.69a.62.62,0,0,0,.38.14,9.77,9.77,0,0,1,1.86-.78.27.27,0,0,0,.16-.21l.33-3a.66.66,0,0,1,.64-.56h3.28a.67.67,0,0,1,.64.6l.32,2.92a.41.41,0,0,0,.26.27,9.53,9.53,0,0,1,1.62.67.5.5,0,0,0,.37.06L95.31,364a.71.71,0,0,1,.91.2l2.11,2.11a.71.71,0,0,1,.19.91l-1.94,2.42a.5.5,0,0,0,.07.36,10.84,10.84,0,0,1,.67,1.62.42.42,0,0,0,.27.27l2.92.32a.65.65,0,0,1,.59.64v3.27a.63.63,0,0,1-.55.64l-3,.33a.26.26,0,0,0-.2.16,10.25,10.25,0,0,1-.78,1.87.53.53,0,0,0,.14.37l1.68,2.11a.7.7,0,0,1,.09.92L96.07,385a.7.7,0,0,1-.92-.09l-2.1-1.69a.51.51,0,0,0-.38-.13,9.73,9.73,0,0,1-1.86.77.28.28,0,0,0-.17.21l-.32,3A.66.66,0,0,1,89.68,387.57Zm-6.42-5a1.19,1.19,0,0,1,.53.13,8.8,8.8,0,0,0,1.53.63.89.89,0,0,1,.61.7l.33,2.92a.17.17,0,0,0,.14.15h3.28a.15.15,0,0,0,.14-.11l.33-3a.77.77,0,0,1,.52-.63,9.09,9.09,0,0,0,1.77-.74.94.94,0,0,1,.92.19l2.1,1.69a.37.37,0,0,0,.28.11l2.39-2.4a.79.79,0,0,0-.13-.25l-1.68-2.11a.89.89,0,0,1-.19-.92,10.18,10.18,0,0,0,.74-1.77.76.76,0,0,1,.63-.51l3-.33a.16.16,0,0,0,.11-.15v-3.27a.17.17,0,0,0-.15-.15l-2.91-.32a.87.87,0,0,1-.7-.61,9.77,9.77,0,0,0-.63-1.54.86.86,0,0,1,0-.9l1.94-2.42a.53.53,0,0,0-.15-.25l-2.11-2.11a.42.42,0,0,0-.27-.14l-2.4,1.93a.9.9,0,0,1-.91,0,8.8,8.8,0,0,0-1.53-.63.9.9,0,0,1-.62-.7l-.32-2.92a.17.17,0,0,0-.14-.15H86.4a.15.15,0,0,0-.14.12l-.33,3a.77.77,0,0,1-.52.63,9.09,9.09,0,0,0-1.77.74.89.89,0,0,1-.92-.19l-2.1-1.69a.47.47,0,0,0-.28-.11L78,366.83a.86.86,0,0,0,.13.26l1.68,2.1a.89.89,0,0,1,.19.92,9.46,9.46,0,0,0-.74,1.77.77.77,0,0,1-.63.52l-3,.33a.13.13,0,0,0-.11.14v3.27a.17.17,0,0,0,.15.15l2.91.32a.87.87,0,0,1,.7.61,9.39,9.39,0,0,0,.63,1.54.86.86,0,0,1,0,.9L78,382.09a.58.58,0,0,0,.15.24l2.11,2.11a.42.42,0,0,0,.27.15l2.4-1.94A.61.61,0,0,1,83.26,382.54ZM88,380.29a5.79,5.79,0,1,1,5.78-5.78A5.79,5.79,0,0,1,88,380.29Zm0-11.07a5.29,5.29,0,1,0,5.28,5.29A5.3,5.3,0,0,0,88,369.22Z"
          style={{
            fill: "#213E60",
            transformOrigin: "88.04px 374.5px",
          }}
          id="el45vgld8uyb9"
          className="animable"
        />
        <g id="elvgsq8bv4iij">
          <g
            style={{
              opacity: 0.6,
              transformOrigin: "88.04px 374.5px",
            }}
            className="animable"
            id="el2r356wwaf97"
          >
            <path
              d="M89.68,387.57H86.4a.67.67,0,0,1-.64-.6l-.32-2.91a.42.42,0,0,0-.26-.28,9.49,9.49,0,0,1-1.62-.66.53.53,0,0,0-.37-.07L80.77,385a.71.71,0,0,1-.91-.19l-2.11-2.11a.71.71,0,0,1-.19-.92l1.94-2.42a.51.51,0,0,0-.07-.36,10.42,10.42,0,0,1-.67-1.62.39.39,0,0,0-.27-.26l-2.92-.32a.67.67,0,0,1-.59-.65v-3.27a.63.63,0,0,1,.55-.64l3-.33a.26.26,0,0,0,.2-.16,10.25,10.25,0,0,1,.78-1.87.54.54,0,0,0-.14-.37l-1.68-2.1a.7.7,0,0,1-.09-.92L80,364.07a.71.71,0,0,1,.92.08l2.1,1.69a.62.62,0,0,0,.38.14,9.77,9.77,0,0,1,1.86-.78.27.27,0,0,0,.16-.21l.33-3a.66.66,0,0,1,.64-.56h3.28a.67.67,0,0,1,.64.6l.32,2.92a.41.41,0,0,0,.26.27,9.53,9.53,0,0,1,1.62.67.5.5,0,0,0,.37.06L95.31,364a.71.71,0,0,1,.91.2l2.11,2.11a.71.71,0,0,1,.19.91l-1.94,2.42a.5.5,0,0,0,.07.36,10.84,10.84,0,0,1,.67,1.62.42.42,0,0,0,.27.27l2.92.32a.65.65,0,0,1,.59.64v3.27a.63.63,0,0,1-.55.64l-3,.33a.26.26,0,0,0-.2.16,10.25,10.25,0,0,1-.78,1.87.53.53,0,0,0,.14.37l1.68,2.11a.7.7,0,0,1,.09.92L96.07,385a.7.7,0,0,1-.92-.09l-2.1-1.69a.51.51,0,0,0-.38-.13,9.73,9.73,0,0,1-1.86.77.28.28,0,0,0-.17.21l-.32,3A.66.66,0,0,1,89.68,387.57Zm-6.42-5a1.19,1.19,0,0,1,.53.13,8.8,8.8,0,0,0,1.53.63.89.89,0,0,1,.61.7l.33,2.92a.17.17,0,0,0,.14.15h3.28a.15.15,0,0,0,.14-.11l.33-3a.77.77,0,0,1,.52-.63,9.09,9.09,0,0,0,1.77-.74.94.94,0,0,1,.92.19l2.1,1.69a.37.37,0,0,0,.28.11l2.39-2.4a.79.79,0,0,0-.13-.25l-1.68-2.11a.89.89,0,0,1-.19-.92,10.18,10.18,0,0,0,.74-1.77.76.76,0,0,1,.63-.51l3-.33a.16.16,0,0,0,.11-.15v-3.27a.17.17,0,0,0-.15-.15l-2.91-.32a.87.87,0,0,1-.7-.61,9.77,9.77,0,0,0-.63-1.54.86.86,0,0,1,0-.9l1.94-2.42a.53.53,0,0,0-.15-.25l-2.11-2.11a.42.42,0,0,0-.27-.14l-2.4,1.93a.9.9,0,0,1-.91,0,8.8,8.8,0,0,0-1.53-.63.9.9,0,0,1-.62-.7l-.32-2.92a.17.17,0,0,0-.14-.15H86.4a.15.15,0,0,0-.14.12l-.33,3a.77.77,0,0,1-.52.63,9.09,9.09,0,0,0-1.77.74.89.89,0,0,1-.92-.19l-2.1-1.69a.47.47,0,0,0-.28-.11L78,366.83a.86.86,0,0,0,.13.26l1.68,2.1a.89.89,0,0,1,.19.92,9.46,9.46,0,0,0-.74,1.77.77.77,0,0,1-.63.52l-3,.33a.13.13,0,0,0-.11.14v3.27a.17.17,0,0,0,.15.15l2.91.32a.87.87,0,0,1,.7.61,9.39,9.39,0,0,0,.63,1.54.86.86,0,0,1,0,.9L78,382.09a.58.58,0,0,0,.15.24l2.11,2.11a.42.42,0,0,0,.27.15l2.4-1.94A.61.61,0,0,1,83.26,382.54ZM88,380.29a5.79,5.79,0,1,1,5.78-5.78A5.79,5.79,0,0,1,88,380.29Zm0-11.07a5.29,5.29,0,1,0,5.28,5.29A5.3,5.3,0,0,0,88,369.22Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "88.04px 374.5px",
              }}
              id="elfxk14g71su5"
              className="animable"
            />
          </g>
        </g>
        <path
          d="M224.31,465.58h-2.39a.49.49,0,0,1-.48-.44l-.23-2.14a.33.33,0,0,0-.19-.2,7.22,7.22,0,0,1-1.19-.48.33.33,0,0,0-.27-.05l-1.77,1.42a.54.54,0,0,1-.67-.14L215.58,462a.54.54,0,0,1-.14-.67l1.42-1.77a.36.36,0,0,0-.05-.26,7.64,7.64,0,0,1-.49-1.19.27.27,0,0,0-.2-.19l-2.13-.24a.48.48,0,0,1-.44-.47v-2.4a.46.46,0,0,1,.41-.46l2.19-.24a.21.21,0,0,0,.15-.12,6.6,6.6,0,0,1,.57-1.37.4.4,0,0,0-.1-.27l-1.24-1.54a.54.54,0,0,1-.06-.68l1.76-1.76a.53.53,0,0,1,.68.06l1.54,1.24a.4.4,0,0,0,.27.1,6.6,6.6,0,0,1,1.37-.57.21.21,0,0,0,.12-.15l.24-2.19a.47.47,0,0,1,.47-.41h2.39a.49.49,0,0,1,.48.44L225,449a.29.29,0,0,0,.19.2,7.26,7.26,0,0,1,1.19.49.45.45,0,0,0,.27.05l1.77-1.42c.16-.14.45-.08.67.14l1.54,1.54a.54.54,0,0,1,.14.67l-1.42,1.77a.39.39,0,0,0,0,.27,7.26,7.26,0,0,1,.49,1.19.29.29,0,0,0,.2.19l2.13.23a.49.49,0,0,1,.44.47v2.4a.47.47,0,0,1-.41.47l-2.19.24a.21.21,0,0,0-.15.12,7.09,7.09,0,0,1-.57,1.37.4.4,0,0,0,.1.27l1.24,1.54a.52.52,0,0,1,.06.67L229,463.66a.53.53,0,0,1-.68-.07l-1.54-1.23a.39.39,0,0,0-.27-.1,7.09,7.09,0,0,1-1.37.57.19.19,0,0,0-.12.15l-.24,2.19A.47.47,0,0,1,224.31,465.58Zm-4.69-3.69a.83.83,0,0,1,.38.1,6.57,6.57,0,0,0,1.13.47.62.62,0,0,1,.44.5l.24,2.14a.13.13,0,0,0,.11.11h2.39a.11.11,0,0,0,.11-.08l.24-2.19a.58.58,0,0,1,.38-.47,6.3,6.3,0,0,0,1.29-.54.7.7,0,0,1,.68.14l1.54,1.24a.31.31,0,0,0,.2.08l1.75-1.76a.36.36,0,0,0-.09-.18l-1.24-1.54a.67.67,0,0,1-.13-.68,7.65,7.65,0,0,0,.54-1.29.54.54,0,0,1,.46-.38l2.19-.24a.11.11,0,0,0,.08-.11v-2.4a.11.11,0,0,0-.11-.1l-2.13-.24a.62.62,0,0,1-.51-.45,6.82,6.82,0,0,0-.47-1.12.65.65,0,0,1,0-.66l1.42-1.78a.41.41,0,0,0-.11-.18l-1.54-1.54a.38.38,0,0,0-.2-.11l-1.76,1.42a.63.63,0,0,1-.66,0,7.43,7.43,0,0,0-1.13-.46.64.64,0,0,1-.44-.51l-.24-2.14a.12.12,0,0,0-.11-.11h-2.39a.12.12,0,0,0-.11.09l-.24,2.19a.56.56,0,0,1-.38.46,6.64,6.64,0,0,0-1.29.54.67.67,0,0,1-.68-.14l-1.54-1.23c-.1-.08-.18-.09-.2-.08l-1.75,1.75a.37.37,0,0,0,.09.19l1.24,1.54a.68.68,0,0,1,.13.67,7.75,7.75,0,0,0-.54,1.3.57.57,0,0,1-.46.38l-2.19.24a.1.1,0,0,0-.08.1v2.4a.12.12,0,0,0,.11.11l2.13.23a.65.65,0,0,1,.51.45,6.57,6.57,0,0,0,.47,1.13.65.65,0,0,1,0,.66l-1.42,1.77a.36.36,0,0,0,.11.18l1.54,1.55a.29.29,0,0,0,.2.1l1.76-1.41A.43.43,0,0,1,219.62,461.89Zm3.49-1.64a4.24,4.24,0,1,1,4.24-4.24A4.24,4.24,0,0,1,223.11,460.25Zm0-8.11A3.87,3.87,0,1,0,227,456,3.88,3.88,0,0,0,223.11,452.14Z"
          style={{
            fill: "#213E60",
            transformOrigin: "223.08px 456.015px",
          }}
          id="elj0eonfsiuzs"
          className="animable"
        />
        <g id="ele7nz8co67w5">
          <g
            style={{
              opacity: 0.6,
              transformOrigin: "223.08px 456.015px",
            }}
            className="animable"
            id="elvaatoa2hf"
          >
            <path
              d="M224.31,465.58h-2.39a.49.49,0,0,1-.48-.44l-.23-2.14a.33.33,0,0,0-.19-.2,7.22,7.22,0,0,1-1.19-.48.33.33,0,0,0-.27-.05l-1.77,1.42a.54.54,0,0,1-.67-.14L215.58,462a.54.54,0,0,1-.14-.67l1.42-1.77a.36.36,0,0,0-.05-.26,7.64,7.64,0,0,1-.49-1.19.27.27,0,0,0-.2-.19l-2.13-.24a.48.48,0,0,1-.44-.47v-2.4a.46.46,0,0,1,.41-.46l2.19-.24a.21.21,0,0,0,.15-.12,6.6,6.6,0,0,1,.57-1.37.4.4,0,0,0-.1-.27l-1.24-1.54a.54.54,0,0,1-.06-.68l1.76-1.76a.53.53,0,0,1,.68.06l1.54,1.24a.4.4,0,0,0,.27.1,6.6,6.6,0,0,1,1.37-.57.21.21,0,0,0,.12-.15l.24-2.19a.47.47,0,0,1,.47-.41h2.39a.49.49,0,0,1,.48.44L225,449a.29.29,0,0,0,.19.2,7.26,7.26,0,0,1,1.19.49.45.45,0,0,0,.27.05l1.77-1.42c.16-.14.45-.08.67.14l1.54,1.54a.54.54,0,0,1,.14.67l-1.42,1.77a.39.39,0,0,0,0,.27,7.26,7.26,0,0,1,.49,1.19.29.29,0,0,0,.2.19l2.13.23a.49.49,0,0,1,.44.47v2.4a.47.47,0,0,1-.41.47l-2.19.24a.21.21,0,0,0-.15.12,7.09,7.09,0,0,1-.57,1.37.4.4,0,0,0,.1.27l1.24,1.54a.52.52,0,0,1,.06.67L229,463.66a.53.53,0,0,1-.68-.07l-1.54-1.23a.39.39,0,0,0-.27-.1,7.09,7.09,0,0,1-1.37.57.19.19,0,0,0-.12.15l-.24,2.19A.47.47,0,0,1,224.31,465.58Zm-4.69-3.69a.83.83,0,0,1,.38.1,6.57,6.57,0,0,0,1.13.47.62.62,0,0,1,.44.5l.24,2.14a.13.13,0,0,0,.11.11h2.39a.11.11,0,0,0,.11-.08l.24-2.19a.58.58,0,0,1,.38-.47,6.3,6.3,0,0,0,1.29-.54.7.7,0,0,1,.68.14l1.54,1.24a.31.31,0,0,0,.2.08l1.75-1.76a.36.36,0,0,0-.09-.18l-1.24-1.54a.67.67,0,0,1-.13-.68,7.65,7.65,0,0,0,.54-1.29.54.54,0,0,1,.46-.38l2.19-.24a.11.11,0,0,0,.08-.11v-2.4a.11.11,0,0,0-.11-.1l-2.13-.24a.62.62,0,0,1-.51-.45,6.82,6.82,0,0,0-.47-1.12.65.65,0,0,1,0-.66l1.42-1.78a.41.41,0,0,0-.11-.18l-1.54-1.54a.38.38,0,0,0-.2-.11l-1.76,1.42a.63.63,0,0,1-.66,0,7.43,7.43,0,0,0-1.13-.46.64.64,0,0,1-.44-.51l-.24-2.14a.12.12,0,0,0-.11-.11h-2.39a.12.12,0,0,0-.11.09l-.24,2.19a.56.56,0,0,1-.38.46,6.64,6.64,0,0,0-1.29.54.67.67,0,0,1-.68-.14l-1.54-1.23c-.1-.08-.18-.09-.2-.08l-1.75,1.75a.37.37,0,0,0,.09.19l1.24,1.54a.68.68,0,0,1,.13.67,7.75,7.75,0,0,0-.54,1.3.57.57,0,0,1-.46.38l-2.19.24a.1.1,0,0,0-.08.1v2.4a.12.12,0,0,0,.11.11l2.13.23a.65.65,0,0,1,.51.45,6.57,6.57,0,0,0,.47,1.13.65.65,0,0,1,0,.66l-1.42,1.77a.36.36,0,0,0,.11.18l1.54,1.55a.29.29,0,0,0,.2.1l1.76-1.41A.43.43,0,0,1,219.62,461.89Zm3.49-1.64a4.24,4.24,0,1,1,4.24-4.24A4.24,4.24,0,0,1,223.11,460.25Zm0-8.11A3.87,3.87,0,1,0,227,456,3.88,3.88,0,0,0,223.11,452.14Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "223.08px 456.015px",
              }}
              id="el3oqg0kdvw31"
              className="animable"
            />
          </g>
        </g>
        <path
          d="M324,81.49h-3.19a.66.66,0,0,1-.63-.58l-.31-2.84a.41.41,0,0,0-.25-.27,9.34,9.34,0,0,1-1.58-.64.53.53,0,0,0-.35-.07L315.32,79a.7.7,0,0,1-.89-.19l-2.05-2.05a.69.69,0,0,1-.19-.89l1.89-2.35a.53.53,0,0,0-.07-.35,10.3,10.3,0,0,1-.65-1.58.38.38,0,0,0-.26-.25L310.26,71a.66.66,0,0,1-.58-.63V67.19a.63.63,0,0,1,.54-.62l2.92-.32a.29.29,0,0,0,.2-.15,9.06,9.06,0,0,1,.75-1.82.55.55,0,0,0-.13-.36l-1.64-2a.7.7,0,0,1-.09-.9l2.34-2.34a.7.7,0,0,1,.9.08l2,1.64a.54.54,0,0,0,.36.14,9,9,0,0,1,1.81-.76.28.28,0,0,0,.16-.2l.32-2.91a.62.62,0,0,1,.62-.54H324a.64.64,0,0,1,.63.58l.31,2.83a.39.39,0,0,0,.26.27,9,9,0,0,1,1.57.65.54.54,0,0,0,.36.06l2.35-1.88a.7.7,0,0,1,.89.18l2.05,2a.7.7,0,0,1,.18.89l-1.89,2.36a.63.63,0,0,0,.07.35A9.79,9.79,0,0,1,331.4,66a.37.37,0,0,0,.27.26l2.83.31a.64.64,0,0,1,.58.62v3.19a.63.63,0,0,1-.54.62l-2.91.32a.28.28,0,0,0-.2.16,9.88,9.88,0,0,1-.76,1.82.54.54,0,0,0,.14.35l1.64,2a.68.68,0,0,1,.08.89l-2.34,2.35a.7.7,0,0,1-.9-.09l-2-1.64a.49.49,0,0,0-.36-.13,9.3,9.3,0,0,1-1.82.75.26.26,0,0,0-.15.2l-.32,2.91A.64.64,0,0,1,324,81.49Zm-6.24-4.9a1.15,1.15,0,0,1,.51.14,9.15,9.15,0,0,0,1.49.61.88.88,0,0,1,.6.68l.31,2.83a.16.16,0,0,0,.14.15H324a.13.13,0,0,0,.14-.11l.32-2.91a.75.75,0,0,1,.51-.61,9.21,9.21,0,0,0,1.72-.72.88.88,0,0,1,.89.18l2.05,1.64a.34.34,0,0,0,.27.11l2.32-2.33a.85.85,0,0,0-.12-.25l-1.64-2a.88.88,0,0,1-.18-.9,9.17,9.17,0,0,0,.71-1.72.75.75,0,0,1,.62-.5l2.91-.32a.14.14,0,0,0,.1-.14V67.19a.16.16,0,0,0-.14-.14l-2.84-.31a.84.84,0,0,1-.67-.59,8.94,8.94,0,0,0-.62-1.5.87.87,0,0,1,0-.88l1.89-2.35a.52.52,0,0,0-.15-.24l-2.05-2c-.12-.12-.22-.15-.26-.14l-2.33,1.88a.87.87,0,0,1-.88,0,8.94,8.94,0,0,0-1.5-.62.84.84,0,0,1-.59-.67l-.31-2.84a.17.17,0,0,0-.15-.14h-3.18a.14.14,0,0,0-.14.1l-.32,2.91a.75.75,0,0,1-.5.62,9.17,9.17,0,0,0-1.72.71.88.88,0,0,1-.9-.18l-2-1.64a.4.4,0,0,0-.27-.11l-2.32,2.33a.46.46,0,0,0,.12.25l1.64,2a.88.88,0,0,1,.18.89,9.21,9.21,0,0,0-.72,1.72.75.75,0,0,1-.61.51l-2.91.32a.13.13,0,0,0-.11.13v3.19a.16.16,0,0,0,.15.14l2.83.31a.88.88,0,0,1,.68.6,10.13,10.13,0,0,0,.61,1.49.85.85,0,0,1,0,.88l-1.89,2.36a.75.75,0,0,0,.15.24l2,2a.46.46,0,0,0,.26.14l2.34-1.88A.59.59,0,0,1,317.74,76.59Zm4.64-2.18A5.63,5.63,0,1,1,328,68.79,5.62,5.62,0,0,1,322.38,74.41Zm0-10.76a5.14,5.14,0,1,0,5.14,5.14A5.14,5.14,0,0,0,322.38,63.65Z"
          style={{
            fill: "#213E60",
            transformOrigin: "322.38px 68.81px",
          }}
          id="elp55euev8hfn"
          className="animable"
        />
        <g id="el2paqrqp45dj">
          <g
            style={{
              opacity: 0.6,
              transformOrigin: "322.38px 68.81px",
            }}
            className="animable"
            id="el35xb3kib03v"
          >
            <path
              d="M324,81.49h-3.19a.66.66,0,0,1-.63-.58l-.31-2.84a.41.41,0,0,0-.25-.27,9.34,9.34,0,0,1-1.58-.64.53.53,0,0,0-.35-.07L315.32,79a.7.7,0,0,1-.89-.19l-2.05-2.05a.69.69,0,0,1-.19-.89l1.89-2.35a.53.53,0,0,0-.07-.35,10.3,10.3,0,0,1-.65-1.58.38.38,0,0,0-.26-.25L310.26,71a.66.66,0,0,1-.58-.63V67.19a.63.63,0,0,1,.54-.62l2.92-.32a.29.29,0,0,0,.2-.15,9.06,9.06,0,0,1,.75-1.82.55.55,0,0,0-.13-.36l-1.64-2a.7.7,0,0,1-.09-.9l2.34-2.34a.7.7,0,0,1,.9.08l2,1.64a.54.54,0,0,0,.36.14,9,9,0,0,1,1.81-.76.28.28,0,0,0,.16-.2l.32-2.91a.62.62,0,0,1,.62-.54H324a.64.64,0,0,1,.63.58l.31,2.83a.39.39,0,0,0,.26.27,9,9,0,0,1,1.57.65.54.54,0,0,0,.36.06l2.35-1.88a.7.7,0,0,1,.89.18l2.05,2a.7.7,0,0,1,.18.89l-1.89,2.36a.63.63,0,0,0,.07.35A9.79,9.79,0,0,1,331.4,66a.37.37,0,0,0,.27.26l2.83.31a.64.64,0,0,1,.58.62v3.19a.63.63,0,0,1-.54.62l-2.91.32a.28.28,0,0,0-.2.16,9.88,9.88,0,0,1-.76,1.82.54.54,0,0,0,.14.35l1.64,2a.68.68,0,0,1,.08.89l-2.34,2.35a.7.7,0,0,1-.9-.09l-2-1.64a.49.49,0,0,0-.36-.13,9.3,9.3,0,0,1-1.82.75.26.26,0,0,0-.15.2l-.32,2.91A.64.64,0,0,1,324,81.49Zm-6.24-4.9a1.15,1.15,0,0,1,.51.14,9.15,9.15,0,0,0,1.49.61.88.88,0,0,1,.6.68l.31,2.83a.16.16,0,0,0,.14.15H324a.13.13,0,0,0,.14-.11l.32-2.91a.75.75,0,0,1,.51-.61,9.21,9.21,0,0,0,1.72-.72.88.88,0,0,1,.89.18l2.05,1.64a.34.34,0,0,0,.27.11l2.32-2.33a.85.85,0,0,0-.12-.25l-1.64-2a.88.88,0,0,1-.18-.9,9.17,9.17,0,0,0,.71-1.72.75.75,0,0,1,.62-.5l2.91-.32a.14.14,0,0,0,.1-.14V67.19a.16.16,0,0,0-.14-.14l-2.84-.31a.84.84,0,0,1-.67-.59,8.94,8.94,0,0,0-.62-1.5.87.87,0,0,1,0-.88l1.89-2.35a.52.52,0,0,0-.15-.24l-2.05-2c-.12-.12-.22-.15-.26-.14l-2.33,1.88a.87.87,0,0,1-.88,0,8.94,8.94,0,0,0-1.5-.62.84.84,0,0,1-.59-.67l-.31-2.84a.17.17,0,0,0-.15-.14h-3.18a.14.14,0,0,0-.14.1l-.32,2.91a.75.75,0,0,1-.5.62,9.17,9.17,0,0,0-1.72.71.88.88,0,0,1-.9-.18l-2-1.64a.4.4,0,0,0-.27-.11l-2.32,2.33a.46.46,0,0,0,.12.25l1.64,2a.88.88,0,0,1,.18.89,9.21,9.21,0,0,0-.72,1.72.75.75,0,0,1-.61.51l-2.91.32a.13.13,0,0,0-.11.13v3.19a.16.16,0,0,0,.15.14l2.83.31a.88.88,0,0,1,.68.6,10.13,10.13,0,0,0,.61,1.49.85.85,0,0,1,0,.88l-1.89,2.36a.75.75,0,0,0,.15.24l2,2a.46.46,0,0,0,.26.14l2.34-1.88A.59.59,0,0,1,317.74,76.59Zm4.64-2.18A5.63,5.63,0,1,1,328,68.79,5.62,5.62,0,0,1,322.38,74.41Zm0-10.76a5.14,5.14,0,1,0,5.14,5.14A5.14,5.14,0,0,0,322.38,63.65Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "322.38px 68.81px",
              }}
              id="ellm0pwbq2ij"
              className="animable"
            />
          </g>
        </g>
        <path
          d="M444.78,322.42h-3.19a.64.64,0,0,1-.62-.58l-.31-2.83a.39.39,0,0,0-.26-.27,8.83,8.83,0,0,1-1.57-.65.48.48,0,0,0-.36-.06l-2.35,1.88a.7.7,0,0,1-.89-.18l-2.05-2.05a.7.7,0,0,1-.18-.89l1.89-2.36a.63.63,0,0,0-.07-.35,9,9,0,0,1-.65-1.57.39.39,0,0,0-.27-.26l-2.83-.31a.64.64,0,0,1-.58-.62v-3.19a.63.63,0,0,1,.54-.62l2.91-.32a.26.26,0,0,0,.2-.16,9,9,0,0,1,.76-1.81.54.54,0,0,0-.14-.36l-1.64-2.05a.68.68,0,0,1-.08-.89l2.34-2.35a.7.7,0,0,1,.9.09l2,1.64a.48.48,0,0,0,.36.13,9.87,9.87,0,0,1,1.81-.75.27.27,0,0,0,.16-.2l.32-2.91a.63.63,0,0,1,.62-.54h3.19a.64.64,0,0,1,.62.57l.32,2.84a.41.41,0,0,0,.25.27,8.92,8.92,0,0,1,1.57.64.5.5,0,0,0,.36.07l2.35-1.89a.69.69,0,0,1,.89.19l2.05,2a.72.72,0,0,1,.19.89L451.49,305a.5.5,0,0,0,.07.36,8.92,8.92,0,0,1,.64,1.57.43.43,0,0,0,.27.26l2.84.31a.64.64,0,0,1,.57.62v3.19a.62.62,0,0,1-.54.62l-2.91.32a.29.29,0,0,0-.2.15,9.3,9.3,0,0,1-.75,1.82.49.49,0,0,0,.13.36l1.64,2a.7.7,0,0,1,.09.9L451,319.87a.68.68,0,0,1-.89-.08l-2.05-1.64a.53.53,0,0,0-.36-.14,9.52,9.52,0,0,1-1.81.76.28.28,0,0,0-.16.2l-.32,2.91A.63.63,0,0,1,444.78,322.42Zm-6.24-4.89a1.07,1.07,0,0,1,.51.13,9.3,9.3,0,0,0,1.5.62.84.84,0,0,1,.59.68l.31,2.83a.17.17,0,0,0,.14.15h3.19a.15.15,0,0,0,.14-.11l.32-2.91a.76.76,0,0,1,.5-.62,8.55,8.55,0,0,0,1.72-.71.88.88,0,0,1,.9.18l2,1.64a.5.5,0,0,0,.27.11l2.32-2.33a.52.52,0,0,0-.12-.25l-1.64-2.05a.88.88,0,0,1-.18-.89,9.21,9.21,0,0,0,.72-1.72.75.75,0,0,1,.61-.51l2.91-.31a.15.15,0,0,0,.11-.14v-3.19a.16.16,0,0,0-.15-.14l-2.83-.31a.86.86,0,0,1-.68-.6,9.19,9.19,0,0,0-.62-1.49.87.87,0,0,1,0-.88l1.89-2.36a.86.86,0,0,0-.15-.24l-2.05-2.05a.44.44,0,0,0-.27-.14l-2.33,1.88a.87.87,0,0,1-.88,0,9.19,9.19,0,0,0-1.49-.62.85.85,0,0,1-.6-.68l-.31-2.83a.16.16,0,0,0-.14-.15h-3.19a.13.13,0,0,0-.13.11l-.32,2.91a.75.75,0,0,1-.51.61,9.21,9.21,0,0,0-1.72.72.86.86,0,0,1-.89-.18L436,300a.35.35,0,0,0-.27-.11l-2.32,2.33a.75.75,0,0,0,.12.25l1.64,2a.88.88,0,0,1,.18.9,8.55,8.55,0,0,0-.71,1.72.75.75,0,0,1-.62.5l-2.91.32a.13.13,0,0,0-.1.14v3.19a.16.16,0,0,0,.14.14l2.84.31a.84.84,0,0,1,.67.59,8.94,8.94,0,0,0,.62,1.5.87.87,0,0,1,0,.88l-1.89,2.35a.52.52,0,0,0,.15.24l2.05,2.05a.4.4,0,0,0,.26.14l2.33-1.88A.58.58,0,0,1,438.54,317.53Zm4.65-2.18a5.63,5.63,0,1,1,5.62-5.63A5.64,5.64,0,0,1,443.19,315.35Zm0-10.76a5.14,5.14,0,1,0,5.13,5.13A5.14,5.14,0,0,0,443.19,304.59Z"
          style={{
            fill: "#213E60",
            transformOrigin: "443.185px 309.725px",
          }}
          id="el27tsl980ulbi"
          className="animable"
        />
        <g id="elvec4avug0b">
          <g
            style={{
              opacity: 0.6,
              transformOrigin: "443.185px 309.725px",
            }}
            className="animable"
            id="el7kv9048c2bp"
          >
            <path
              d="M444.78,322.42h-3.19a.64.64,0,0,1-.62-.58l-.31-2.83a.39.39,0,0,0-.26-.27,8.83,8.83,0,0,1-1.57-.65.48.48,0,0,0-.36-.06l-2.35,1.88a.7.7,0,0,1-.89-.18l-2.05-2.05a.7.7,0,0,1-.18-.89l1.89-2.36a.63.63,0,0,0-.07-.35,9,9,0,0,1-.65-1.57.39.39,0,0,0-.27-.26l-2.83-.31a.64.64,0,0,1-.58-.62v-3.19a.63.63,0,0,1,.54-.62l2.91-.32a.26.26,0,0,0,.2-.16,9,9,0,0,1,.76-1.81.54.54,0,0,0-.14-.36l-1.64-2.05a.68.68,0,0,1-.08-.89l2.34-2.35a.7.7,0,0,1,.9.09l2,1.64a.48.48,0,0,0,.36.13,9.87,9.87,0,0,1,1.81-.75.27.27,0,0,0,.16-.2l.32-2.91a.63.63,0,0,1,.62-.54h3.19a.64.64,0,0,1,.62.57l.32,2.84a.41.41,0,0,0,.25.27,8.92,8.92,0,0,1,1.57.64.5.5,0,0,0,.36.07l2.35-1.89a.69.69,0,0,1,.89.19l2.05,2a.72.72,0,0,1,.19.89L451.49,305a.5.5,0,0,0,.07.36,8.92,8.92,0,0,1,.64,1.57.43.43,0,0,0,.27.26l2.84.31a.64.64,0,0,1,.57.62v3.19a.62.62,0,0,1-.54.62l-2.91.32a.29.29,0,0,0-.2.15,9.3,9.3,0,0,1-.75,1.82.49.49,0,0,0,.13.36l1.64,2a.7.7,0,0,1,.09.9L451,319.87a.68.68,0,0,1-.89-.08l-2.05-1.64a.53.53,0,0,0-.36-.14,9.52,9.52,0,0,1-1.81.76.28.28,0,0,0-.16.2l-.32,2.91A.63.63,0,0,1,444.78,322.42Zm-6.24-4.89a1.07,1.07,0,0,1,.51.13,9.3,9.3,0,0,0,1.5.62.84.84,0,0,1,.59.68l.31,2.83a.17.17,0,0,0,.14.15h3.19a.15.15,0,0,0,.14-.11l.32-2.91a.76.76,0,0,1,.5-.62,8.55,8.55,0,0,0,1.72-.71.88.88,0,0,1,.9.18l2,1.64a.5.5,0,0,0,.27.11l2.32-2.33a.52.52,0,0,0-.12-.25l-1.64-2.05a.88.88,0,0,1-.18-.89,9.21,9.21,0,0,0,.72-1.72.75.75,0,0,1,.61-.51l2.91-.31a.15.15,0,0,0,.11-.14v-3.19a.16.16,0,0,0-.15-.14l-2.83-.31a.86.86,0,0,1-.68-.6,9.19,9.19,0,0,0-.62-1.49.87.87,0,0,1,0-.88l1.89-2.36a.86.86,0,0,0-.15-.24l-2.05-2.05a.44.44,0,0,0-.27-.14l-2.33,1.88a.87.87,0,0,1-.88,0,9.19,9.19,0,0,0-1.49-.62.85.85,0,0,1-.6-.68l-.31-2.83a.16.16,0,0,0-.14-.15h-3.19a.13.13,0,0,0-.13.11l-.32,2.91a.75.75,0,0,1-.51.61,9.21,9.21,0,0,0-1.72.72.86.86,0,0,1-.89-.18L436,300a.35.35,0,0,0-.27-.11l-2.32,2.33a.75.75,0,0,0,.12.25l1.64,2a.88.88,0,0,1,.18.9,8.55,8.55,0,0,0-.71,1.72.75.75,0,0,1-.62.5l-2.91.32a.13.13,0,0,0-.1.14v3.19a.16.16,0,0,0,.14.14l2.84.31a.84.84,0,0,1,.67.59,8.94,8.94,0,0,0,.62,1.5.87.87,0,0,1,0,.88l-1.89,2.35a.52.52,0,0,0,.15.24l2.05,2.05a.4.4,0,0,0,.26.14l2.33-1.88A.58.58,0,0,1,438.54,317.53Zm4.65-2.18a5.63,5.63,0,1,1,5.62-5.63A5.64,5.64,0,0,1,443.19,315.35Zm0-10.76a5.14,5.14,0,1,0,5.13,5.13A5.14,5.14,0,0,0,443.19,304.59Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "443.185px 309.725px",
              }}
              id="el7kaflcdgl8q"
              className="animable"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="abhishek--gears-1--inject-2"
      className="animable animator-active"
      style={{
        transformOrigin: "251.407px 403.875px",
      }}
    >
      <g
        id="abhishek--Gear--inject-2"
        className="animable"
        style={{
          transformOrigin: "306.54px 403.875px",
        }}
      >
        <path
          d="M251.31,403.82h0l4.44,8.43h0a.91.91,0,0,0,.72.44l6.13.88a2.45,2.45,0,0,1-.88,1.06l-12.53,7.6a1.47,1.47,0,0,0-.54,1.92l3.78,7.23s0,0,0,0l4.41,8.39a1.48,1.48,0,0,0,1.89.66l13.39-5.95a2.31,2.31,0,0,1,1.34-.12l-2.79,5.55a.9.9,0,0,0-.05.85h0l4.45,8.45h0a.92.92,0,0,0,.79.41l12.66.53a3,3,0,0,0,2.2-1l7.48-9.72a4,4,0,0,1,2.18-1.31,68.31,68.31,0,0,0,8.61-2.18,2.08,2.08,0,0,1,2.15.64l4.62,5.85a1.73,1.73,0,0,0,2.07.44l14.3-7.48a1.71,1.71,0,0,0,.82-1.94l-2.17-7.14a2.11,2.11,0,0,1,.71-2.13,66.27,66.27,0,0,0,6.7-5.82,4.09,4.09,0,0,1,2.33-1.05l12.24-.58a2.94,2.94,0,0,0,2.1-1.22l6.8-10.7a.89.89,0,0,0,.1-.9h0l-4.44-8.43h0a.94.94,0,0,0-.73-.44l-6.12-.88a2.45,2.45,0,0,1,.88-1.06l12.53-7.6a1.47,1.47,0,0,0,.54-1.92l-5.32-10.13h0l-2.88-5.51a1.49,1.49,0,0,0-1.89-.66l-13.39,6a2.39,2.39,0,0,1-1.34.11l2.79-5.55a.92.92,0,0,0,.05-.86h0L338,358.51h0a.87.87,0,0,0-.8-.42l-12.66-.54a3,3,0,0,0-2.21,1l-7.47,9.72a4.12,4.12,0,0,1-2.18,1.32,65,65,0,0,0-8.61,2.18,2.12,2.12,0,0,1-2.15-.64l-4.63-5.86a1.72,1.72,0,0,0-2.06-.44L281,372.34a1.71,1.71,0,0,0-.82,1.94l2.16,7.14a2.1,2.1,0,0,1-.7,2.13,66.43,66.43,0,0,0-6.7,5.82,4.09,4.09,0,0,1-2.33,1.05l-12.24.58a3,3,0,0,0-2.11,1.22l-6.79,10.7A.91.91,0,0,0,251.31,403.82Zm74.41-3.26c-6.34,10-21.05,17.67-32.86,17.17-4.62-.19-8.11-1.62-10.27-3.87-.15-2.67.91-5.92,3.24-9.58,6.34-10,21.05-17.68,32.86-17.18,4.62.2,7.9,1.39,9.81,3.35C328.92,393.4,328.06,396.88,325.72,400.56Z"
          style={{
            fill: "#213E60",
            transformOrigin: "306.535px 403.85px",
          }}
          id="el6m5igwhxqp9"
          className="animable"
        />
        <g id="eld7600q6ck5">
          <path
            d="M251.31,403.82h0l4.44,8.43h0a.91.91,0,0,0,.72.44l6.13.88a2.45,2.45,0,0,1-.88,1.06l-12.53,7.6a1.47,1.47,0,0,0-.54,1.92l3.78,7.23s0,0,0,0l4.41,8.39a1.48,1.48,0,0,0,1.89.66l13.39-5.95a2.31,2.31,0,0,1,1.34-.12l-2.79,5.55a.9.9,0,0,0-.05.85h0l4.45,8.45h0a.92.92,0,0,0,.79.41l12.66.53a3,3,0,0,0,2.2-1l7.48-9.72a4,4,0,0,1,2.18-1.31,68.31,68.31,0,0,0,8.61-2.18,2.08,2.08,0,0,1,2.15.64l4.62,5.85a1.73,1.73,0,0,0,2.07.44l14.3-7.48a1.71,1.71,0,0,0,.82-1.94l-2.17-7.14a2.11,2.11,0,0,1,.71-2.13,66.27,66.27,0,0,0,6.7-5.82,4.09,4.09,0,0,1,2.33-1.05l12.24-.58a2.94,2.94,0,0,0,2.1-1.22l6.8-10.7a.89.89,0,0,0,.1-.9h0l-4.44-8.43h0a.94.94,0,0,0-.73-.44l-6.12-.88a2.45,2.45,0,0,1,.88-1.06l12.53-7.6a1.47,1.47,0,0,0,.54-1.92l-5.32-10.13h0l-2.88-5.51a1.49,1.49,0,0,0-1.89-.66l-13.39,6a2.39,2.39,0,0,1-1.34.11l2.79-5.55a.92.92,0,0,0,.05-.86h0L338,358.51h0a.87.87,0,0,0-.8-.42l-12.66-.54a3,3,0,0,0-2.21,1l-7.47,9.72a4.12,4.12,0,0,1-2.18,1.32,65,65,0,0,0-8.61,2.18,2.12,2.12,0,0,1-2.15-.64l-4.63-5.86a1.72,1.72,0,0,0-2.06-.44L281,372.34a1.71,1.71,0,0,0-.82,1.94l2.16,7.14a2.1,2.1,0,0,1-.7,2.13,66.43,66.43,0,0,0-6.7,5.82,4.09,4.09,0,0,1-2.33,1.05l-12.24.58a3,3,0,0,0-2.11,1.22l-6.79,10.7A.91.91,0,0,0,251.31,403.82Zm74.41-3.26c-6.34,10-21.05,17.67-32.86,17.17-4.62-.19-8.11-1.62-10.27-3.87-.15-2.67.91-5.92,3.24-9.58,6.34-10,21.05-17.68,32.86-17.18,4.62.2,7.9,1.39,9.81,3.35C328.92,393.4,328.06,396.88,325.72,400.56Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.2,
              transformOrigin: "306.535px 403.85px",
            }}
            className="animable"
            id="elzhz6lomfkdl"
          />
        </g>
        <g id="elmfxydn07d5r">
          <path
            d="M345,392a1.16,1.16,0,0,0,1,1.51l4.46.64a2.42,2.42,0,0,1,.9-1.06l12.53-7.6a1.48,1.48,0,0,0,.54-1.93l-5.32-10.12.89,1.71a1.48,1.48,0,0,1-.53,1.92l-12.54,7.59a2.74,2.74,0,0,0-1.14,2.09A22.19,22.19,0,0,1,345,392Zm-7-33.41a1.08,1.08,0,0,1-.09.77l-4.81,9.57a1.15,1.15,0,0,0,.68,1.66A22,22,0,0,1,338.6,373a2.71,2.71,0,0,0,1,.37l2.79-5.56a.9.9,0,0,0,.05-.85h0Z"
            style={{
              opacity: 0.1,
              transformOrigin: "348.774px 376.37px",
            }}
            className="animable"
            id="elav8g6kpl7tl"
          />
        </g>
        <g id="elwkjwzf58mx">
          <path
            d="M282.94,398.76c6.34-10,21.05-17.68,32.86-17.18,7.47.31,12,3.82,12.71,8.88-1.9-2-5.19-3.16-9.82-3.36-11.82-.5-26.52,7.2-32.86,17.18-2.32,3.65-3.4,6.9-3.25,9.58C279.21,410.36,279.09,404.83,282.94,398.76Z"
            style={{
              opacity: 0.1,
              transformOrigin: "304.281px 397.708px",
            }}
            className="animable"
            id="elxcj1x3uqud"
          />
        </g>
        <path
          d="M256.86,439.81a1.46,1.46,0,0,0,1.88.64l13.4-5.94a1.9,1.9,0,0,1,.73-.15l-4.43-8.44a1.83,1.83,0,0,0-.74.17l-13.39,6a1.48,1.48,0,0,1-1.78-.5Zm-1.11-27.55h0a1,1,0,0,0,.73.45l6.13.87a2.77,2.77,0,0,0,.25-1,21.52,21.52,0,0,1,.71-5,1,1,0,0,1,.05-.24,1.48,1.48,0,0,0,0-.59c0-.06,0-.12,0-.18a1.26,1.26,0,0,0-.18-.32,1.16,1.16,0,0,0-.5-.35.71.71,0,0,0-.27-.07L252,404.27a1,1,0,0,1-.25-.06.56.56,0,0,1-.29-.17.5.5,0,0,1-.18-.23h0Zm19.33,37a.87.87,0,0,0,.79.4l12.66.54a2.9,2.9,0,0,0,1.64-.53l-4.42-8.42a2.88,2.88,0,0,1-1.64.53l-12.67-.53a1,1,0,0,1-.77-.36Zm64.36-31.65a3.52,3.52,0,0,1,1.08-.28l12.25-.58a2.89,2.89,0,0,0,1-.29l-4.42-8.4a2.45,2.45,0,0,1-1,.27l-12.24.58a3.49,3.49,0,0,0-1.1.28ZM316.21,442.8a1.74,1.74,0,0,0,1.63.07l14.3-7.47a1.64,1.64,0,0,0,.7-.77l-4.42-8.43a1.63,1.63,0,0,1-.71.78l-14.31,7.47a1.69,1.69,0,0,1-1.53,0Z"
          style={{
            fill: "#213E60",
            transformOrigin: "302.525px 427.005px",
          }}
          id="el5qrip2t1yn6"
          className="animable"
        />
        <g id="el28qx6jtb9hi">
          <path
            d="M256.86,439.81a1.46,1.46,0,0,0,1.88.64l13.4-5.94a1.9,1.9,0,0,1,.73-.15l-4.43-8.44a1.83,1.83,0,0,0-.74.17l-13.39,6a1.48,1.48,0,0,1-1.78-.5Zm-1.11-27.55h0a1,1,0,0,0,.73.45l6.13.87a2.77,2.77,0,0,0,.25-1,21.52,21.52,0,0,1,.71-5,1,1,0,0,1,.05-.24,1.48,1.48,0,0,0,0-.59c0-.06,0-.12,0-.18a1.26,1.26,0,0,0-.18-.32,1.16,1.16,0,0,0-.5-.35.71.71,0,0,0-.27-.07L252,404.27a1,1,0,0,1-.25-.06.56.56,0,0,1-.29-.17.5.5,0,0,1-.18-.23h0Zm19.33,37a.87.87,0,0,0,.79.4l12.66.54a2.9,2.9,0,0,0,1.64-.53l-4.42-8.42a2.88,2.88,0,0,1-1.64.53l-12.67-.53a1,1,0,0,1-.77-.36Zm64.36-31.65a3.52,3.52,0,0,1,1.08-.28l12.25-.58a2.89,2.89,0,0,0,1-.29l-4.42-8.4a2.45,2.45,0,0,1-1,.27l-12.24.58a3.49,3.49,0,0,0-1.1.28ZM316.21,442.8a1.74,1.74,0,0,0,1.63.07l14.3-7.47a1.64,1.64,0,0,0,.7-.77l-4.42-8.43a1.63,1.63,0,0,1-.71.78l-14.31,7.47a1.69,1.69,0,0,1-1.53,0Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.7,
              transformOrigin: "302.525px 427.005px",
            }}
            className="animable"
            id="el6e14jxbgyz3"
          />
        </g>
        <path
          d="M258.21,392.22l-6.79,10.7a.82.82,0,0,0,.62,1.35l10.61,1.52a1.16,1.16,0,0,1,1,1.51,22.2,22.2,0,0,0-.76,5.26,2.67,2.67,0,0,1-1.14,2.07l-12.53,7.6a1.47,1.47,0,0,0-.54,1.92l3.78,7.23a1.48,1.48,0,0,0,1.89.66l13.39-6a2.7,2.7,0,0,1,2.36.24,21.44,21.44,0,0,0,4.74,2.38,1.16,1.16,0,0,1,.69,1.66l-4.81,9.57a.82.82,0,0,0,.75,1.29l12.66.53a3,3,0,0,0,2.2-1l7.48-9.72A4,4,0,0,1,296,429.7a68.31,68.31,0,0,0,8.61-2.18,2.08,2.08,0,0,1,2.15.64l4.63,5.85a1.72,1.72,0,0,0,2.06.44l14.3-7.48a1.71,1.71,0,0,0,.82-1.94l-2.16-7.14a2.1,2.1,0,0,1,.7-2.13,65.19,65.19,0,0,0,6.7-5.82,4.09,4.09,0,0,1,2.33-1.05l12.24-.58a2.94,2.94,0,0,0,2.1-1.22l6.8-10.7a.82.82,0,0,0-.63-1.35L346,393.52a1.16,1.16,0,0,1-1-1.51,22.12,22.12,0,0,0,.76-5.25,2.68,2.68,0,0,1,1.14-2.08l12.53-7.6a1.47,1.47,0,0,0,.54-1.92l-3.78-7.23a1.49,1.49,0,0,0-1.89-.66l-13.39,6a2.73,2.73,0,0,1-2.36-.25,21.44,21.44,0,0,0-4.74-2.38,1.16,1.16,0,0,1-.69-1.66l4.81-9.57a.81.81,0,0,0-.75-1.28l-12.66-.54a3,3,0,0,0-2.21,1l-7.47,9.72a4.12,4.12,0,0,1-2.18,1.32,65,65,0,0,0-8.61,2.18,2.12,2.12,0,0,1-2.15-.64l-4.63-5.86a1.72,1.72,0,0,0-2.06-.44L281,372.34a1.71,1.71,0,0,0-.82,1.94l2.16,7.14a2.1,2.1,0,0,1-.7,2.13,66.43,66.43,0,0,0-6.7,5.82,4.09,4.09,0,0,1-2.33,1.05l-12.24.58A3,3,0,0,0,258.21,392.22Zm57.59-10.64c11.82.5,16.26,9,9.92,19s-21.05,17.67-32.86,17.17-16.26-9-9.92-19S304,381.08,315.8,381.58Z"
          style={{
            fill: "#213E60",
            transformOrigin: "304.325px 399.65px",
          }}
          id="elax9diu1hhd"
          className="animable"
        />
        <g id="elqq5m7hgb6i8">
          <path
            d="M258.21,392.22l-6.79,10.7a.82.82,0,0,0,.62,1.35l10.61,1.52a1.16,1.16,0,0,1,1,1.51,22.2,22.2,0,0,0-.76,5.26,2.67,2.67,0,0,1-1.14,2.07l-12.53,7.6a1.47,1.47,0,0,0-.54,1.92l3.78,7.23a1.48,1.48,0,0,0,1.89.66l13.39-6a2.7,2.7,0,0,1,2.36.24,21.44,21.44,0,0,0,4.74,2.38,1.16,1.16,0,0,1,.69,1.66l-4.81,9.57a.82.82,0,0,0,.75,1.29l12.66.53a3,3,0,0,0,2.2-1l7.48-9.72A4,4,0,0,1,296,429.7a68.31,68.31,0,0,0,8.61-2.18,2.08,2.08,0,0,1,2.15.64l4.63,5.85a1.72,1.72,0,0,0,2.06.44l14.3-7.48a1.71,1.71,0,0,0,.82-1.94l-2.16-7.14a2.1,2.1,0,0,1,.7-2.13,65.19,65.19,0,0,0,6.7-5.82,4.09,4.09,0,0,1,2.33-1.05l12.24-.58a2.94,2.94,0,0,0,2.1-1.22l6.8-10.7a.82.82,0,0,0-.63-1.35L346,393.52a1.16,1.16,0,0,1-1-1.51,22.12,22.12,0,0,0,.76-5.25,2.68,2.68,0,0,1,1.14-2.08l12.53-7.6a1.47,1.47,0,0,0,.54-1.92l-3.78-7.23a1.49,1.49,0,0,0-1.89-.66l-13.39,6a2.73,2.73,0,0,1-2.36-.25,21.44,21.44,0,0,0-4.74-2.38,1.16,1.16,0,0,1-.69-1.66l4.81-9.57a.81.81,0,0,0-.75-1.28l-12.66-.54a3,3,0,0,0-2.21,1l-7.47,9.72a4.12,4.12,0,0,1-2.18,1.32,65,65,0,0,0-8.61,2.18,2.12,2.12,0,0,1-2.15-.64l-4.63-5.86a1.72,1.72,0,0,0-2.06-.44L281,372.34a1.71,1.71,0,0,0-.82,1.94l2.16,7.14a2.1,2.1,0,0,1-.7,2.13,66.43,66.43,0,0,0-6.7,5.82,4.09,4.09,0,0,1-2.33,1.05l-12.24.58A3,3,0,0,0,258.21,392.22Zm57.59-10.64c11.82.5,16.26,9,9.92,19s-21.05,17.67-32.86,17.17-16.26-9-9.92-19S304,381.08,315.8,381.58Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.55,
              transformOrigin: "304.325px 399.65px",
            }}
            className="animable"
            id="el5zszmree78p"
          />
        </g>
        <g id="elh0cz0hbnew">
          <g
            style={{
              opacity: 0.55,
              transformOrigin: "304.335px 399.69px",
            }}
            className="animable"
            id="elbyg1gj5t43u"
          >
            <path
              d="M253.43,431.14a.55.55,0,0,1-.18-.19l-3.78-7.23a.56.56,0,0,1,.2-.7l12.53-7.59a3.57,3.57,0,0,0,1.59-2.86,21,21,0,0,1,.73-5,2.11,2.11,0,0,0-.87-2.36,2.32,2.32,0,0,0-.87-.31l-10.53-1.51L259,392.72a2.06,2.06,0,0,1,1.36-.79l12.25-.58a5,5,0,0,0,2.94-1.32,64.38,64.38,0,0,1,6.61-5.74,3,3,0,0,0,1-3.14L281,374a.8.8,0,0,1,.36-.85l14.3-7.47a.78.78,0,0,1,.75.06.49.49,0,0,1,.15.13l4.63,5.85a2.54,2.54,0,0,0,.67.59,3,3,0,0,0,2.5.36,64.69,64.69,0,0,1,8.48-2.15,5,5,0,0,0,2.76-1.66l7.47-9.72a2.06,2.06,0,0,1,1.43-.67l12.59.53-4.78,9.51a2.08,2.08,0,0,0,.74,2.73,2.15,2.15,0,0,0,.46.22,21.22,21.22,0,0,1,4.14,2l.41.26.06,0a3.65,3.65,0,0,0,3.19.29l13.39-6a.55.55,0,0,1,.51.05.65.65,0,0,1,.18.19l3.78,7.23a.55.55,0,0,1-.2.7l-12.53,7.59a3.57,3.57,0,0,0-1.59,2.86,21,21,0,0,1-.73,5,2.09,2.09,0,0,0,.87,2.36,2.16,2.16,0,0,0,.87.31L356.41,396l-6.75,10.64a2.06,2.06,0,0,1-1.36.79l-12.25.58a5.08,5.08,0,0,0-2.94,1.32A64.38,64.38,0,0,1,326.5,415a3,3,0,0,0-1,3.14l2.16,7.14a.8.8,0,0,1-.36.85L313,433.62a.78.78,0,0,1-.75-.06.38.38,0,0,1-.15-.13l-4.63-5.85a2.54,2.54,0,0,0-.67-.59,3,3,0,0,0-2.5-.36,64.69,64.69,0,0,1-8.48,2.15,5,5,0,0,0-2.76,1.66l-7.47,9.72a2.06,2.06,0,0,1-1.43.67l-12.59-.53,4.78-9.51a2.08,2.08,0,0,0-.75-2.73,2.35,2.35,0,0,0-.45-.22,21.78,21.78,0,0,1-4.14-2l-.41-.27-.06,0a3.61,3.61,0,0,0-3.19-.28l-13.39,5.95a.55.55,0,0,1-.51-.05h0m71.22-48a17.59,17.59,0,0,0-8.81-2.45c-12.09-.51-27.2,7.39-33.69,17.61-2.28,3.6-3.31,7.18-3,10.37a10.05,10.05,0,0,0,4.82,7.59,17.69,17.69,0,0,0,8.81,2.44c12.09.51,27.2-7.39,33.69-17.61,4.61-7.26,3.88-14.31-1.86-17.95m-71.72,48.83a1.52,1.52,0,0,0,1.39.11l13.39-6a2.69,2.69,0,0,1,2.31.22l.05,0,.42.28a22.21,22.21,0,0,0,4.32,2.1,1.47,1.47,0,0,1,.28.14,1.14,1.14,0,0,1,.41,1.52l-4.81,9.57a.82.82,0,0,0,.2,1.13,1.12,1.12,0,0,0,.55.16l12.66.53a3,3,0,0,0,2.2-1l7.48-9.72A4,4,0,0,1,296,429.7a68.31,68.31,0,0,0,8.61-2.18,2.08,2.08,0,0,1,1.71.25,1.84,1.84,0,0,1,.44.39l4.63,5.85a1.38,1.38,0,0,0,.38.34,1.73,1.73,0,0,0,1.68.1l14.3-7.48a1.71,1.71,0,0,0,.82-1.94l-2.16-7.14a2.1,2.1,0,0,1,.7-2.13,65.19,65.19,0,0,0,6.7-5.82,4.09,4.09,0,0,1,2.33-1.05l12.24-.58a2.94,2.94,0,0,0,2.1-1.22l6.8-10.7a.81.81,0,0,0-.16-1.19,1.09,1.09,0,0,0-.47-.16L346,393.52a1.29,1.29,0,0,1-.5-.18A1.17,1.17,0,0,1,345,392a22.12,22.12,0,0,0,.76-5.25,2.68,2.68,0,0,1,1.14-2.08l12.53-7.6a1.47,1.47,0,0,0,.54-1.92l-3.78-7.23a1.45,1.45,0,0,0-.5-.54,1.49,1.49,0,0,0-1.39-.12l-13.39,6a2.72,2.72,0,0,1-2.32-.23l0,0c-.13-.1-.28-.19-.42-.28a22.21,22.21,0,0,0-4.32-2.1l-.28-.13a1.16,1.16,0,0,1-.41-1.53l4.81-9.57a.82.82,0,0,0-.2-1.13,1,1,0,0,0-.55-.15l-12.66-.54a3,3,0,0,0-2.21,1l-7.47,9.72a4.12,4.12,0,0,1-2.18,1.32,65,65,0,0,0-8.61,2.18,2.15,2.15,0,0,1-1.72-.26,2.25,2.25,0,0,1-.43-.38l-4.63-5.86a1.38,1.38,0,0,0-.38-.34,1.73,1.73,0,0,0-1.68-.1L281,372.34a1.71,1.71,0,0,0-.82,1.94l2.16,7.14a2.1,2.1,0,0,1-.7,2.13,66.43,66.43,0,0,0-6.7,5.82,4.09,4.09,0,0,1-2.33,1.05l-12.24.58a3,3,0,0,0-2.11,1.22l-6.79,10.7a.81.81,0,0,0,.16,1.19,1.09,1.09,0,0,0,.46.16l10.61,1.52a1.29,1.29,0,0,1,.5.18,1.17,1.17,0,0,1,.47,1.33,22.2,22.2,0,0,0-.76,5.26,2.67,2.67,0,0,1-1.14,2.07l-12.53,7.6a1.47,1.47,0,0,0-.54,1.92l3.78,7.23a1.56,1.56,0,0,0,.5.55Zm71.22-48.05c5.14,3.26,6.07,9.59,1.57,16.68-6.34,10-21.05,17.67-32.86,17.17a16.7,16.7,0,0,1-8.35-2.3c-5.14-3.26-6.07-9.59-1.57-16.67,6.34-10,21.05-17.68,32.86-17.18a16.91,16.91,0,0,1,8.35,2.3Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "304.335px 399.69px",
              }}
              id="elw61g60jrhhn"
              className="animable"
            />
          </g>
        </g>
      </g>
      <g
        id="abhishek--gear--inject-2"
        className="animable"
        style={{
          transformOrigin: "181.143px 403.871px",
        }}
      >
        <path
          d="M166.92,381.58a5.27,5.27,0,0,1-3.15-.52l-6.77-4a3.5,3.5,0,0,0-3-.1l-5.72,2.86a1.2,1.2,0,0,0-.68.79h0l-1.79,7.7h0a1.07,1.07,0,0,0,.45,1.11l2.28,1.9-6.9-.41a1.42,1.42,0,0,0-1.53,1.15l0,0-1.8,7.7h0a1.87,1.87,0,0,0,0,.48l.33,4.45a2.35,2.35,0,0,0,1.81,2l8.65,1.66a4.06,4.06,0,0,1,1.91,1.12l-.54.36a1.34,1.34,0,0,0-.57.75h0L148,418.32h0a1.14,1.14,0,0,0,.54,1.19l6.8,4.75a3.63,3.63,0,0,0,3,.39l5.83-2.17a4.92,4.92,0,0,1,3.17.1c1.53.65,3.11,1.23,4.71,1.74a3.34,3.34,0,0,1,2.06,2.15l1,4.07a2.69,2.69,0,0,0,2.11,1.88l9.6,1.21a1.67,1.67,0,0,0,1.84-1.26h0l1.22-5.23a2.09,2.09,0,0,1,1.12-.45,38.85,38.85,0,0,0,4.25-.53,5.36,5.36,0,0,1,3.15.53l6.76,4a3.49,3.49,0,0,0,3,.1l5.71-2.86a1.18,1.18,0,0,0,.67-.75h0l1.81-7.75h0a1.13,1.13,0,0,0-.46-1.1l-2.28-1.9,6.91.42a1.45,1.45,0,0,0,1.52-1.07h0L224,408h0a1.46,1.46,0,0,0,.06-.52l-.33-4.45a2.37,2.37,0,0,0-1.8-2l-8.66-1.66a4,4,0,0,1-1.91-1.12l.54-.36a1.24,1.24,0,0,0,.57-.76h0l1.78-7.66h0l0-.09h0a1.12,1.12,0,0,0-.55-1.14l-6.8-4.76a3.66,3.66,0,0,0-3-.38L198,385.27a4.86,4.86,0,0,1-3.17-.11c-1.53-.65-3.11-1.23-4.71-1.73a3.41,3.41,0,0,1-2.06-2.15l-1-4.08a2.68,2.68,0,0,0-2.12-1.87l-9.6-1.22a1.69,1.69,0,0,0-1.89,1.49l-.4,3.66a2.1,2.1,0,0,1-1.9,1.79A38.36,38.36,0,0,0,166.92,381.58Zm28.45,27.76c-6.74,3.38-18.18,1.93-25.55-3.22A14.26,14.26,0,0,1,164.5,400a11.16,11.16,0,0,1,2.38-1.57c6.73-3.38,18.17-1.93,25.54,3.22a14.35,14.35,0,0,1,5.32,6.14A10.89,10.89,0,0,1,195.37,409.34Z"
          style={{
            fill: "#213E60",
            transformOrigin: "181.179px 403.871px",
          }}
          id="elcp6vfyznkb"
          className="animable"
        />
        <g id="elddmxsrqs9ne">
          <path
            d="M166.92,381.58a5.27,5.27,0,0,1-3.15-.52l-6.77-4a3.5,3.5,0,0,0-3-.1l-5.72,2.86a1.2,1.2,0,0,0-.68.79h0l-1.79,7.7h0a1.07,1.07,0,0,0,.45,1.11l2.28,1.9-6.9-.41a1.42,1.42,0,0,0-1.53,1.15l0,0-1.8,7.7h0a1.87,1.87,0,0,0,0,.48l.33,4.45a2.35,2.35,0,0,0,1.81,2l8.65,1.66a4.06,4.06,0,0,1,1.91,1.12l-.54.36a1.34,1.34,0,0,0-.57.75h0L148,418.32h0a1.14,1.14,0,0,0,.54,1.19l6.8,4.75a3.63,3.63,0,0,0,3,.39l5.83-2.17a4.92,4.92,0,0,1,3.17.1c1.53.65,3.11,1.23,4.71,1.74a3.34,3.34,0,0,1,2.06,2.15l1,4.07a2.69,2.69,0,0,0,2.11,1.88l9.6,1.21a1.67,1.67,0,0,0,1.84-1.26h0l1.22-5.23a2.09,2.09,0,0,1,1.12-.45,38.85,38.85,0,0,0,4.25-.53,5.36,5.36,0,0,1,3.15.53l6.76,4a3.49,3.49,0,0,0,3,.1l5.71-2.86a1.18,1.18,0,0,0,.67-.75h0l1.81-7.75h0a1.13,1.13,0,0,0-.46-1.1l-2.28-1.9,6.91.42a1.45,1.45,0,0,0,1.52-1.07h0L224,408h0a1.46,1.46,0,0,0,.06-.52l-.33-4.45a2.37,2.37,0,0,0-1.8-2l-8.66-1.66a4,4,0,0,1-1.91-1.12l.54-.36a1.24,1.24,0,0,0,.57-.76h0l1.78-7.66h0l0-.09h0a1.12,1.12,0,0,0-.55-1.14l-6.8-4.76a3.66,3.66,0,0,0-3-.38L198,385.27a4.86,4.86,0,0,1-3.17-.11c-1.53-.65-3.11-1.23-4.71-1.73a3.41,3.41,0,0,1-2.06-2.15l-1-4.08a2.68,2.68,0,0,0-2.12-1.87l-9.6-1.22a1.69,1.69,0,0,0-1.89,1.49l-.4,3.66a2.1,2.1,0,0,1-1.9,1.79A38.36,38.36,0,0,0,166.92,381.58Zm28.45,27.76c-6.74,3.38-18.18,1.93-25.55-3.22A14.26,14.26,0,0,1,164.5,400a11.16,11.16,0,0,1,2.38-1.57c6.73-3.38,18.17-1.93,25.54,3.22a14.35,14.35,0,0,1,5.32,6.14A10.89,10.89,0,0,1,195.37,409.34Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.2,
              transformOrigin: "181.179px 403.871px",
            }}
            className="animable"
            id="eln37jz334zdf"
          />
        </g>
        <g id="elgkxs8zr6z49">
          <path
            d="M210.51,411.52a1.66,1.66,0,0,0,.16,2.37l3,2.53,6.91.42a1.45,1.45,0,0,0,1.52-1.07l1.78-7.64a1.44,1.44,0,0,1-1.5,1l-8.48-.52a2.93,2.93,0,0,0-2.44,1.44A10.83,10.83,0,0,1,210.51,411.52Zm3.69-22.1a1.23,1.23,0,0,1-.56.75L209.38,393a1.5,1.5,0,0,0-.3,2.25,18,18,0,0,1,1.63,2.31,3.62,3.62,0,0,0,.58.71l.55-.37a1.32,1.32,0,0,0,.56-.76h0Z"
            style={{
              opacity: 0.1,
              transformOrigin: "216.291px 403.132px",
            }}
            className="animable"
            id="elx5vn5bk3n8r"
          />
        </g>
        <g id="el6ou5n5xdm">
          <path
            d="M194.22,393.9c6.36,4.45,7.62,10.2,3.51,13.85a14.3,14.3,0,0,0-5.31-6.13c-7.37-5.16-18.8-6.61-25.55-3.23a10.63,10.63,0,0,0-2.36,1.57c-1.45-3.61-.09-7.16,4.16-9.29C175.42,387.29,186.85,388.74,194.22,393.9Z"
            style={{
              opacity: 0.1,
              transformOrigin: "182.027px 398.297px",
            }}
            className="animable"
            id="elc1v9th31xl5"
          />
        </g>
        <path
          d="M173.57,425.38a2.92,2.92,0,0,1,.59,1.07l1,4.08a2.62,2.62,0,0,0,1.11,1.48l1.8-7.72a2.7,2.7,0,0,1-1.11-1.48l-1-4.08a2.9,2.9,0,0,0-.57-1.08ZM148,418.32a1.09,1.09,0,0,0,.54,1.17l6.8,4.77a3.62,3.62,0,0,0,2,.53l1.8-7.72a3.48,3.48,0,0,1-1.95-.54l-6.79-4.75a1.13,1.13,0,0,1-.54-1.19h0Zm50.52,8.4,6.68,3.95a3.35,3.35,0,0,0,1.83.37l1.79-7.7A3.39,3.39,0,0,1,207,423L200.37,419Zm-60.27-27a1.13,1.13,0,0,0,0,.49l.32,4.44a2.36,2.36,0,0,0,1.81,2l8.65,1.66a3.55,3.55,0,0,1,1.27.59l1.8-7.73a3.52,3.52,0,0,0-1.27-.58L142.19,399a2.34,2.34,0,0,1-1.81-2l-.32-4.45a2.43,2.43,0,0,1,0-.47Zm7.5-11.44h0a1.13,1.13,0,0,0,.45,1.12l2.29,1.89,1.56.11a2.89,2.89,0,0,0,2.45-1.46,10.52,10.52,0,0,1,1-1.47,3.85,3.85,0,0,0,.23-.38l.11-.3a1.66,1.66,0,0,0,.05-.62,1.46,1.46,0,0,0-.26-.72,1,1,0,0,0-.3-.35l-5.31-4.43a2,2,0,0,1-.32-.35,1,1,0,0,1-.17-.46,1.31,1.31,0,0,1,0-.28Z"
          style={{
            fill: "#213E60",
            transformOrigin: "173.522px 406.295px",
          }}
          id="elnha4rov2wm"
          className="animable"
        />
        <g id="elbzpe0a5oa58">
          <path
            d="M173.57,425.38a2.92,2.92,0,0,1,.59,1.07l1,4.08a2.62,2.62,0,0,0,1.11,1.48l1.8-7.72a2.7,2.7,0,0,1-1.11-1.48l-1-4.08a2.9,2.9,0,0,0-.57-1.08ZM148,418.32a1.09,1.09,0,0,0,.54,1.17l6.8,4.77a3.62,3.62,0,0,0,2,.53l1.8-7.72a3.48,3.48,0,0,1-1.95-.54l-6.79-4.75a1.13,1.13,0,0,1-.54-1.19h0Zm50.52,8.4,6.68,3.95a3.35,3.35,0,0,0,1.83.37l1.79-7.7A3.39,3.39,0,0,1,207,423L200.37,419Zm-60.27-27a1.13,1.13,0,0,0,0,.49l.32,4.44a2.36,2.36,0,0,0,1.81,2l8.65,1.66a3.55,3.55,0,0,1,1.27.59l1.8-7.73a3.52,3.52,0,0,0-1.27-.58L142.19,399a2.34,2.34,0,0,1-1.81-2l-.32-4.45a2.43,2.43,0,0,1,0-.47Zm7.5-11.44h0a1.13,1.13,0,0,0,.45,1.12l2.29,1.89,1.56.11a2.89,2.89,0,0,0,2.45-1.46,10.52,10.52,0,0,1,1-1.47,3.85,3.85,0,0,0,.23-.38l.11-.3a1.66,1.66,0,0,0,.05-.62,1.46,1.46,0,0,0-.26-.72,1,1,0,0,0-.3-.35l-5.31-4.43a2,2,0,0,1-.32-.35,1,1,0,0,1-.17-.46,1.31,1.31,0,0,1,0-.28Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.7,
              transformOrigin: "173.522px 406.295px",
            }}
            className="animable"
            id="el3yk03rb5j8j"
          />
        </g>
        <path
          d="M154,377l-5.72,2.86a1,1,0,0,0-.22,1.87l5.31,4.43a1.67,1.67,0,0,1,.17,2.37,12.61,12.61,0,0,0-1,1.47,2.85,2.85,0,0,1-2.44,1.45l-8.47-.51a1.46,1.46,0,0,0-1.59,1.6l.33,4.45a2.36,2.36,0,0,0,1.81,2l8.65,1.66a4.31,4.31,0,0,1,2.5,1.83,23.16,23.16,0,0,0,1.62,2.31,1.47,1.47,0,0,1-.3,2.24l-4.25,2.82a1.09,1.09,0,0,0,0,1.93l6.8,4.76a3.64,3.64,0,0,0,3,.39l5.83-2.17a4.92,4.92,0,0,1,3.17.1,50.06,50.06,0,0,0,4.72,1.73,3.39,3.39,0,0,1,2.05,2.16l1,4.07a2.7,2.7,0,0,0,2.11,1.88l9.61,1.21a1.67,1.67,0,0,0,1.88-1.49l.41-3.66a2.09,2.09,0,0,1,1.89-1.79,38.24,38.24,0,0,0,4.25-.53,5.27,5.27,0,0,1,3.15.53l6.76,4a3.49,3.49,0,0,0,3,.1l5.72-2.86a1,1,0,0,0,.21-1.87l-5.31-4.42a1.7,1.7,0,0,1-.17-2.38,11.56,11.56,0,0,0,1-1.47,2.87,2.87,0,0,1,2.43-1.45l8.48.51a1.45,1.45,0,0,0,1.58-1.6l-.33-4.45a2.37,2.37,0,0,0-1.8-2l-8.66-1.66a4.29,4.29,0,0,1-2.49-1.83,21.75,21.75,0,0,0-1.63-2.31,1.48,1.48,0,0,1,.31-2.24l4.25-2.82a1.09,1.09,0,0,0,0-1.93l-6.8-4.76a3.66,3.66,0,0,0-3-.38L198,385.27a4.92,4.92,0,0,1-3.17-.11c-1.53-.65-3.11-1.23-4.71-1.73a3.41,3.41,0,0,1-2.06-2.15l-1-4.08a2.68,2.68,0,0,0-2.12-1.87l-9.6-1.22a1.69,1.69,0,0,0-1.89,1.49l-.4,3.66a2.1,2.1,0,0,1-1.9,1.79,38.36,38.36,0,0,0-4.24.53,5.27,5.27,0,0,1-3.15-.52l-6.77-4A3.5,3.5,0,0,0,154,377Zm40.22,16.93c7.37,5.16,7.88,12.08,1.15,15.45s-18.18,1.93-25.55-3.22-7.88-12.08-1.14-15.45S186.85,388.74,194.22,393.89Z"
          style={{
            fill: "#213E60",
            transformOrigin: "182.006px 400.011px",
          }}
          id="elyih1rigtkd"
          className="animable"
        />
        <g id="elw9oyqfwa8hs">
          <path
            d="M154,377l-5.72,2.86a1,1,0,0,0-.22,1.87l5.31,4.43a1.67,1.67,0,0,1,.17,2.37,12.61,12.61,0,0,0-1,1.47,2.85,2.85,0,0,1-2.44,1.45l-8.47-.51a1.46,1.46,0,0,0-1.59,1.6l.33,4.45a2.36,2.36,0,0,0,1.81,2l8.65,1.66a4.31,4.31,0,0,1,2.5,1.83,23.16,23.16,0,0,0,1.62,2.31,1.47,1.47,0,0,1-.3,2.24l-4.25,2.82a1.09,1.09,0,0,0,0,1.93l6.8,4.76a3.64,3.64,0,0,0,3,.39l5.83-2.17a4.92,4.92,0,0,1,3.17.1,50.06,50.06,0,0,0,4.72,1.73,3.39,3.39,0,0,1,2.05,2.16l1,4.07a2.7,2.7,0,0,0,2.11,1.88l9.61,1.21a1.67,1.67,0,0,0,1.88-1.49l.41-3.66a2.09,2.09,0,0,1,1.89-1.79,38.24,38.24,0,0,0,4.25-.53,5.27,5.27,0,0,1,3.15.53l6.76,4a3.49,3.49,0,0,0,3,.1l5.72-2.86a1,1,0,0,0,.21-1.87l-5.31-4.42a1.7,1.7,0,0,1-.17-2.38,11.56,11.56,0,0,0,1-1.47,2.87,2.87,0,0,1,2.43-1.45l8.48.51a1.45,1.45,0,0,0,1.58-1.6l-.33-4.45a2.37,2.37,0,0,0-1.8-2l-8.66-1.66a4.29,4.29,0,0,1-2.49-1.83,21.75,21.75,0,0,0-1.63-2.31,1.48,1.48,0,0,1,.31-2.24l4.25-2.82a1.09,1.09,0,0,0,0-1.93l-6.8-4.76a3.66,3.66,0,0,0-3-.38L198,385.27a4.92,4.92,0,0,1-3.17-.11c-1.53-.65-3.11-1.23-4.71-1.73a3.41,3.41,0,0,1-2.06-2.15l-1-4.08a2.68,2.68,0,0,0-2.12-1.87l-9.6-1.22a1.69,1.69,0,0,0-1.89,1.49l-.4,3.66a2.1,2.1,0,0,1-1.9,1.79,38.36,38.36,0,0,0-4.24.53,5.27,5.27,0,0,1-3.15-.52l-6.77-4A3.5,3.5,0,0,0,154,377Zm40.22,16.93c7.37,5.16,7.88,12.08,1.15,15.45s-18.18,1.93-25.55-3.22-7.88-12.08-1.14-15.45S186.85,388.74,194.22,393.89Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.55,
              transformOrigin: "182.006px 400.011px",
            }}
            className="animable"
            id="el46te49nig7"
          />
        </g>
        <g id="elyax4p284t0q">
          <g
            style={{
              opacity: 0.55,
              transformOrigin: "182.001px 400.041px",
            }}
            className="animable"
            id="elzc89nei26hf"
          >
            <path
              d="M141.46,397.07h0a.71.71,0,0,1,0-.2l-.33-4.44a.51.51,0,0,1,.11-.38.5.5,0,0,1,.37-.11l8.48.51a3.92,3.92,0,0,0,3.41-2,9.9,9.9,0,0,1,.9-1.35,2.8,2.8,0,0,0,.52-2.55,2.63,2.63,0,0,0-.84-1.26l-5.31-4.43-.08-.08.09-.05,5.72-2.87a2.51,2.51,0,0,1,2,.07l6.77,4a6.29,6.29,0,0,0,3.86.65,38.08,38.08,0,0,1,4.14-.51,3.14,3.14,0,0,0,2.85-2.71l.41-3.67a.61.61,0,0,1,.24-.43.63.63,0,0,1,.48-.14l9.6,1.22a1.7,1.7,0,0,1,1.24,1.09h0l1,4.08a.83.83,0,0,1,0,.15,4.45,4.45,0,0,0,2.72,2.74c1.58.5,3.13,1.07,4.62,1.7a5.93,5.93,0,0,0,3.94.12l5.82-2.17a2.67,2.67,0,0,1,2,.26l6.8,4.76c.08.05.11.09.13.1l-.13.11-4.25,2.83a2.47,2.47,0,0,0-1,2.82,2.94,2.94,0,0,0,.5.94,20.41,20.41,0,0,1,1.55,2.19,5.22,5.22,0,0,0,3.19,2.31l8.65,1.66a1.38,1.38,0,0,1,.93.89,1.77,1.77,0,0,1,0,.2l.33,4.45a.46.46,0,0,1-.12.37.47.47,0,0,1-.37.12l-8.48-.51a3.9,3.9,0,0,0-3.4,2,10,10,0,0,1-.91,1.35,2.82,2.82,0,0,0-.51,2.55,2.5,2.5,0,0,0,.84,1.26l5.31,4.43.08.08-.1.06-5.72,2.86a2.47,2.47,0,0,1-2-.07l-6.76-4a6.31,6.31,0,0,0-3.87-.65,37.58,37.58,0,0,1-4.13.51,3.16,3.16,0,0,0-2.86,2.72l-.4,3.66a.65.65,0,0,1-.24.44.69.69,0,0,1-.48.13l-9.61-1.22a1.68,1.68,0,0,1-1.23-1.09h0l-1-4.08a.83.83,0,0,0,0-.15,4.44,4.44,0,0,0-2.71-2.74c-1.58-.5-3.14-1.07-4.62-1.7a6,6,0,0,0-3.94-.12l-5.83,2.17a2.67,2.67,0,0,1-2.05-.26l-6.8-4.76-.12-.1a.56.56,0,0,1,.13-.11l4.25-2.82a2.49,2.49,0,0,0,1-2.83,2.76,2.76,0,0,0-.5-.94,18.15,18.15,0,0,1-1.54-2.19,5.28,5.28,0,0,0-3.19-2.31L142.39,398a1.34,1.34,0,0,1-.93-.89m59.32,3.33c-.8-2.65-2.86-5.19-6-7.36-7.64-5.34-19.57-6.83-26.61-3.3-4.31,2.16-6.16,5.85-4.94,9.87.8,2.65,2.86,5.19,6,7.36,7.64,5.34,19.57,6.83,26.6,3.3,4.32-2.16,6.17-5.85,4.95-9.87m-60.32-3a2.38,2.38,0,0,0,1.73,1.61l8.65,1.66a4.31,4.31,0,0,1,2.5,1.83,23.16,23.16,0,0,0,1.62,2.31,1.85,1.85,0,0,1,.32.58,1.46,1.46,0,0,1-.62,1.66l-4.25,2.82a1.12,1.12,0,0,0-.56,1.25,1.33,1.33,0,0,0,.54.68l6.8,4.76a3.64,3.64,0,0,0,3,.39l5.83-2.17a4.92,4.92,0,0,1,3.17.1,50.06,50.06,0,0,0,4.72,1.73,3.42,3.42,0,0,1,2,2.06.3.3,0,0,1,0,.1l1,4.07,0,.09a2.71,2.71,0,0,0,2.08,1.79l9.61,1.21a1.67,1.67,0,0,0,1.88-1.49l.41-3.66a2.09,2.09,0,0,1,1.89-1.79,38.24,38.24,0,0,0,4.25-.53,5.27,5.27,0,0,1,3.15.53l6.76,4a3.49,3.49,0,0,0,3,.1l5.72-2.86a1.05,1.05,0,0,0,.66-1.24,1.35,1.35,0,0,0-.45-.63l-5.31-4.42a1.68,1.68,0,0,1-.51-.77,1.79,1.79,0,0,1,.34-1.61,11.56,11.56,0,0,0,1-1.47,2.87,2.87,0,0,1,2.43-1.45l8.48.51a1.45,1.45,0,0,0,1.58-1.6l-.33-4.45a2,2,0,0,0-.07-.42,2.38,2.38,0,0,0-1.73-1.61l-8.66-1.66a4.29,4.29,0,0,1-2.49-1.83,21.75,21.75,0,0,0-1.63-2.31,1.82,1.82,0,0,1-.31-.58,1.44,1.44,0,0,1,.62-1.66l4.25-2.82a1.1,1.1,0,0,0,.55-1.25,1.26,1.26,0,0,0-.53-.68l-6.8-4.76a3.66,3.66,0,0,0-3-.38L198,385.27a4.86,4.86,0,0,1-3.17-.11c-1.53-.65-3.11-1.23-4.71-1.73a3.42,3.42,0,0,1-2-2.06l0-.09-1-4.08,0-.09a2.7,2.7,0,0,0-2.09-1.78l-9.6-1.22a1.69,1.69,0,0,0-1.89,1.49l-.4,3.66a2.09,2.09,0,0,1-1.9,1.79,38.36,38.36,0,0,0-4.24.53,5.27,5.27,0,0,1-3.15-.52l-6.77-4a3.5,3.5,0,0,0-3-.1l-5.72,2.87a1,1,0,0,0-.66,1.23,1.33,1.33,0,0,0,.44.63l5.31,4.43a1.56,1.56,0,0,1,.52.76,1.82,1.82,0,0,1-.35,1.61,12.61,12.61,0,0,0-1,1.47,2.85,2.85,0,0,1-2.44,1.45l-8.47-.51a1.46,1.46,0,0,0-1.59,1.6l.33,4.45a2.07,2.07,0,0,0,.08.42Zm59.32,3.33c1,3.39-.41,6.64-4.41,8.64-6.74,3.38-18.18,1.93-25.55-3.22-3-2.1-4.85-4.49-5.56-6.81-1-3.39.42-6.64,4.42-8.64,6.74-3.38,18.17-1.93,25.54,3.22,3,2.1,4.86,4.49,5.56,6.81Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "182.001px 400.041px",
              }}
              id="el9hgyszsorb"
              className="animable"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="abhishek--Character--inject-2"
      className="animable"
      style={{
        transformOrigin: "390.389px 232.171px",
      }}
    >
      <g
        id="abhishek--character--inject-2"
        className="animable"
        style={{
          transformOrigin: "390.389px 232.171px",
        }}
      >
        <path
          d="M367.93,281.26c1.17,2.56,3.64,1.43,4.87,4.16a8,8,0,0,1,.24,6,10.56,10.56,0,0,0-.86,3.05c0,1.29,0,2.59,0,3.89a45,45,0,0,0,.51,6.14c.66,5-1.89,10-5.22,13.59-1.75,1.89-3.11,1.82-5.42,2.92-1.58.76-3.93,1.32-5.38.12s-1.71-3.33-1.62-5.1c.12-2.17.83-2.73,1.45-4.78a26.4,26.4,0,0,0,.89-7,28.58,28.58,0,0,0-.58-5.48c-.59-3.21-.44-5.83-2.28-10.37-1.16-2.89-5.53-13.67-5.53-13.67l16-8.58Z"
          style={{
            fill: "rgb(255, 168, 167)",
            transformOrigin: "361.255px 293.988px",
          }}
          id="elab23kxugf5h"
          className="animable"
        />
        <path
          d="M373.71,285.46a5.15,5.15,0,0,1,2.29,2.72,16.45,16.45,0,0,1-1.61,6.2c-1.24,2.73-1.69,3.85-1.16,6.05a19.72,19.72,0,0,1,.71,8.84,16.14,16.14,0,0,1-7.27,11.42c-4.92,3.33-7.16,3.14-8.7,2.75a9,9,0,0,1-3.29-2.26Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "365.34px 304.554px",
          }}
          id="elzn5qmgfbpg"
          className="animable"
        />
        <path
          d="M367.73,280.2l.2,1.06a11.09,11.09,0,0,1-.55,3.48c-.88,3-3.48,4.95-4.49,5.95a3.13,3.13,0,0,0-2.39-1.06c-2-.14-5.59-.08-6,.8s2,7.55,2.12,12.37-.9,6.64-2.46,10.19c-1.11,2.54-2.17,7.39,1.62,8.76,2,.73,8.25.61,13.76-6.16,4.89-6,3-12.15,2.15-15.56s.31-5.35,1.63-9.39c.57-1.76,1.14-3.07.41-5.18-1.45-2.17-2.68-2.29-4-3.62C368.69,280.75,368.57,279.86,367.73,280.2Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "363.601px 301.088px",
          }}
          id="elbdriqr271i"
          className="animable"
        />
        <path
          d="M362.89,290.69a1.77,1.77,0,0,0-.68,1,3.53,3.53,0,0,0,.06,1.22c.15.78.27,1.53.38,2.31.26,1.53.49,3.07.66,4.61a42.31,42.31,0,0,1,.26,4.64,21.47,21.47,0,0,1-.5,4.64,14.59,14.59,0,0,0,1.05-4.62,26,26,0,0,0-.08-4.75,42.55,42.55,0,0,0-.78-4.65c-.18-.76-.39-1.53-.61-2.27a4.47,4.47,0,0,1-.22-1.1A1.88,1.88,0,0,1,362.89,290.69Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "363.188px 299.9px",
          }}
          id="el5vpqdfax7f2"
          className="animable"
        />
        <path
          d="M364.1,308c-1.81-.91-6.88-1.51-8.07,0l-.14.54a2.52,2.52,0,0,1,.19-1.67c.42-1,4-1.81,8.18-.08C364.68,307.26,364.66,308.2,364.1,308Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "360.188px 307.16px",
          }}
          id="elpwq7cg1ui9"
          className="animable"
        />
        <path
          d="M364.25,304c-1.75-1-6.39-1.69-7.66-.23l0,.45a1.48,1.48,0,0,1,0-1.53c.48-.95,3.79-1.85,7.88.13C364.87,303.26,364.79,304.2,364.25,304Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "360.549px 302.929px",
          }}
          id="elq2t546nbst"
          className="animable"
        />
        <path
          d="M364,299.84c-1.82-.86-6.55-1.36-7.68.23l.07.54a1.88,1.88,0,0,1-.26-1.47c.32-1.05,3.8-2.1,8-.5C364.6,299.1,364.59,300,364,299.84Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "360.272px 299.214px",
          }}
          id="el6znx3bdrm6v"
          className="animable"
        />
        <path
          d="M363.68,296.33c-1.81-.85-6.84-1.43-8,.16l.09.54a2.11,2.11,0,0,1-.27-1.55c.33-1.05,4.09-1.94,8.29-.35C364.24,295.59,364.24,296.54,363.68,296.33Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "359.784px 295.647px",
          }}
          id="eldlwt6ngpd9c"
          className="animable"
        />
        <path
          d="M387.64,211.6c-21.84,5.08-29.52,6.74-41.72,12.46-6.08,2.85-7.91,5.58-9.65,9.94-1.07,2.7-.92,9.77,2.26,17.29,6,14.25,7.85,18.3,12.23,28.06,0,0,11.84.3,15.54-7.4l-3.56-22.45,53.17-11.61,2.42-28.43Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "377.001px 244.406px",
          }}
          id="elmhp44ao6on"
          className="animable"
        />
        <path
          d="M387.64,211.6l-12.88,3.27c-4.29,1.08-8.58,2.17-12.8,3.47a113.11,113.11,0,0,0-12.41,4.58,58.9,58.9,0,0,0-5.92,2.88,14.5,14.5,0,0,0-4.77,4.23,18,18,0,0,0-1.57,2.82c-.22.49-.45,1-.62,1.5a7.19,7.19,0,0,0-.36,1.52,23.12,23.12,0,0,0,.15,6.48,35.77,35.77,0,0,0,1.55,6.36c.71,2.06,1.64,4.08,2.49,6.13l5.18,12.23,5.08,12.28-5.53-12.08-5.44-12.13c-.89-2-1.86-4-2.6-6.15a36.27,36.27,0,0,1-1.63-6.51,24.2,24.2,0,0,1-.2-6.75,8.79,8.79,0,0,1,.39-1.71c.2-.56.42-1.05.64-1.57a17.83,17.83,0,0,1,1.65-3,15.55,15.55,0,0,1,5.1-4.49,60.78,60.78,0,0,1,6.05-2.89,97.51,97.51,0,0,1,12.55-4.47C370.29,215.2,379,213.44,387.64,211.6Z"
          style={{
            fill: "#213E60",
            transformOrigin: "361.426px 245.475px",
          }}
          id="ely01wuf09lgg"
          className="animable"
        />
        <g id="elch5sldouzvn">
          <path
            d="M387.64,211.6l-12.88,3.27c-4.29,1.08-8.58,2.17-12.8,3.47a113.11,113.11,0,0,0-12.41,4.58,58.9,58.9,0,0,0-5.92,2.88,14.5,14.5,0,0,0-4.77,4.23,18,18,0,0,0-1.57,2.82c-.22.49-.45,1-.62,1.5a7.19,7.19,0,0,0-.36,1.52,23.12,23.12,0,0,0,.15,6.48,35.77,35.77,0,0,0,1.55,6.36c.71,2.06,1.64,4.08,2.49,6.13l5.18,12.23,5.08,12.28-5.53-12.08-5.44-12.13c-.89-2-1.86-4-2.6-6.15a36.27,36.27,0,0,1-1.63-6.51,24.2,24.2,0,0,1-.2-6.75,8.79,8.79,0,0,1,.39-1.71c.2-.56.42-1.05.64-1.57a17.83,17.83,0,0,1,1.65-3,15.55,15.55,0,0,1,5.1-4.49,60.78,60.78,0,0,1,6.05-2.89,97.51,97.51,0,0,1,12.55-4.47C370.29,215.2,379,213.44,387.64,211.6Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.5,
              transformOrigin: "361.426px 245.475px",
            }}
            className="animable"
            id="elogpb09mmxup"
          />
        </g>
        <path
          d="M392,243.12l8.36-11.83s-6-2.14-9.89-10.66c0,6.13,5.45,11.69,5.45,11.69l-7.62,11.61Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "394.33px 232.28px",
          }}
          id="el8zkpwas81lr"
          className="animable"
        />
        <path
          d="M356.62,246.76c-1.29-3.88-2-6.32-1.38-7.49.5-.9,1.93-1.38,4.56-2,6.06-1.45,35.21-6.1,35.5-6.14l-.19-1.19c-.29,0-29.49,4.69-35.59,6.15-3,.73-4.62,1.31-5.34,2.6-.86,1.56-.27,3.78,1.3,8.46,1,3.06,2.63,13.19,3.7,19.89,1,6.31,1.11,6.86,1.28,7.11l.67-.45.38-.14c-.13-.37-.62-3.45-1.14-6.71C359.23,259.7,357.67,249.91,356.62,246.76Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "374.542px 252.045px",
          }}
          id="eluluqcyjn4xh"
          className="animable"
        />
        <path
          d="M347.48,273.23l3.17,6.79s5.79.87,10.65-1.78,5.52-5.75,5.52-5.91-1.24-7.3-1.24-7.3S361.82,274.76,347.48,273.23Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "357.15px 272.593px",
          }}
          id="elq7vik7tadoe"
          className="animable"
        />
        <path
          d="M362.74,249.5a23,23,0,0,0-5.38-10.56s5.83,2,7.57,10.09Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "361.145px 244.22px",
          }}
          id="eli5p1pb1rkm"
          className="animable"
        />
        <path
          d="M406,323.81c.75,2.72,3.87,2.95,4.65,5.84a8,8,0,0,1-.71,6,10.57,10.57,0,0,0-1.33,2.88c-.18,1.27-.37,2.56-.58,3.84a46.75,46.75,0,0,0-.46,6.15c-.13,5-3.44,9.55-7.3,12.59-2,1.59-3.36,1.31-5.81,2-1.68.49-4.09.68-5.34-.74s-1.16-3.55-.78-5.28c.45-2.13,1.24-2.57,2.18-4.5a28.6,28.6,0,0,0,2-6.79,25.06,25.06,0,0,0,.55-5.3,57.48,57.48,0,0,0-1.17-13.24c-.89-4.91-3-11.93-3-11.93l17.32-6Z"
          style={{
            fill: "rgb(255, 168, 167)",
            transformOrigin: "399.514px 336.401px",
          }}
          id="elnb2z8gvcm9a"
          className="animable"
        />
        <path
          d="M411.54,329.83a5.16,5.16,0,0,1,1.83,3.05,16.51,16.51,0,0,1-2.57,5.86c-1.65,2.5-2.28,3.54-2.1,5.8a19.71,19.71,0,0,1-.69,8.83,16.14,16.14,0,0,1-9,10.13c-5.39,2.51-7.58,2-9,1.34a9,9,0,0,1-2.89-2.75Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "400.245px 347.605px",
          }}
          id="elv9v5i71tdo"
          className="animable"
        />
        <path
          d="M406,323.81l0,1.77a11.43,11.43,0,0,1-.07,2c-.39,3.14-4.7,4.91-5.86,5.74a3.12,3.12,0,0,0-2.19-1.43c-2-.46-5.51-1-6.07-.16s.83,7.77.14,12.55-1.94,6.41-4,9.67c-1.5,2.33-3.31,7,.21,8.91,1.83,1,8.06,1.91,14.57-3.91,5.77-5.16,4.85-11.53,4.57-15s1.16-5.23,3.1-9c.84-1.65,1.6-2.86,1.22-5.05-1.09-2.37-2.75-2.66-3.81-4.19C406.86,324.41,406.87,323.61,406,323.81Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "398.924px 343.688px",
          }}
          id="elnvqo2ktqzu9"
          className="animable"
        />
        <path
          d="M400,333.29a1.72,1.72,0,0,0-.82.88,3.6,3.6,0,0,0-.13,1.21c0,.79,0,1.55,0,2.34,0,1.56,0,3.11-.08,4.66a42,42,0,0,1-.48,4.62,21,21,0,0,1-1.23,4.5,14.17,14.17,0,0,0,1.77-4.4,25.72,25.72,0,0,0,.67-4.7,38.94,38.94,0,0,0,0-4.71c-.05-.78-.13-1.57-.23-2.34a4.34,4.34,0,0,1,0-1.13A1.92,1.92,0,0,1,400,333.29Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "398.63px 342.395px",
          }}
          id="eluzfhe1l733"
          className="animable"
        />
        <path
          d="M398.49,350.55c-1.63-1.19-6.55-2.58-8-1.25l-.22.51a2.51,2.51,0,0,1,.45-1.62c.57-.9,4.22-1.16,8.09,1.21C399.18,349.93,399,350.86,398.49,350.55Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "394.635px 349.077px",
          }}
          id="elw0ix72ziqkh"
          className="animable"
        />
        <path
          d="M399.28,346.59c-1.57-1.28-6-2.68-7.53-1.44l-.09.45a1.47,1.47,0,0,1,.27-1.51c.62-.86,4-1.22,7.76,1.37C400,346,399.77,346.93,399.28,346.59Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "395.695px 345.058px",
          }}
          id="elg0hcbjpa5fg"
          className="animable"
        />
        <path
          d="M399.72,342.5c-1.66-1.13-6.25-2.37-7.62-1l0,.55a1.88,1.88,0,0,1,0-1.49c.48-1,4.08-1.47,8,.76C400.39,341.85,400.24,342.79,399.72,342.5Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "396.096px 341.14px",
          }}
          id="elnjoaif6s0qc"
          className="animable"
        />
        <path
          d="M399.92,339c-1.65-1.13-6.53-2.49-7.91-1.11v.56a2.16,2.16,0,0,1,0-1.58c.48-1,4.34-1.27,8.24,1C400.59,338.33,400.44,339.27,399.92,339Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "396.146px 337.588px",
          }}
          id="elso7xg5b2i1p"
          className="animable"
        />
        <path
          d="M387.51,211.61c5.43,14.39,12.82,19.68,12.82,19.68S384.44,253.38,381.6,259c-3.32,6.49-2.8,10.56-2.15,15.06,1.17,8.06,10.11,46.55,10.11,46.55,4.47,2.82,15.92-.35,17-3.78,0,0,.15-7,.19-13.47,0-6,.36-16.39-1.32-22.52-2.62-9.58-1.28-9.15,1.88-12.79,2.19-2.52,13.18-11.84,22.62-21.86,7.95-8.44,10.1-13.87,11.49-20.56,1.22-5.84,1-8.43,1.64-19.18Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "411.014px 264.073px",
          }}
          id="elp4tozcbm69s"
          className="animable"
        />
        <path
          d="M389.56,320.56c-2-7.79-3.9-15.62-5.73-23.46-.93-3.92-1.78-7.85-2.64-11.79s-1.71-7.86-2.33-11.88a27.72,27.72,0,0,1-.31-6.12,20.78,20.78,0,0,1,1.46-6,32.29,32.29,0,0,1,2.84-5.4q1.62-2.56,3.34-5.05,6.84-10,14.14-19.59l-6.78,10c-2.26,3.33-4.52,6.66-6.72,10-1.1,1.68-2.17,3.38-3.24,5.07a31.12,31.12,0,0,0-2.72,5.29,19.26,19.26,0,0,0-1.36,5.72,26.7,26.7,0,0,0,.35,5.9c1.24,7.9,3.11,15.77,4.72,23.64l2.52,11.81Z"
          style={{
            fill: "#213E60",
            transformOrigin: "389.415px 275.915px",
          }}
          id="el8qurvyykgt"
          className="animable"
        />
        <g id="elzfav8krjrzq">
          <path
            d="M389.56,320.56c-2-7.79-3.9-15.62-5.73-23.46-.93-3.92-1.78-7.85-2.64-11.79s-1.71-7.86-2.33-11.88a27.72,27.72,0,0,1-.31-6.12,20.78,20.78,0,0,1,1.46-6,32.29,32.29,0,0,1,2.84-5.4q1.62-2.56,3.34-5.05,6.84-10,14.14-19.59l-6.78,10c-2.26,3.33-4.52,6.66-6.72,10-1.1,1.68-2.17,3.38-3.24,5.07a31.12,31.12,0,0,0-2.72,5.29,19.26,19.26,0,0,0-1.36,5.72,26.7,26.7,0,0,0,.35,5.9c1.24,7.9,3.11,15.77,4.72,23.64l2.52,11.81Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.5,
              transformOrigin: "389.415px 275.915px",
            }}
            className="animable"
            id="el15dtkdh3xy4"
          />
        </g>
        <path
          d="M430.32,208c4.18,10.33,6.7,16.57-4.87,28.81-3.48,3.69-7.18,7.33-10.74,10.85-10.59,10.44-18.95,18.68-18,23.7.38,1.93,1,4.16,1.68,6.74,1.66,6.1,2.54,7.8,3.23,17,.58,7.81,1.21,19.36,1.48,24.63a13.43,13.43,0,0,0,1.2-.63c-.27-5.28-.89-16.54-1.45-24.08-.69-9.34-1.6-11.11-3.27-17.26-.69-2.56-1.29-4.77-1.66-6.65-.86-4.36,8.11-13.2,17.61-22.56,3.58-3.53,7.28-7.18,10.78-10.88,12.12-12.83,9.33-19.73,5.12-30.16-.4-1-.81-2-1.23-3.08l-1.25.18C429.44,205.77,429.89,206.9,430.32,208Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "415.831px 262.08px",
          }}
          id="elo2f6ykoojob"
          className="animable"
        />
        <path
          d="M429.41,233.8c-.22-.07-5.48-1.8-6.2-10.12a47.36,47.36,0,0,0-4.85-18.45l1.12-.51a48.85,48.85,0,0,1,5,18.86c.65,7.49,5.28,9,5.33,9Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "424.085px 219.26px",
          }}
          id="el57e90hxwyfj"
          className="animable"
        />
        <path
          d="M388.24,315.75c2.66,2.38,13.68,1.54,18.48-3.07l0,6.17c-3.39,4.24-11.39,6.12-16.82,3.08Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "397.48px 318.053px",
          }}
          id="elz9rxrbqycz"
          className="animable"
        />
        <path
          d="M354.68,321.18h0a3.43,3.43,0,0,1-1-1.2,4.45,4.45,0,0,1-.3-.71c-.63-2,.06-4.63.77-6.27a30.83,30.83,0,0,0,2-5L356,308l-.14.53a2.52,2.52,0,0,1,.19-1.67,1,1,0,0,1,.3-.35,19.85,19.85,0,0,0,.2-2.35c0-.16,0-.29,0-.46h0v.46a1.45,1.45,0,0,1,0-1.5c0-.67-.08-1.36-.17-2.07a1.85,1.85,0,0,1-.25-1.46l0-.05c-.13-.69-.27-1.38-.41-2.06a2.32,2.32,0,0,1-.31-1.34c-.63-2.63-1.23-4.78-1-5.25a1.12,1.12,0,0,1,.67-.47c-.17-.5-.35-1-.58-1.57l-3.37-8.33a14.41,14.41,0,0,0,1.53.07l.53,1.14a76.07,76.07,0,0,1,3.34,8.4l-.45.47c-.93,1-.36,2.93,0,4.15.39,1.42.68,3.54,1,5a21.46,21.46,0,0,1,.39,8.37c-.52,3.07-1.88,5.65-3,8.49a4.87,4.87,0,0,0-.19,3.9,8.55,8.55,0,0,0,3.11,3.21A10.36,10.36,0,0,1,354.68,321.18Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "354.42px 301.66px",
          }}
          id="eltdwb655tvdb"
          className="animable"
        />
        <path
          d="M391.74,365.33a6.2,6.2,0,0,1-1.75-.49,9,9,0,0,1-2.88-2.74l0-.05a3.52,3.52,0,0,1-.78-1.29.19.19,0,0,0,0-.07,4.06,4.06,0,0,1-.16-.69s0,0,0,0c-.29-2.08.8-4.53,1.77-6a33.16,33.16,0,0,0,2.72-4.67l-.07.05-.22.51a2.5,2.5,0,0,1,.45-1.62.88.88,0,0,1,.35-.3,20.48,20.48,0,0,0,.66-2.74h0l-.09.45a1.47,1.47,0,0,1,.26-1.49,19.14,19.14,0,0,0,.16-2.05,1.87,1.87,0,0,1,0-1.5,0,0,0,0,0,0,0c0-.7,0-1.4-.08-2.1a2.28,2.28,0,0,1-.09-1.36c-.2-2.7-.46-4.92-.16-5.35a1.14,1.14,0,0,1,.77-.36c-.16-1.17-.38-2.5-.66-4.08s-.66-3.23-1.07-4.88a10,10,0,0,0,1.79.62c.19,1,.35,2.1.51,3.15.24,1.66.51,3.31.7,5.12a2.06,2.06,0,0,0-.76,1.84c0,.52.07,1.13.1,1.64.09,1,.21,2,.25,2.94a26.94,26.94,0,0,1-1.76,11.9c-1.4,3.32-4.3,6.64-3.92,10.44C388,362.68,389.66,364.28,391.74,365.33Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "389.996px 343.92px",
          }}
          id="elbn7gv10ri8"
          className="animable"
        />
        <g
          id="abhishek--Top--inject-2"
          className="animable"
          style={{
            transformOrigin: "390.389px 232.167px",
          }}
        >
          <g
            id="abhishek--Arm--inject-2"
            className="animable"
            style={{
              transformOrigin: "361.68px 163.981px",
            }}
          >
            <path
              d="M383.27,157.6c-4,4.25-10.67,10-17.19,16.46,0,0-13.21-14.13-14.64-17.07-.95-2-.95-3.33-.74-6.64a22.18,22.18,0,0,1,2.07-8.16c.85-1.5-1.16-1.82-3.25-.24s-1.79,2.87-2.69,4.7-1.7,1.37-2.57-.11-4.92-8.88-6.46-11.09-3-2.16-3.76-1.4c-.42.43.34,1.73,2.09,5.09s3.76,6.27,3.52,6.4-2.1-3-4.32-6.15c-2.05-2.9-3.28-4.37-4.79-4.61-1.71-.27-2.12,1-1.75,1.46a76.13,76.13,0,0,1,4.82,6.81,31.14,31.14,0,0,1,2.39,4.1c-.2.28-1.86-2-4.35-4.42-2.26-2.22-3.62-3.28-5.34-2.86-.36.09-.91.45-.87.76.08.71,2,2.34,3.08,3.53,1.56,1.7,1.75,1.79,2.88,3.14.77.93,1.75,2.15,1.62,2.31s-4.27-3.33-5.94-3.73c-1.44-.35-2.66.18-1.64,1.4s6.8,7.1,8.91,9.57,5.43,5.67,7.36,8.25,5.17,8.65,9.24,14.9c3.36,5.15,7.05,10.27,8.53,12,4.46,5.14,7.6,3,13.75-1.32,6.93-4.92,16.35-14.54,18-16.59l7.43-24.72C392.35,150.23,390.25,150.28,383.27,157.6Z"
              style={{
                fill: "rgb(255, 168, 167)",
                transformOrigin: "361.861px 164.289px",
              }}
              id="elyrcq8arjo6h"
              className="animable"
            />
            <path
              d="M397.93,149.09c-2.42.35-7.52.78-11.36,4.6s-15.08,14.93-15.08,14.93,3.07.86,7.06,5.77c2.49,3.05,3.92,8.7,3.92,8.7l9.24-8.68Z"
              style={{
                fill: "#213E60",
                transformOrigin: "384.71px 166.09px",
              }}
              id="el7tcuky1vhk"
              className="animable"
            />
            <path
              d="M397.93,149.09c-2.42.35-7.52.78-11.36,4.6s-15.08,14.93-15.08,14.93"
              style={{
                fill: "#213E60",
                transformOrigin: "384.71px 158.855px",
              }}
              id="elvdz7585gg9"
              className="animable"
            />
            <path
              d="M397.93,149.09a24.63,24.63,0,0,0-7.95,2.46,14.4,14.4,0,0,0-3.27,2.48l-3,3c-2,2-4,3.94-6.05,5.87s-4.09,3.86-6.2,5.73c1.89-2.09,3.84-4.12,5.79-6.14s4-4,5.93-6l3-2.94a13,13,0,0,1,3.48-2.51,17.13,17.13,0,0,1,4-1.4A31.56,31.56,0,0,1,397.93,149.09Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "384.695px 158.86px",
              }}
              id="el6o7c9omf1oj"
              className="animable"
            />
            <path
              d="M366.08,174.06a12.78,12.78,0,0,0-3.33,9.85,11.2,11.2,0,0,1,2-11.28Z"
              style={{
                fill: "rgb(242, 143, 143)",
                transformOrigin: "364.053px 178.27px",
              }}
              id="el5gelnqemm23"
              className="animable"
            />
            <g
              id="abhishek--Glove--inject-2"
              className="animable"
              style={{
                transformOrigin: "340.205px 151.995px",
              }}
            >
              <path
                d="M344.6,170.92s-2.55-3.8-3.85-5.77a74.25,74.25,0,0,0-5.82-7.32l-.74-.86c-1.22-1.4-3.58-3.86-5.66-6-1.54-1.61-2.87-3-3.32-3.52s-.49-1.08-.37-1.35a1.48,1.48,0,0,1,1.44-.64,3.92,3.92,0,0,1,.88.11c1.14.28,3.18,1.76,4.68,2.85l.32.23c-.23-.29-.54-.67-1-1.17-.69-.83-1-1.18-1.54-1.71-.33-.34-.74-.76-1.34-1.42-.32-.34-.7-.71-1.09-1.09-1.26-1.23-2-2-2.09-2.59s.7-1,1.11-1.08a2.92,2.92,0,0,1,.82-.1c1.47,0,2.73,1,4.84,3,1.13,1.1,2.11,2.18,2.82,3l.29.33c-.36-.63-.88-1.48-1.61-2.6a69.61,69.61,0,0,0-4.36-6.15l-.48-.61a1.1,1.1,0,0,1-.05-1.15,1.66,1.66,0,0,1,1.62-.83,2.74,2.74,0,0,1,.48,0c1.6.25,2.84,1.66,5,4.72.43.59.84,1.19,1.23,1.76-.31-.55-.62-1.12-.93-1.7l-.56-1.07c-1.52-2.86-2-3.82-1.49-4.36a1.85,1.85,0,0,1,1.35-.55c.68,0,1.74.35,2.89,2s3.79,6.28,5.36,9.05c.52.92.93,1.64,1.15,2,.56.95.93,1.15,1.13,1.15s.36-.21.69-1.09c.24-.63.41-1.2.6-1.73a7.11,7.11,0,0,1,2.13-3.17,4,4,0,0,1,2.62-1.13,1.67,1.67,0,0,1,1.47.69,1.23,1.23,0,0,1-.06,1.25,21.49,21.49,0,0,0-2.05,8c-.21,3.3-.24,4.43.68,6.3.9,1.54,3.79,5.23,3.82,5.27l.1.13-.06.16a2.87,2.87,0,0,1-.18.4,15.5,15.5,0,0,1-9.74,8.24,8.42,8.42,0,0,1-.88.23l-.2,0Z"
                style={{
                  fill: "rgb(69, 90, 100)",
                  transformOrigin: "340.246px 152.155px",
                }}
                id="elztcl9sqm04g"
                className="animable"
              />
              <path
                d="M344.64,146.34a3.18,3.18,0,0,0,1,1c.37.21.44-.47.61-.88a24.58,24.58,0,0,1,1-2.77,7,7,0,0,1,1.86-2.32,3.77,3.77,0,0,1,2.75-1,4.19,4.19,0,0,0-2.48,1.27,8.12,8.12,0,0,0-1.68,2.25c-.4.84-.67,1.8-1,2.69-.1.22-.19.44-.31.67a.76.76,0,0,1-.31.34.49.49,0,0,1-.46-.05A2.84,2.84,0,0,1,344.64,146.34Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "348.25px 143.995px",
                }}
                id="elw4u98ffel6i"
                className="animable"
              />
              <path
                d="M335,145.78c-.73-1-1.39-2-2.08-3l-2.08-3c-.7-1-1.42-1.95-2.14-2.93l-.27-.36a1.11,1.11,0,0,1-.2-.49,1.3,1.3,0,0,1,.22-1,1.78,1.78,0,0,1,1.67-.67,1.72,1.72,0,0,0-1.46.8,1.1,1.1,0,0,0-.12.77.7.7,0,0,0,.17.33l.3.35c.78.91,1.53,1.88,2.23,2.86A48.61,48.61,0,0,1,335,145.78Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "331.604px 140.045px",
                }}
                id="el88i2fiapqwe"
                className="animable"
              />
              <path
                d="M332.16,148.62,330,146.38c-.35-.38-.72-.72-1.09-1.08l-1.09-1.09c-.72-.72-1.47-1.43-2.15-2.23a2.43,2.43,0,0,1-.7-1.47,1.05,1.05,0,0,1,.5-.68,1.84,1.84,0,0,1,.74-.27c-.45.18-.95.55-1,1s.42.81.75,1.17c.7.73,1.47,1.41,2.18,2.17s1.37,1.52,2.05,2.31S331.55,147.79,332.16,148.62Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "328.565px 144.09px",
                }}
                id="elhrogrgx97h"
                className="animable"
              />
              <path
                d="M344.6,170.92l-4.85-6.87c-1.67-2.25-3.51-4.36-5.36-6.47s-3.81-4.11-5.7-6.18l-2.84-3.12-.7-.79a1.81,1.81,0,0,1-.45-1,.94.94,0,0,1,.54-.89,2.21,2.21,0,0,1,1-.19,2.18,2.18,0,0,0-1,.24.84.84,0,0,0-.44.83c.09.68.74,1.11,1.21,1.62l2.93,3c1.95,2,3.9,4.05,5.8,6.12s3.68,4.26,5.29,6.57S343.11,168.54,344.6,170.92Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "334.65px 158.164px",
                }}
                id="elr0r1795kw6"
                className="animable"
              />
              <path
                d="M342.71,149.55c-.86,4.06,1.62,8.45,3.31,9.35C343.49,158.66,340.19,153.85,342.71,149.55Z"
                style={{
                  fill: "rgb(55, 71, 79)",
                  transformOrigin: "343.914px 154.225px",
                }}
                id="elawwupzr0df"
                className="animable"
              />
              <path
                d="M352.18,157.49c.56.81-2.12,4.48-5.56,5.89l2.25,3.26s4.52-1.68,6.1-5.29c.41-.7-.21-1.4-1.23-2.79a28.79,28.79,0,0,0-1.72-2.33.43.43,0,0,0-.52.07A5.48,5.48,0,0,0,352.18,157.49Z"
                style={{
                  fill: "rgb(55, 71, 79)",
                  transformOrigin: "350.859px 161.406px",
                }}
                id="ely5jdclxfukc"
                className="animable"
              />
              <path
                d="M349.85,164.19a.78.78,0,1,1-.78-.79A.78.78,0,0,1,349.85,164.19Z"
                style={{
                  fill: "#213E60",
                  transformOrigin: "349.07px 164.18px",
                }}
                id="elr6n10503jy"
                className="animable"
              />
              <polygon
                points="336.8 140.98 339.28 144.79 334.32 136.15 336.8 140.98"
                style={{
                  fill: "rgb(55, 71, 79)",
                  transformOrigin: "336.8px 140.47px",
                }}
                id="elswbdgi8gl6n"
                className="animable"
              />
              <path
                d="M332.68,151.72a.24.24,0,0,1-.2-.11,24,24,0,0,0-4.79-4.58.25.25,0,0,1-.06-.35.25.25,0,0,1,.35-.06,23.91,23.91,0,0,1,4.91,4.71.25.25,0,0,1-.06.35A.28.28,0,0,1,332.68,151.72Z"
                style={{
                  fill: "rgb(55, 71, 79)",
                  transformOrigin: "330.26px 149.147px",
                }}
                id="elme21r1hajh"
                className="animable"
              />
              <path
                d="M334.58,148.16a.26.26,0,0,1-.19-.1,67.78,67.78,0,0,0-6.37-7l0-.05a.26.26,0,0,1,0-.36.27.27,0,0,1,.36,0l.05,0a70.61,70.61,0,0,1,6.42,7.1.25.25,0,0,1-.06.35A.29.29,0,0,1,334.58,148.16Z"
                style={{
                  fill: "rgb(55, 71, 79)",
                  transformOrigin: "331.422px 144.371px",
                }}
                id="elwocig2297zb"
                className="animable"
              />
              <path
                d="M337.39,145.59a.27.27,0,0,1-.22-.14,75.55,75.55,0,0,0-5.95-9.22.25.25,0,0,1,0-.35.26.26,0,0,1,.36.05,76.56,76.56,0,0,1,6,9.3.25.25,0,0,1-.12.33A.27.27,0,0,1,337.39,145.59Z"
                style={{
                  fill: "rgb(55, 71, 79)",
                  transformOrigin: "334.376px 140.71px",
                }}
                id="el9lzvsk4r77s"
                className="animable"
              />
              <path
                d="M341.23,143.87a.26.26,0,0,1-.23-.19,48.83,48.83,0,0,0-4.21-8.4.25.25,0,1,1,.41-.29,48.57,48.57,0,0,1,4.28,8.56.25.25,0,0,1-.17.31Z"
                style={{
                  fill: "rgb(55, 71, 79)",
                  transformOrigin: "339.117px 139.376px",
                }}
                id="elv20dwzdezl"
                className="animable"
              />
              <path
                d="M347.05,149.16h0a.25.25,0,0,1-.19-.3c.31-1.28,1.42-5.6,2.66-7.16a.25.25,0,0,1,.35,0,.26.26,0,0,1,0,.36c-1.17,1.47-2.26,5.7-2.56,7A.25.25,0,0,1,347.05,149.16Z"
                style={{
                  fill: "rgb(55, 71, 79)",
                  transformOrigin: "348.398px 145.397px",
                }}
                id="eleqvbrxfkevw"
                className="animable"
              />
              <path
                d="M352,140.47c.33.47,0,1.29-.79,1.82s-1.65.57-2,.09,0-1.29.78-1.82S351.64,140,352,140.47Z"
                style={{
                  fill: "#213E60",
                  transformOrigin: "350.601px 141.427px",
                }}
                id="el9pcog2g9p1t"
                className="animable"
              />
              <g id="el5mpjb6hgw36">
                <path
                  d="M352,140.47c.33.47,0,1.29-.79,1.82s-1.65.57-2,.09,0-1.29.78-1.82S351.64,140,352,140.47Z"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.5,
                    transformOrigin: "350.601px 141.427px",
                  }}
                  className="animable"
                  id="eldoh1m6ese5"
                />
              </g>
              <g id="el9xgkjkws3zr">
                <path
                  d="M350.89,140.17a2.59,2.59,0,0,0-.9.39c-.76.53-1.11,1.35-.78,1.82a.7.7,0,0,0,.49.28,2.2,2.2,0,0,0,1.47-.93C351.71,140.9,351.55,140.22,350.89,140.17Z"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.5,
                    transformOrigin: "350.29px 141.415px",
                  }}
                  className="animable"
                  id="elz8pxu98iz0s"
                />
              </g>
              <path
                d="M335,133.17c.41-.41,1.27-.2,1.92.46s.85,1.53.44,1.93-1.27.2-1.93-.46S334.54,133.58,335,133.17Z"
                style={{
                  fill: "#213E60",
                  transformOrigin: "336.166px 134.363px",
                }}
                id="elisqel19il6c"
                className="animable"
              />
              <g id="elzmflf1ef5d">
                <path
                  d="M335,133.17c.41-.41,1.27-.2,1.92.46s.85,1.53.44,1.93-1.27.2-1.93-.46S334.54,133.58,335,133.17Z"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.5,
                    transformOrigin: "336.166px 134.363px",
                  }}
                  className="animable"
                  id="elz10rcieqbai"
                />
              </g>
              <g id="elxpzpg01r8no">
                <path
                  d="M337.18,135.28c-.27.13-.84.1-1.44-.49s-.89-1.68-.38-1.81a.68.68,0,0,0-.41.19c-.41.41-.22,1.27.43,1.93s1.52.87,1.93.46a.93.93,0,0,0,.17-.92A.61.61,0,0,1,337.18,135.28Z"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.5,
                    transformOrigin: "336.134px 134.375px",
                  }}
                  className="animable"
                  id="elqoz7fqz5wpp"
                />
              </g>
              <path
                d="M329.41,134.14c.41-.4,1.28-.2,1.93.46s.85,1.53.44,1.94-1.28.2-1.93-.46S329,134.55,329.41,134.14Z"
                style={{
                  fill: "#213E60",
                  transformOrigin: "330.595px 135.342px",
                }}
                id="elynxdib8x7o"
                className="animable"
              />
              <g id="eltea2vh7d33">
                <path
                  d="M329.41,134.14c.41-.4,1.28-.2,1.93.46s.85,1.53.44,1.94-1.28.2-1.93-.46S329,134.55,329.41,134.14Z"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.5,
                    transformOrigin: "330.595px 135.342px",
                  }}
                  className="animable"
                  id="elgqw93zar9th"
                />
              </g>
              <g id="el65gmbqy8p8s">
                <path
                  d="M332,135.78a.71.71,0,0,1-.31.58c-.29.13-.69.11-1.41-.6s-.64-1.68-.15-1.79a.84.84,0,0,0-.69.17c-.41.41-.21,1.27.44,1.94s1.51.86,1.93.46A.89.89,0,0,0,332,135.78Z"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.5,
                    transformOrigin: "330.623px 135.351px",
                  }}
                  className="animable"
                  id="elvolna76d57"
                />
              </g>
              <path
                d="M325.79,139.26c.33-.47,1.22-.42,2,.11s1.1,1.35.77,1.82-1.22.43-2-.11S325.46,139.73,325.79,139.26Z"
                style={{
                  fill: "#213E60",
                  transformOrigin: "327.175px 140.227px",
                }}
                id="el463xlkxxaf"
                className="animable"
              />
              <g id="elycsjencugj">
                <path
                  d="M325.79,139.26c.33-.47,1.22-.42,2,.11s1.1,1.35.77,1.82-1.22.43-2-.11S325.46,139.73,325.79,139.26Z"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.5,
                    transformOrigin: "327.175px 140.227px",
                  }}
                  className="animable"
                  id="eleehevbi4ygp"
                />
              </g>
              <g id="els9fyg967vm">
                <path
                  d="M328.54,141.19a1.61,1.61,0,0,1-1.73-.45c-.72-.63-.92-1.53-.6-1.75a.75.75,0,0,0-.42.27c-.33.47,0,1.29.77,1.82S328.21,141.67,328.54,141.19Z"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.5,
                    transformOrigin: "327.101px 140.253px",
                  }}
                  className="animable"
                  id="elblz14om7ehm"
                />
              </g>
              <path
                d="M325.6,145c.34-.48,1.22-.43,2,.11s1.11,1.35.77,1.82-1.21.42-2-.11S325.27,145.51,325.6,145Z"
                style={{
                  fill: "#213E60",
                  transformOrigin: "326.986px 145.961px",
                }}
                id="elal2r4gqieze"
                className="animable"
              />
              <g id="el5lgymhh7ihl">
                <path
                  d="M325.6,145c.34-.48,1.22-.43,2,.11s1.11,1.35.77,1.82-1.21.42-2-.11S325.27,145.51,325.6,145Z"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.5,
                    transformOrigin: "326.986px 145.961px",
                  }}
                  className="animable"
                  id="elj6yoy5ay8c"
                />
              </g>
              <g id="elpww8t11d80b">
                <path
                  d="M328.35,147a.57.57,0,0,0,.11-.25s-.41.45-1.31.07-1.87-1.74-.83-2.08a.83.83,0,0,0-.72.33c-.33.47,0,1.29.78,1.82S328,147.44,328.35,147Z"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.5,
                    transformOrigin: "326.966px 146.024px",
                  }}
                  className="animable"
                  id="elwrbxp989l5"
                />
              </g>
            </g>
            <g id="el5zs5yfv57y6">
              <path
                d="M370.79,184.27c-6.07,4.68-6.83,5.72-12.56.63a141.79,141.79,0,0,1-12-12.57c1.4,2.35,3,5,4.73,7.67,3.36,5.15,7.05,10.27,8.53,12,4.46,5.14,7.6,3,13.75-1.32a97.78,97.78,0,0,0,9.21-7.71l0,.13,9.24-8.68,2.72-11.07.56-1.86C388.78,167.62,375.39,180.72,370.79,184.27Z"
                style={{
                  opacity: 0.3,
                  transformOrigin: "370.6px 178.246px",
                }}
                className="animable"
                id="elrot0dyp5ngc"
              />
            </g>
          </g>
          <path
            id="abhishek--Chest--inject-2"
            d="M389.6,167.73c.38-13.22,8.33-18.64,8.33-18.64s6.84-1.59,18.67-.79a118,118,0,0,1,19.25,3.21c-1.36,3.39-2.05,15.16-1.32,19.38s5.91,8.14,5.91,8.14c1.68,13.09,3.68,18.62,3.34,26a149.53,149.53,0,0,1-1.5,19.11c-18.16,7.83-46.49-.78-55.28-12.58C390.56,193.63,389.1,185.18,389.6,167.73Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "415.409px 187.612px",
            }}
            className="animable"
          />
          <path
            d="M393,155.43a20,20,0,0,1,4.93-6.34c-4.42,3.23-7.13,8.44-8.21,13.8a45.82,45.82,0,0,0-.65,8.16c-.06,2.72-.09,5.43-.09,8.15.06,5.42.11,10.83-.18,16.23-.12,2.7-.36,5.4-.69,8.09s-.71,5.36-1.11,8a106.35,106.35,0,0,0,2.57-16.09c.46-5.42.39-10.87.42-16.29,0-2.71,0-5.41,0-8.12a53.59,53.59,0,0,1,.5-8A25.56,25.56,0,0,1,393,155.43Z"
            style={{
              fill: "#213E60",
              transformOrigin: "392.465px 180.305px",
            }}
            id="elg27b5gekyrb"
            className="animable"
          />
          <g id="elen3xxfzldl">
            <path
              d="M393,155.43a20,20,0,0,1,4.93-6.34c-4.42,3.23-7.13,8.44-8.21,13.8a45.82,45.82,0,0,0-.65,8.16c-.06,2.72-.09,5.43-.09,8.15.06,5.42.11,10.83-.18,16.23-.12,2.7-.36,5.4-.69,8.09s-.71,5.36-1.11,8a106.35,106.35,0,0,0,2.57-16.09c.46-5.42.39-10.87.42-16.29,0-2.71,0-5.41,0-8.12a53.59,53.59,0,0,1,.5-8A25.56,25.56,0,0,1,393,155.43Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: 0.5,
                transformOrigin: "392.465px 180.305px",
              }}
              className="animable"
              id="elt36xos6zyl8"
            />
          </g>
          <g
            id="abhishek--Head--inject-2"
            className="animable"
            style={{
              transformOrigin: "410.118px 129.121px",
            }}
          >
            <path
              d="M422.4,140.85c2.81-8.11,15.63-20.91,4.92-30.81-.83-6.33-8.49-7.84-13.76-8.51a66.88,66.88,0,0,1-15.88-2.19c-4.82-2-4.72,4.44-3.11,7.27-4.74-1.06-3.74,2.5-1.94,5.32-3.75,3,2.14,5.47,4.07,7.32Z"
              style={{
                fill: "#213E60",
                transformOrigin: "411.327px 119.906px",
              }}
              id="elskpm9deysg"
              className="animable"
            />
            <g id="el64xsuxrdbe9">
              <path
                d="M393.71,116.36a24.14,24.14,0,0,1-1.6-1.91c-.53-1,.24-1.76.88-2.36.31-.28.28-.35.11-.63-.59-.94-1.92-2.73-1-3.86.65-.84,2.18-.57,3.09-.37.57.13.31-.42.05-.84a8.3,8.3,0,0,1-1-3.42,6.19,6.19,0,0,1,.23-2.22A3.15,3.15,0,0,1,395.64,99c-2.69.45-2.4,5.24-1.07,7.59-4.11-.92-3.9,1.63-2.61,4.17l.33.51,0,0c.12.21.25.42.38.62-2.15,1.71-1.13,3.25.5,4.61a2.16,2.16,0,0,0,.43.14C393.7,116.72,393.78,116.46,393.71,116.36Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: 0.3,
                  transformOrigin: "393.388px 107.828px",
                }}
                className="animable"
                id="elwi0q1br3q1o"
              />
            </g>
            <g id="elt9lyb6tph8">
              <path
                d="M411.23,111.64c-2-.33-4.05-.15-6-.84a5.36,5.36,0,0,1-2.37-1.46c-1.24-1.48.74-2.06,1.83-2.13.22,0,.27-.5.06-.56a13.35,13.35,0,0,1-3.85-1.73c-1.13-.73-2.46-1.75-2.78-3.13,0-.09-.1,0-.09.07a4.58,4.58,0,0,0,2.2,3.25,11.71,11.71,0,0,0,3.12,1.7,1.8,1.8,0,0,0-1.26,1c-.46,1.05.3,2.09,1.1,2.71a8.23,8.23,0,0,0,3.44,1.42,10.82,10.82,0,0,0,4.53.1C411.29,112.05,411.42,111.67,411.23,111.64Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: 0.3,
                  transformOrigin: "404.678px 106.992px",
                }}
                className="animable"
                id="ely4pg0954rto"
              />
            </g>
            <path
              d="M396.15,111.19c-1.19,1.28-2.53,7.26-2.85,17.37s2.84,12.9,6,14.35c1.77.82,4.25.92,7.62.59l.09,5.14c-2,4-2,7,.1,10.64,11.13-3.16,14.95-7,15.91-9.18l.13-13.83s1.17,2.17,4.7-.52c2.9-2.22,4.1-6.21,2.1-8.52a5,5,0,0,0-7.88,1s-2.11.67-3.58-2.71c-1-2.29-1.79-5.16-1.76-12.3C406.58,116.33,396.61,113.42,396.15,111.19Z"
              style={{
                fill: "rgb(255, 168, 167)",
                transformOrigin: "412.108px 135.235px",
              }}
              id="elv3l2cmz1z3m"
              className="animable"
            />
            <path
              d="M396.34,139.73c-1.86-2.75-1.82-6.65-1.95-9.85a67,67,0,0,1,.4-9.91q.27-2.46.75-4.89c.24-1.16.56-2.32.8-3.48a1.36,1.36,0,0,1-.19-.41c-1.19,1.28-2.53,7.26-2.85,17.37s2.84,12.9,6,14.35a11,11,0,0,0,4.65.76C401.07,143.36,398,142.23,396.34,139.73Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "398.614px 127.438px",
              }}
              id="elw2a1mhj7sne"
              className="animable"
            />
            <path
              d="M409,133.52l-5.95,1.66a3,3,0,0,0,3.75,2.25A3.23,3.23,0,0,0,409,133.52Z"
              style={{
                fill: "rgb(177, 102, 104)",
                transformOrigin: "406.077px 135.532px",
              }}
              id="elva35m51wjta"
              className="animable"
            />
            <path
              d="M405.48,137.48a2.86,2.86,0,0,1,3-2.66,2.61,2.61,0,0,1,.57.09,3.16,3.16,0,0,1-2.24,2.52A3,3,0,0,1,405.48,137.48Z"
              style={{
                fill: "rgb(242, 143, 143)",
                transformOrigin: "407.265px 136.174px",
              }}
              id="elxst1lkbiag"
              className="animable"
            />
            <path
              d="M396,119.83l3.25-1a1.64,1.64,0,0,0-2-1.18A1.8,1.8,0,0,0,396,119.83Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "397.597px 118.714px",
              }}
              id="eluqekurrus3k"
              className="animable"
            />
            <path
              d="M409.1,119.7l3.08,1.42a1.62,1.62,0,0,0-.76-2.23A1.78,1.78,0,0,0,409.1,119.7Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "410.734px 119.925px",
              }}
              id="eli06pt0uzn0c"
              className="animable"
            />
            <polygon
              points="403.76 122.55 403.61 131.8 398.57 131.08 403.76 122.55"
              style={{
                fill: "rgb(242, 143, 143)",
                transformOrigin: "401.165px 127.175px",
              }}
              id="elyc2k4x4vg7c"
              className="animable"
            />
            <path
              d="M406.91,143.5c3.54-.23,11.3-3.12,12.61-5.9a7.38,7.38,0,0,1-3,4.64c-3.41,2.08-9.6,3.4-9.6,3.4Z"
              style={{
                fill: "rgb(242, 143, 143)",
                transformOrigin: "413.215px 141.62px",
              }}
              id="elyy95qi0ha97"
              className="animable"
            />
            <path
              d="M410.7,124.07a1.55,1.55,0,0,1-1.37,1.68,1.47,1.47,0,0,1-1.65-1.32,1.57,1.57,0,0,1,1.37-1.67A1.45,1.45,0,0,1,410.7,124.07Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "409.191px 124.254px",
              }}
              id="el8rgdjrq230h"
              className="animable"
            />
            <path
              d="M399.1,122.82a1.55,1.55,0,0,1-1.37,1.68,1.46,1.46,0,0,1-1.64-1.32,1.55,1.55,0,0,1,1.37-1.67A1.45,1.45,0,0,1,399.1,122.82Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "397.595px 123.004px",
              }}
              id="el48ynrccldgv"
              className="animable"
            />
            <g
              id="abhishek--Glasses--inject-2"
              className="animable"
              style={{
                transformOrigin: "403.578px 124.427px",
              }}
            >
              <path
                d="M418.42,120.44c-.06-1.89-6.67-2.45-13-3.22s-11.2-1.82-12.58-.56c-.14.13-2.34,1.77-2.79,2.11a1.12,1.12,0,0,0-.4.56c-.65,2-1.32,8.87-.07,10.49s8.53,2.07,9.25.88l.95-1.56c.95-1.56,1.45-2.39,1.69-2.8a1.28,1.28,0,0,1,1.15.69,4.85,4.85,0,0,1,.65,1.69c.61,2.68.43,2.84,2.09,3.27s6.43,1,7.79.51a1.66,1.66,0,0,0,.45-.25l2.87-2.18C418.54,128.49,418.48,122.21,418.42,120.44Z"
                style={{
                  fill: "rgb(38, 50, 56)",
                  transformOrigin: "403.659px 124.381px",
                }}
                id="elregmpsmt1fb"
                className="animable"
              />
              <path
                d="M402.51,119.41c-6.95-.84-12.25-2-12.89-.08s-1.33,8.87-.07,10.49,8.53,2.07,9.25.88l2.65-4.35s1.19-.31,1.79,2.37.43,2.84,2.09,3.27,6.43,1,7.79.51c2.55-1,2.48-8,2.42-9.87S408.87,120.17,402.51,119.41Z"
                style={{
                  fill: "#213E60",
                  transformOrigin: "402.202px 125.488px",
                }}
                id="elqi3hwmnhamb"
                className="animable"
              />
              <path
                d="M401.45,126.35a1.07,1.07,0,0,1,.88.32,2.9,2.9,0,0,1,.57.78,8.75,8.75,0,0,1,.56,1.85,8.88,8.88,0,0,0,.51,1.82c.27.54,1,.64,1.57.79a29.61,29.61,0,0,0,3.77.61c.64.06,1.27.11,1.91.13a6.4,6.4,0,0,0,1.9-.15,10.68,10.68,0,0,1-3.82.19,31,31,0,0,1-3.82-.53,8.29,8.29,0,0,1-.93-.29,1.35,1.35,0,0,1-.77-.66,9.93,9.93,0,0,1-.49-1.87,8,8,0,0,0-.51-1.83C402.55,127,402.13,126.31,401.45,126.35Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "407.285px 129.562px",
                }}
                id="elkfxsxhrqzk"
                className="animable"
              />
              <path
                d="M402.51,119.41c-2-.19-4-.45-6-.71-1-.12-2-.23-3-.29a8.44,8.44,0,0,0-2.93.2c-1,.22-1.07,1.42-1.27,2.36a29.71,29.71,0,0,0-.36,3,23,23,0,0,0-.06,3,6.07,6.07,0,0,0,.61,2.89,6.08,6.08,0,0,1-.74-2.88,25.19,25.19,0,0,1,0-3,30,30,0,0,1,.32-3,12.71,12.71,0,0,1,.31-1.49,1.6,1.6,0,0,1,1.09-1.08,8.86,8.86,0,0,1,3-.17c1,.08,2,.21,3,.34Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "395.613px 124.021px",
                }}
                id="elqfat264zzf"
                className="animable"
              />
              <path
                d="M411.27,131.7a29,29,0,0,1-5.69-.68c-.86-.23-.86-.23-1.16-1.64l-.2-.88c-.61-2.74-1.92-3.16-2.65-3.16a2.05,2.05,0,0,0-.38,0l-.39.11-2.8,4.6a6.41,6.41,0,0,1-2.33.28c-2.71,0-5-.7-5.32-1.16-.86-1.11-.47-7.45.22-9.57,0,0,.15-.38,1.92-.37a53.77,53.77,0,0,1,6.1.64l3.8.5,1.91.22c3.85.45,9.68,1.13,10.26,2.1.12,4.71-.61,8.37-1.81,8.84a4.6,4.6,0,0,1-1.48.13Z"
                style={{
                  fill: "rgb(55, 71, 79)",
                  transformOrigin: "402.215px 125.465px",
                }}
                id="elijawcimmco"
                className="animable"
              />
              <path
                d="M398.59,119.91l-.19,0-8.5,7.37a4.33,4.33,0,0,0,.45,2,1.92,1.92,0,0,0,.79.44l10.73-9.31Z"
                style={{
                  fill: "rgb(69, 90, 100)",
                  transformOrigin: "395.885px 124.815px",
                }}
                id="elrnfsghvugcb"
                className="animable"
              />
              <path
                d="M410.2,121.41,403.73,127a6.64,6.64,0,0,1,.49,1.47l.2.88c0,.16.06.31.09.44l8.89-7.71A23.74,23.74,0,0,0,410.2,121.41Z"
                style={{
                  fill: "rgb(69, 90, 100)",
                  transformOrigin: "408.565px 125.6px",
                }}
                id="elye8bhxjeci"
                className="animable"
              />
              <path
                d="M393.86,119.34,390,122.66c-.08.82-.14,1.71-.16,2.55l6.46-5.6C395.43,119.49,394.6,119.4,393.86,119.34Z"
                style={{
                  fill: "rgb(69, 90, 100)",
                  transformOrigin: "393.07px 122.275px",
                }}
                id="elejs7hwq643p"
                className="animable"
              />
              <path
                d="M396.74,130.33l2.35-2,1.71-2.8.39-.11a2.05,2.05,0,0,1,.38,0,1.83,1.83,0,0,1,.74.16l5.16-4.48-2.43-.3-11,9.55c.53.06,1.08.09,1.65.1C396.09,130.37,396.44,130.35,396.74,130.33Z"
                style={{
                  fill: "rgb(69, 90, 100)",
                  transformOrigin: "400.755px 125.625px",
                }}
                id="ellb2gg5qlw6"
                className="animable"
              />
              <path
                d="M414.47,126.32c.06-.68.09-1.42.1-2.2l-8.16,7.08c.59.11,1.31.22,2.09.31Z"
                style={{
                  fill: "rgb(69, 90, 100)",
                  transformOrigin: "410.49px 127.815px",
                }}
                id="elcon3maw0b9u"
                className="animable"
              />
              <g id="elans8ak3kcqw">
                <path
                  d="M414.56,122.73c-.58-1-6.41-1.65-10.26-2.1l-1.91-.22-3.8-.5a53.77,53.77,0,0,0-6.1-.64c-1.77,0-1.92.37-1.92.37-.69,2.12-1.08,8.46-.22,9.57a2.45,2.45,0,0,0,1,.53c-1.63-.59-.75-5.9-.34-7.5s.33-2.19,9.62-1.26,12.07,1.17,12.9,2a4.86,4.86,0,0,1,.91,3.51A35,35,0,0,0,414.56,122.73Z"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.9,
                    transformOrigin: "402.213px 124.505px",
                  }}
                  className="animable"
                  id="elonb9k1a2af"
                />
              </g>
              <g id="elyo6h2wmybg">
                <path
                  d="M403,120.48l-.65-.07-3.8-.5a53.77,53.77,0,0,0-6.1-.64c-1.77,0-1.92.37-1.92.37-.69,2.12-1.08,8.46-.22,9.57.35.46,2.61,1.14,5.32,1.16a6.41,6.41,0,0,0,2.33-.28l.73-1.21c.33-.72-.51-.79-1-.77-1.77,0-2.63.49-3.89-.28-1.64-1-1.09-4.32.13-5.18C396.47,120.88,397.65,120,403,120.48Z"
                  style={{
                    fill: "#213E60",
                    opacity: 0.5,
                    transformOrigin: "396.409px 124.827px",
                  }}
                  className="animable"
                  id="elu1pqohf5yd"
                />
              </g>
            </g>
          </g>
          <g id="abhishek--Shadow--inject-2">
            <path
              d="M388.27,243.93l3.7-.81,6.33-9a145,145,0,0,0-22.4,4.25c-13.07,3.46-17.45,6-19,9.34s-2.12,6.66,0,16.65,6.07,14.89,7.51,20,4.56,5.82,4.42,8.91.87,5.89,1,11.62-4.64,13.05-10.39,14.08-6-3.67-6-3.78c-.52,2.15-.52,4.66,1.27,6h0a9,9,0,0,0,3.29,2.26c1.54.39,3.78.58,8.7-2.75a16.14,16.14,0,0,0,7.27-11.42,19.72,19.72,0,0,0-.71-8.84c-.53-2.2-.08-3.32,1.16-6.05a16.45,16.45,0,0,0,1.61-6.2,5.15,5.15,0,0,0-2.29-2.72c-1.45-2.17-2.68-2.29-4-3.62-1.05-1.09-1.17-2-2-1.64l.2,1.06-1.49-7.87a3.65,3.65,0,0,0,.38-1.06c0-.16-1.24-7.3-1.24-7.3s-.09.23-.28.61l-2.56-16.14,2.19-.47ZM443.78,205c.34-7.39-1.66-12.92-3.34-26,0,0-5.18-3.92-5.91-8.14s0-16,1.32-19.38A125.23,125.23,0,0,0,423,149l.09-9.88c.31-.67.67-1.37,1.06-2.09.73.2,1.91.07,3.67-1.27,2.9-2.22,4.1-6.21,2.1-8.52a2.81,2.81,0,0,0-.34-.35c2.48-5.68,3.33-11.65-2.28-16.84-.83-6.33-8.49-7.84-13.76-8.51-2.85-.13-5.71-.32-8.55-.69,6.28,1.53,11.77,4.15,8,4.62,4.56,2.69,5.21,8.05-3.41,9,0,0,3.13.6,2.84,3.62l-2.75,2.36a6.73,6.73,0,0,1,2.36,6.29c-.67,4-5.72,5.63-5.72,5.63a27.65,27.65,0,0,0,5.6.36c1.07,1.79,1.49,5.26.36,7.36a8.66,8.66,0,0,1-4,3.2c4.11-.85,9.93-3.12,11.19-5.71,0,3.9-.18,8.6,0,16.31-1.83,4.45-2,11-1.91,13,.2,4.89,1.31,11.68,4.3,22.55.58,2.14,1.25,4.26,2,6.34.34.94.7,1.87,1.08,2.8.15.36.35.72.48,1.08s-.19.68-.35.93a9.67,9.67,0,0,1-.65.89c-.93,1.16-2.07,2.14-3,3.31a9,9,0,0,0-1,1.55,1,1,0,0,0-.13.72.79.79,0,0,0,.42.44c1,.51,2.14,0,3.11-.52l3.22-1.71-2.84,5a8.12,8.12,0,0,0-1.46,4.47,2.12,2.12,0,0,0,2.44-.07,7.16,7.16,0,0,0,1.73-1.94,30.83,30.83,0,0,1,2.63-3.2,2.2,2.2,0,0,1,.81-.62,1.5,1.5,0,0,1,1.68.83,4.32,4.32,0,0,1,.35,2l.06,3.4a2.65,2.65,0,0,0,.82,2.31,1.34,1.34,0,0,0,1.55-.08,3.73,3.73,0,0,0,.62-.8c.14-.22.36-.63.68-.47a3.08,3.08,0,0,1,.78.79,4.45,4.45,0,0,1,.48.66c1,1.88,1.17,11.41-9.11,23.19-10.65,12.2-26.89,24.74-28.06,27.94s1,6.88,2.25,13,.67,38.34.65,44.54,2.79,18-.66,25.93-9.2,9.14-12.69,8.87-3-5-3-5.09c-.85,2.05-1.27,4.55.3,6.16a9,9,0,0,0,2.89,2.75c1.45.64,3.64,1.17,9-1.34a16.14,16.14,0,0,0,9-10.13,19.71,19.71,0,0,0,.69-8.83c-.18-2.26.45-3.3,2.1-5.8a16.51,16.51,0,0,0,2.57-5.86,5.16,5.16,0,0,0-1.83-3.05c-1.09-2.37-2.75-2.66-3.81-4.19-.87-1.23-.86-2-1.74-1.83l.05-4.25a8.54,8.54,0,0,0,.64-.71l0-6.17-.06.05c0-2.6.09-6.09.11-9.42,0-6,.36-16.39-1.32-22.52-2.62-9.58-1.28-9.15,1.88-12.79,2.19-2.52,13.18-11.84,22.62-21.86,7.95-8.44,10.1-13.87,11.49-20.56.09-.41.17-.81.24-1.19l.6-.24A149.53,149.53,0,0,0,443.78,205Z"
              style={{
                opacity: 0.3,
                transformOrigin: "398.479px 233.111px",
              }}
              className="animable"
              id="elzec18c7bah"
            />
          </g>
          <g
            id="abhishek--arm--inject-2"
            className="animable"
            style={{
              transformOrigin: "438.003px 183.905px",
            }}
          >
            <path
              d="M436.24,151.91c7.53,1.64,9.13,3.94,11.31,10s5.47,20.86,7.21,29.79c1.5,7.65,2,14.52,0,17.71L439,201.87l-6.5-24.2S430.3,159.33,436.24,151.91Z"
              style={{
                fill: "rgb(255, 168, 167)",
                transformOrigin: "444.09px 180.66px",
              }}
              id="elvn3uc4ezjx"
              className="animable"
            />
            <path
              d="M435.85,151.51c3.4.77,7.92,1.81,9.88,5.56s4.23,11.1,6,19,2,9.1,2,9.1-3.11,4-18.44,4.73l-4.07-14.28S428.57,156.4,435.85,151.51Z"
              style={{
                fill: "#213E60",
                transformOrigin: "442.24px 170.705px",
              }}
              id="elf6ur1raglrn"
              className="animable"
            />
            <path
              d="M438.09,190.19c1.27,1.95,2.8,2.77,6.14,4.53,3.11,1.65,6.74,3.24,8.49,6.79-.4-3.23-2.08-4.89-5.94-7.31s-9.55-5.35-9.55-5.35Z"
              style={{
                fill: "rgb(242, 143, 143)",
                transformOrigin: "444.975px 195.18px",
              }}
              id="el0ouf0vhjq3qi"
              className="animable"
            />
            <path
              d="M438.09,190.19c1.27,1.95,2.8,2.77,6.14,4.53,3.11,1.65,6.74,3.24,8.49,6.79,1.55,3.13,3.26,5.75,2,7.91-.84,1.49-5.35,2.24-9.56,1.76s-6.9-4.12-11-7.34c-3.52-2.77-5.35-4.51-5.35-4.51Z"
              style={{
                fill: "rgb(255, 168, 167)",
                transformOrigin: "441.984px 200.757px",
              }}
              id="elmri9urklqam"
              className="animable"
            />
            <g id="elkpwx608tq9b">
              <path
                d="M454.76,209.42c-.84,1.5-5.35,2.24-9.56,1.76-3-.35-5.16-2.24-7.64-4.45l-.15.09-3.91-3.35.08-.12c-3.11-2.48-4.74-4-4.74-4l3.66-3.63c.08.38.13.59.14.61.14.31,6.4-2.26,6.4-2.26s-2.74-10.86-4.75-17.89-2.47-17.93-1.23-21.3h0a8.6,8.6,0,0,1,2.79-3.34c3.4.76,7.92,1.81,9.88,5.56s4.23,11.1,6,19,2,9.1,2,9.1a2.65,2.65,0,0,1-.3.29c.49,2.24.92,4.38,1.28,6.23C456.26,199.36,456.75,206.22,454.76,209.42Z"
                style={{
                  opacity: 0.3,
                  transformOrigin: "442.455px 181.433px",
                }}
                className="animable"
                id="elem58c7sxoap"
              />
            </g>
            <g
              id="abhishek--Gloves--inject-2"
              className="animable"
              style={{
                transformOrigin: "435.562px 200.662px",
              }}
            >
              <path
                d="M440.38,192.21l2.33,1.7s3,7.85-5.3,12.91l-3.91-3.34Z"
                style={{
                  fill: "rgb(55, 71, 79)",
                  transformOrigin: "438.369px 199.515px",
                }}
                id="el4sua25csqm7"
                className="animable"
              />
              <path
                d="M432.07,192.28c1.76-1.43,2.22-3,4.71-4.13s4-.9,6.63-1.93,4.74-1.47,6.57-.66,1.43,1.87-.09,2.62-4.08,1.68-5.91,2.74-3.55,1.61-3.78,3.76a96.35,96.35,0,0,0-.28,10.27c.09,3.65.51,6.64.2,7s-2.2.36-2.94-1.75-1.21-9.29-1.21-9.29-.92,4.75-1.57,8.23-1,6.14-1.21,6.88-2.6-.09-2.73-2.78,1.19-10.47,1.19-10.47-2.43,3.35-4,5.53-3.54,5.17-4.16,5.89-2.06-.82-1.46-2.88,3.82-6.94,3.82-6.94-3.61,3.07-4.22,3.35-2.31-.17-1.48-2.44c.56-1.51,1.65-2.4,4.58-5.12s3-4,4-5.26C430,193.21,430.8,193.32,432.07,192.28Z"
                style={{
                  fill: "rgb(69, 90, 100)",
                  transformOrigin: "435.562px 200.709px",
                }}
                id="elaqk8uhp6jx6"
                className="animable"
              />
              <path
                d="M440.12,212a1.07,1.07,0,0,1-.8.23,2.5,2.5,0,0,1-.84-.19,2.82,2.82,0,0,1-1.25-1.19,10.28,10.28,0,0,1-.85-3.26c-.16-1.1-.27-2.2-.33-3.31s-.11-2.21-.08-3.32c.35,2.19.59,4.38.9,6.56a13.27,13.27,0,0,0,.7,3.15,2.55,2.55,0,0,0,1,1.15A1.62,1.62,0,0,0,440.12,212Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "438.041px 206.599px",
                }}
                id="elfofo1v3zbs6"
                className="animable"
              />
              <path
                d="M433.19,216c0,.2-.26.3-.45.3a1.56,1.56,0,0,1-.56-.12,2.82,2.82,0,0,1-1-.65,3.65,3.65,0,0,1-.94-2.1,27.24,27.24,0,0,1,.23-4.53c.19-1.49.41-3,.67-4.45s.6-2.95,1-4.4l-.6,4.46c-.19,1.48-.41,3-.56,4.45a31.81,31.81,0,0,0-.34,4.43,3.32,3.32,0,0,0,.73,2,2.62,2.62,0,0,0,.83.69,1.37,1.37,0,0,0,.52.16C432.92,216.27,433.14,216.23,433.19,216Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "431.708px 208.175px",
                }}
                id="el66tqq18t84p"
                className="animable"
              />
              <path
                d="M420.16,205.29c.52-1.52,1.8-2.6,2.89-3.72a40.22,40.22,0,0,0,3.3-3.36,14.74,14.74,0,0,0,1.29-1.93,10,10,0,0,1,1.31-2,6.2,6.2,0,0,1,1.93-1.47,7.28,7.28,0,0,0,1.8-1.42c.54-.55,1-1.18,1.59-1.75a7.29,7.29,0,0,1,2-1.45,16.8,16.8,0,0,1,4.57-1.37,16.21,16.21,0,0,0,2.27-.62c.73-.26,1.49-.54,2.25-.74a6.87,6.87,0,0,1,4.67.12,6.74,6.74,0,0,0-4.6.12c-.75.22-1.48.51-2.22.8a16.62,16.62,0,0,1-2.28.69,18,18,0,0,0-4.45,1.4,7,7,0,0,0-1.82,1.38c-.53.56-1,1.19-1.57,1.77a8,8,0,0,1-1.92,1.49,5.77,5.77,0,0,0-1.83,1.35,9.91,9.91,0,0,0-1.27,1.93,12.23,12.23,0,0,1-1.38,2,38,38,0,0,1-3.43,3.29C422.07,202.81,420.76,203.8,420.16,205.29Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "435.095px 195.199px",
                }}
                id="elacsychtzak5"
                className="animable"
              />
              <path
                d="M438.45,194.16c-2.73.89-5.16-.54-5.45-1.22C433,194.75,436.46,196.16,438.45,194.16Z"
                style={{
                  fill: "rgb(55, 71, 79)",
                  transformOrigin: "435.725px 194.038px",
                }}
                id="el89ryqrf8yyn"
                className="animable"
              />
              <path
                d="M420,206.63c.21.36.93.54,1.65.06s2.52-2.14,3.34-2.9,3.64-3.49,3.64-3.49l-2.73,4.08s-3.61,3.07-4.22,3.35A1.27,1.27,0,0,1,420,206.63Z"
                style={{
                  fill: "rgb(55, 71, 79)",
                  transformOrigin: "424.315px 204.05px",
                }}
                id="elo98hlvrj789"
                className="animable"
              />
              <path
                d="M422,211.32a13,13,0,0,1,1.19-3c.48-1,1-1.89,1.6-2.8s1.18-1.8,1.81-2.66,1.27-1.73,1.95-2.56c-1,1.9-2.21,3.68-3.34,5.49l-1.68,2.72A22.41,22.41,0,0,0,422,211.32Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "425.275px 205.81px",
                }}
                id="el9sjh30w4kr6"
                className="animable"
              />
              <path
                d="M440.14,189.35a.28.28,0,0,1-.2-.12.26.26,0,0,1,.08-.35,23,23,0,0,1,8-2.95.24.24,0,0,1,.28.22.26.26,0,0,1-.22.28,22.19,22.19,0,0,0-7.77,2.88A.28.28,0,0,1,440.14,189.35Z"
                style={{
                  fill: "rgb(55, 71, 79)",
                  transformOrigin: "444.102px 187.639px",
                }}
                id="elz2kw5usch4q"
                className="animable"
              />
              <path
                d="M438,209.57a.24.24,0,0,1-.24-.2,78.82,78.82,0,0,1-.84-10.59.26.26,0,0,1,.51,0,77.83,77.83,0,0,0,.82,10.5.25.25,0,0,1-.19.3Z"
                style={{
                  fill: "rgb(55, 71, 79)",
                  transformOrigin: "437.588px 204.075px",
                }}
                id="el1igjchqab06"
                className="animable"
              />
              <path
                d="M431.24,213.1a.24.24,0,0,1-.24-.25,65,65,0,0,1,1.92-11.69.27.27,0,0,1,.32-.17.26.26,0,0,1,.17.32,63.39,63.39,0,0,0-1.91,11.55.26.26,0,0,1-.25.25Z"
                style={{
                  fill: "rgb(55, 71, 79)",
                  transformOrigin: "432.21px 207.046px",
                }}
                id="elbq8xc5buur"
                className="animable"
              />
              <path
                d="M422.87,211.07h-.07a.26.26,0,0,1-.15-.33c.93-2.59,7-10.55,7.27-10.89a.26.26,0,0,1,.35-.05.27.27,0,0,1,.05.36c-.06.08-6.29,8.23-7.2,10.75A.25.25,0,0,1,422.87,211.07Z"
                style={{
                  fill: "rgb(55, 71, 79)",
                  transformOrigin: "426.501px 205.412px",
                }}
                id="el7xio0yyemcp"
                className="animable"
              />
              <path
                d="M421.54,204.28a.22.22,0,0,1-.13,0,.26.26,0,0,1-.07-.35,33.94,33.94,0,0,1,4.88-4.42c.53-.43.95-.76,1.15-.94a.25.25,0,0,1,.35,0,.25.25,0,0,1,0,.36c-.2.18-.63.52-1.16,1a34.66,34.66,0,0,0-4.78,4.31A.22.22,0,0,1,421.54,204.28Z"
                style={{
                  fill: "rgb(55, 71, 79)",
                  transformOrigin: "424.548px 201.399px",
                }}
                id="eluja4sg0l9ld"
                className="animable"
              />
              <path
                d="M447.38,185.82c.09-.57.91-.91,1.83-.76s1.58.74,1.49,1.31-.92.91-1.83.76S447.29,186.39,447.38,185.82Z"
                style={{
                  fill: "#213E60",
                  transformOrigin: "449.04px 186.095px",
                }}
                id="elhgh8dz0arys"
                className="animable"
              />
              <g id="elux0wftgl8b">
                <path
                  d="M447.38,185.82c.09-.57.91-.91,1.83-.76s1.58.74,1.49,1.31-.92.91-1.83.76S447.29,186.39,447.38,185.82Z"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.5,
                    transformOrigin: "449.04px 186.095px",
                  }}
                  className="animable"
                  id="elzfhv3ylc6ah"
                />
              </g>
              <path
                d="M437.67,208.82c.54-.22,1.25.31,1.6,1.17s.2,1.73-.33,1.95-1.26-.31-1.6-1.17S437.14,209,437.67,208.82Z"
                style={{
                  fill: "#213E60",
                  transformOrigin: "438.307px 210.38px",
                }}
                id="el3f8vpayvv7c"
                className="animable"
              />
              <g id="eluxcwuhtjbt">
                <path
                  d="M437.67,208.82c.54-.22,1.25.31,1.6,1.17s.2,1.73-.33,1.95-1.26-.31-1.6-1.17S437.14,209,437.67,208.82Z"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.5,
                    transformOrigin: "438.307px 210.38px",
                  }}
                  className="animable"
                  id="elyioh554jmw8"
                />
              </g>
              <g id="el499uf16nafr">
                <path
                  d="M438.38,211.92c.89,0,.8-1.12.38-2s-1.14-1.08-1.48-.71a2,2,0,0,0,.06,1.54A1.93,1.93,0,0,0,438.38,211.92Z"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.5,
                    transformOrigin: "438.111px 210.477px",
                  }}
                  className="animable"
                  id="elez1h0dcdt6s"
                />
              </g>
              <path
                d="M431.25,212c.58,0,1.08.7,1.13,1.63s-.39,1.7-1,1.73-1.08-.71-1.12-1.63S430.68,212,431.25,212Z"
                style={{
                  fill: "#213E60",
                  transformOrigin: "431.321px 213.68px",
                }}
                id="elmd2duxb4y8"
                className="animable"
              />
              <g id="el8hucenj2a8h">
                <path
                  d="M431.25,212c.58,0,1.08.7,1.13,1.63s-.39,1.7-1,1.73-1.08-.71-1.12-1.63S430.68,212,431.25,212Z"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.5,
                    transformOrigin: "431.321px 213.68px",
                  }}
                  className="animable"
                  id="elkg3y04kdrek"
                />
              </g>
              <g id="elp40681psyre">
                <path
                  d="M431.25,212c-.57,0-1,.8-1,1.73a1.73,1.73,0,0,0,.84,1.57,1.8,1.8,0,0,0,.51-.52C432.25,213.88,431.92,211.94,431.25,212Z"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.5,
                    transformOrigin: "431.1px 213.649px",
                  }}
                  className="animable"
                  id="elxiihetfc8wb"
                />
              </g>
              <path
                d="M423.09,210c.57.12.87,1,.68,1.87s-.81,1.54-1.38,1.42-.86-.95-.67-1.86S422.53,209.84,423.09,210Z"
                style={{
                  fill: "#213E60",
                  transformOrigin: "422.744px 211.64px",
                }}
                id="elz3pmp388ovr"
                className="animable"
              />
              <g id="el049vi98pzmfk">
                <path
                  d="M423.09,210c.57.12.87,1,.68,1.87s-.81,1.54-1.38,1.42-.86-.95-.67-1.86S422.53,209.84,423.09,210Z"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.5,
                    transformOrigin: "422.744px 211.64px",
                  }}
                  className="animable"
                  id="elm1c7tog8kr"
                />
              </g>
              <g id="el0mo74zdfetwh">
                <path
                  d="M423.29,211.07a1.18,1.18,0,0,0-.57-1.07,1.8,1.8,0,0,0-1,1.39,1.84,1.84,0,0,0,.35,1.69C423.2,213.15,423.35,211.87,423.29,211.07Z"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.5,
                    transformOrigin: "422.474px 211.541px",
                  }}
                  className="animable"
                  id="elkdetfb65wch"
                />
              </g>
              <path
                d="M422.05,202.9c.5.3.53,1.18.06,2s-1.25,1.22-1.75.93-.53-1.18-.06-2S421.56,202.61,422.05,202.9Z"
                style={{
                  fill: "#213E60",
                  transformOrigin: "421.205px 204.365px",
                }}
                id="elyy8osy592c"
                className="animable"
              />
              <g id="elcu2e5a4kji">
                <path
                  d="M422.05,202.9c.5.3.53,1.18.06,2s-1.25,1.22-1.75.93-.53-1.18-.06-2S421.56,202.61,422.05,202.9Z"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.5,
                    transformOrigin: "421.205px 204.365px",
                  }}
                  className="animable"
                  id="elk0m8ukuldle"
                />
              </g>
              <g id="ellke8iwhcin">
                <path
                  d="M421.78,202.82a1.75,1.75,0,0,0-1.48,1c-.44.76-.44,1.58,0,1.92.59-.15,1.1-.7,1.45-1.71C422,203.39,422,203,421.78,202.82Z"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.5,
                    transformOrigin: "420.956px 204.28px",
                  }}
                  className="animable"
                  id="els7u0fuknjfr"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <g
      id="abhishek--light-bulb--inject-2"
      className="animable"
      style={{
        transformOrigin: "169.86px 198.83px",
      }}
    >
      <g
        id="abhishek--Bulb--inject-2"
        className="animable"
        style={{
          transformOrigin: "169.86px 198.83px",
        }}
      >
        <g id="elrobjyexihq">
          <circle
            cx={169.86}
            cy={198.83}
            r={157.22}
            style={{
              fill: "#213E60",
              opacity: 0.2,
              transformOrigin: "169.86px 198.83px",
            }}
            className="animable"
            id="elakndezuf99q"
          />
        </g>
        <g id="eletlp0ugvkvc">
          <circle
            cx={169.86}
            cy={198.83}
            r={133.39}
            style={{
              fill: "#213E60",
              opacity: 0.2,
              transformOrigin: "169.86px 198.83px",
              transform: "rotate(-45deg)",
            }}
            className="animable"
            id="elaa4gs1nuw8w"
          />
        </g>
        <g id="elayiafsqqo5b">
          <circle
            cx={169.86}
            cy={198.83}
            r={115.05}
            style={{
              fill: "#213E60",
              opacity: 0.2,
              transformOrigin: "169.86px 198.83px",
              transform: "rotate(-45deg)",
            }}
            className="animable"
            id="elab95j5ax2s9"
          />
        </g>
        <g id="elvnoeur3l40n">
          <circle
            cx={169.86}
            cy={198.83}
            r={100.69}
            style={{
              fill: "#213E60",
              opacity: 0.2,
              transformOrigin: "169.86px 198.83px",
              transform: "rotate(-45deg)",
            }}
            className="animable"
            id="el18vjeiqlzfy"
          />
        </g>
        <g
          id="abhishek--bulb--inject-2"
          className="animable"
          style={{
            transformOrigin: "166.945px 216.9px",
          }}
        >
          <g
            id="abhishek--Socket--inject-2"
            className="animable"
            style={{
              transformOrigin: "213.64px 306.496px",
            }}
          >
            <path
              d="M214,334.34c-7.33-.94-9.65-6.46-5.17-12.34s14-9.88,21.36-8.95,9.64,6.46,5.17,12.34S221.33,335.27,214,334.34Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "222.096px 323.695px",
              }}
              id="eldwth0sfarfu"
              className="animable"
            />
            <path
              d="M237.58,320.57l-2.45,1a8.09,8.09,0,0,0-4.45-1.79c-6-.76-13.73,2.5-17.37,7.28a8.11,8.11,0,0,0-1.84,4.43l-2.45,1,4.68,3.28h0a8.78,8.78,0,0,0,3.8,1.31c6,.76,13.74-2.5,17.38-7.28a8.82,8.82,0,0,0,1.73-3.63h0Z"
              style={{
                fill: "#213E60",
                transformOrigin: "223.3px 328.43px",
              }}
              id="elrwoomqxn11i"
              className="animable"
            />
            <g id="eln3mlm4k065g">
              <path
                d="M237.58,320.57l-2.45,1a8.09,8.09,0,0,0-4.45-1.79c-6-.76-13.73,2.5-17.37,7.28a8.11,8.11,0,0,0-1.84,4.43l-2.45,1,4.68,3.28h0a8.78,8.78,0,0,0,3.8,1.31c6,.76,13.74-2.5,17.38-7.28a8.82,8.82,0,0,0,1.73-3.63h0Z"
                style={{
                  opacity: 0.4,
                  transformOrigin: "223.3px 328.43px",
                }}
                className="animable"
                id="elfpkpr4wwfgf"
              />
            </g>
            <g id="el2uztudahlwj">
              <ellipse
                cx={219.24}
                cy={316.8}
                rx={24.22}
                ry={13.98}
                style={{
                  fill: "#213E60",
                  transformOrigin: "219.24px 316.8px",
                  transform: "rotate(-22.58deg)",
                }}
                className="animable"
                id="el2a3hwahi8r"
              />
            </g>
            <g id="el10svc5o4gmcj">
              <ellipse
                cx={217.87}
                cy={313.5}
                rx={25.12}
                ry={14.5}
                style={{
                  fill: "#213E60",
                  transformOrigin: "217.87px 313.5px",
                  transform: "rotate(-22.58deg)",
                }}
                className="animable"
                id="el6sdkvikiw2o"
              />
            </g>
            <g id="el7qnapur2txp">
              <ellipse
                cx={217.87}
                cy={313.5}
                rx={25.12}
                ry={14.5}
                style={{
                  opacity: 0.2,
                  transformOrigin: "217.87px 313.5px",
                  transform: "rotate(-22.58deg)",
                }}
                className="animable"
                id="eloyetchmxaps"
              />
            </g>
            <g id="els0czntkuyx">
              <ellipse
                cx={216.4}
                cy={309.96}
                rx={25.76}
                ry={14.87}
                style={{
                  fill: "#213E60",
                  transformOrigin: "216.4px 309.96px",
                  transform: "rotate(-22.58deg)",
                }}
                className="animable"
                id="elumcv7scpw"
              />
            </g>
            <g id="ely7bro1n537l">
              <ellipse
                cx={214.93}
                cy={306.42}
                rx={26.39}
                ry={15.24}
                style={{
                  fill: "#213E60",
                  transformOrigin: "214.93px 306.42px",
                  transform: "rotate(-22.58deg)",
                }}
                className="animable"
                id="elp5j5m1n7u8"
              />
            </g>
            <g id="el4zkdam07ta3">
              <ellipse
                cx={214.93}
                cy={306.42}
                rx={26.39}
                ry={15.24}
                style={{
                  opacity: 0.2,
                  transformOrigin: "214.93px 306.42px",
                  transform: "rotate(-22.58deg)",
                }}
                className="animable"
                id="elcpfa2h3mlv"
              />
            </g>
            <g id="elm4kg85fcdzk">
              <ellipse
                cx={213.46}
                cy={302.89}
                rx={27.03}
                ry={15.6}
                style={{
                  fill: "#213E60",
                  transformOrigin: "213.46px 302.89px",
                  transform: "rotate(-22.58deg)",
                }}
                className="animable"
                id="eltumd92kmu4f"
              />
            </g>
            <g id="elmnr2tyqii9b">
              <ellipse
                cx={211.98}
                cy={299.35}
                rx={27.66}
                ry={15.97}
                style={{
                  fill: "rgb(55, 71, 79)",
                  transformOrigin: "211.98px 299.35px",
                  transform: "rotate(-22.58deg)",
                }}
                className="animable"
                id="el8d9ahz8gpz7"
              />
            </g>
          </g>
          <path
            d="M136.37,117.48a87.06,87.06,0,0,0-47,113.82c26.54,63.81,83.6,52.51,94.3,78.23,1.7,4.1,6.11,7.07,12.83,8,13.43,1.75,31-5.56,39.22-16.31,4.12-5.38,5.12-10.61,3.42-14.7h0c-10.7-25.73,37.55-58.22,11-122A87.06,87.06,0,0,0,136.37,117.48Z"
            style={{
              fill: "#213E60",
              transformOrigin: "170.464px 214.312px",
            }}
            id="elui11751xhqc"
            className="animable"
          />
          <g id="elslkvi7bp6yl">
            <path
              d="M136.37,117.48a87.06,87.06,0,0,0-47,113.82c26.54,63.81,83.6,52.51,94.3,78.23,1.7,4.1,6.11,7.07,12.83,8,13.43,1.75,31-5.56,39.22-16.31,4.12-5.38,5.12-10.61,3.42-14.7h0c-10.7-25.73,37.55-58.22,11-122A87.06,87.06,0,0,0,136.37,117.48Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: 0.9,
                mixBlendMode: "screen",
                transformOrigin: "170.464px 214.312px",
              }}
              className="animable"
              id="elceg0iw51dbs"
            />
          </g>
          <path
            d="M190.77,132.92a13.72,13.72,0,0,0-2.12,2.85c-2.16,3.83-1.61,8.81.65,12.58,4.37,7.3,13.87,9,20.72,13.28a74.78,74.78,0,0,1,19.59,17.56c1.62,2.08,4.07,5.61,6.15,7.22a6.8,6.8,0,0,0,9.12-.63c2.43-3,2.42-7.54,1.59-10.79-5-19.27-14.34-31.33-29.33-41.51C209,127.93,198.5,125,190.77,132.92Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "217.13px 157.969px",
            }}
            id="elalepsa1jbc"
            className="animable"
          />
          <g id="elcg62vbzo5zj">
            <circle
              cx={163.44}
              cy={182.6}
              r={62.09}
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: 0.6,
                transformOrigin: "163.44px 182.6px",
                transform: "rotate(-45deg)",
              }}
              className="animable"
              id="elngab9s6qidi"
            />
          </g>
          <path
            d="M238.88,199.76a9.57,9.57,0,0,0,3.84,6.85,5.57,5.57,0,0,0,7.72-1.32,9,9,0,0,0,.93-8.55c-1.27-2.93-4.49-5.28-7.89-4.25C240.31,193.46,238.68,197,238.88,199.76Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "245.454px 199.93px",
            }}
            id="el7g6k8nd7wi2"
            className="animable"
          />
          <g id="elzbpp0npqd3">
            <path
              d="M192,296.56c-6-9.44-11.08-13.75-26.3-15s-41-2-61-24.39c28.82,35.18,70.1,30.85,79,52.33,1.7,4.1,6.11,7.07,12.83,8a35.39,35.39,0,0,0,8.72-.05C201.46,311.45,195.71,302.43,192,296.56Z"
              style={{
                fill: "#213E60",
                opacity: 0.15,
                transformOrigin: "154.975px 287.458px",
              }}
              className="animable"
              id="el9o94eavnhsi"
            />
          </g>
          <g id="elizhnc0rzvu">
            <path
              d="M224.15,283.17c-2.45-10.92-1.94-17.55,7.93-29.2s27.51-30.44,25.72-60.45c4.63,45.25-27.56,71.46-18.62,93,1.7,4.09.7,9.32-3.42,14.7a35.28,35.28,0,0,1-6.18,6.15C228,300.41,225.68,290,224.15,283.17Z"
              style={{
                fill: "#213E60",
                opacity: 0.15,
                transformOrigin: "240.587px 250.445px",
              }}
              className="animable"
              id="ela4q6gqkkk2g"
            />
          </g>
        </g>
      </g>
      <g
        id="abhishek--Atom--inject-2"
        className="animable"
        style={{
          transformOrigin: "169.91px 199.171px",
        }}
      >
        <g id="elqkiyj6fv6xg">
          <circle
            cx={144.59}
            cy={175.4}
            r={13.41}
            style={{
              fill: "#213E60",
              transformOrigin: "144.59px 175.4px",
              transform: "rotate(-69.56deg)",
            }}
            className="animable"
            id="elkiwv0geupyq"
          />
        </g>
        <g id="el4jo62bsrllg">
          <path
            d="M146.58,184.07c-6.83,1.73-13.11-2.58-15.39-9a13.4,13.4,0,1,0,26-4.08C158.14,174.56,153.85,182.22,146.58,184.07Z"
            style={{
              opacity: 0.2,
              transformOrigin: "144.582px 179.959px",
            }}
            className="animable"
            id="ellzvgrbu7939"
          />
        </g>
        <path
          d="M153.1,193.5a13.41,13.41,0,1,1-18.95-.59A13.42,13.42,0,0,1,153.1,193.5Z"
          style={{
            fill: "#213E60",
            transformOrigin: "143.33px 202.687px",
          }}
          id="elv5cudbf6if"
          className="animable"
        />
        <g id="elj24ff5op26">
          <path
            d="M153.1,193.5a13.41,13.41,0,1,1-18.95-.59A13.42,13.42,0,0,1,153.1,193.5Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.45,
              transformOrigin: "143.33px 202.687px",
            }}
            className="animable"
            id="elo3or1xy2z4a"
          />
        </g>
        <g id="elbphsbeyfm24">
          <path
            d="M145.32,211.35c-6.83,1.74-13.11-2.57-15.39-9a13.4,13.4,0,1,0,26-4.07C156.88,201.84,152.58,209.5,145.32,211.35Z"
            style={{
              fill: "#213E60",
              opacity: 0.2,
              transformOrigin: "143.322px 207.249px",
            }}
            className="animable"
            id="el9xzhytl1ecv"
          />
        </g>
        <path
          d="M173.49,206.91a13.41,13.41,0,1,1-19-.59A13.41,13.41,0,0,1,173.49,206.91Z"
          style={{
            fill: "#213E60",
            transformOrigin: "163.696px 216.07px",
          }}
          id="elbvikt9jp4o9"
          className="animable"
        />
        <g id="elinojpw7s9m">
          <path
            d="M173.49,206.91a13.41,13.41,0,1,1-19-.59A13.41,13.41,0,0,1,173.49,206.91Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.15,
              transformOrigin: "163.696px 216.07px",
            }}
            className="animable"
            id="elhw7p6hki9xa"
          />
        </g>
        <g id="elcdokdg27mre">
          <path
            d="M165.71,224.76c-6.84,1.74-13.11-2.58-15.39-9a13.4,13.4,0,1,0,26-4.07C177.27,215.25,173,222.91,165.71,224.76Z"
            style={{
              fill: "#213E60",
              opacity: 0.4,
              transformOrigin: "163.712px 220.659px",
            }}
            className="animable"
            id="el4kglk0m5byn"
          />
        </g>
        <path
          d="M196.1,196.05a13.41,13.41,0,1,1-18.95-.59A13.4,13.4,0,0,1,196.1,196.05Z"
          style={{
            fill: "#213E60",
            transformOrigin: "186.33px 205.233px",
          }}
          id="elcxcpq4gyvmk"
          className="animable"
        />
        <g id="el3lseqj5e0yh">
          <path
            d="M188.32,213.9c-6.83,1.74-13.11-2.58-15.39-9.05a13.4,13.4,0,1,0,26-4.08C199.89,204.39,195.59,212.05,188.32,213.9Z"
            style={{
              opacity: 0.2,
              transformOrigin: "186.322px 209.739px",
            }}
            className="animable"
            id="el21v0h0tdn7h"
          />
        </g>
        <path
          d="M196.64,172.24a13.41,13.41,0,1,1-18.95-.59A13.41,13.41,0,0,1,196.64,172.24Z"
          style={{
            fill: "#213E60",
            transformOrigin: "186.87px 181.425px",
          }}
          id="elnbb9ff13c2g"
          className="animable"
        />
        <g id="el2q6qgjn8mwx">
          <path
            d="M196.64,172.24a13.41,13.41,0,1,1-18.95-.59A13.41,13.41,0,0,1,196.64,172.24Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.45,
              transformOrigin: "186.87px 181.425px",
            }}
            className="animable"
            id="eldykpw0xp2hw"
          />
        </g>
        <g id="elhnzk77ay36r">
          <path
            d="M188.86,190.09c-6.83,1.74-13.11-2.58-15.39-9.05a13.4,13.4,0,1,0,26-4.07C200.42,180.58,196.12,188.24,188.86,190.09Z"
            style={{
              fill: "#213E60",
              opacity: 0.2,
              transformOrigin: "186.862px 185.939px",
            }}
            className="animable"
            id="eltu1pwt72e1m"
          />
        </g>
        <path
          d="M191.72,183.88a10.64,10.64,0,1,1-15.05-.47A10.65,10.65,0,0,1,191.72,183.88Z"
          style={{
            fill: "#213E60",
            transformOrigin: "183.96px 191.162px",
          }}
          id="elfcyvoyqcgcm"
          className="animable"
        />
        <g id="elcxmww5aeqwj">
          <path
            d="M191.72,183.88a10.64,10.64,0,1,1-15.05-.47A10.65,10.65,0,0,1,191.72,183.88Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.3,
              transformOrigin: "183.96px 191.162px",
            }}
            className="animable"
            id="el2ptrxar4v74"
          />
        </g>
        <g id="elelqjy5um2tu">
          <path
            d="M185.55,198.05c-5.43,1.38-10.41-2.05-12.23-7.19A10.65,10.65,0,1,0,194,187.63C194.73,190.5,191.32,196.58,185.55,198.05Z"
            style={{
              fill: "#213E60",
              opacity: 0.5,
              transformOrigin: "183.965px 194.738px",
            }}
            className="animable"
            id="el91l811nqpef"
          />
        </g>
        <g id="elkaz6tpczcuo">
          <circle
            cx={168.22}
            cy={170.2}
            r={16.1}
            style={{
              fill: "#213E60",
              transformOrigin: "168.22px 170.2px",
              transform: "rotate(-89.84deg)",
            }}
            className="animable"
            id="elkj9mcwx0ath"
          />
        </g>
        <g id="elesrvp18pkw">
          <circle
            cx={168.22}
            cy={170.2}
            r={16.1}
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.15,
              transformOrigin: "168.22px 170.2px",
              transform: "rotate(-89.84deg)",
            }}
            className="animable"
            id="el256nlgsrqyu"
          />
        </g>
        <g id="el8bghvml812n">
          <path
            d="M170.61,180.6c-8.2,2.09-15.74-3.09-18.48-10.86a16.09,16.09,0,1,0,31.26-4.89C184.49,169.18,179.33,178.38,170.61,180.6Z"
            style={{
              fill: "#213E60",
              opacity: 0.4,
              transformOrigin: "168.214px 175.567px",
            }}
            className="animable"
            id="el5i2shbaob1"
          />
        </g>
        <circle
          cx={165.04}
          cy={194.21}
          r={16.1}
          style={{
            fill: "#213E60",
            transformOrigin: "165.04px 194.21px",
          }}
          id="elhlig25orvwa"
          className="animable"
        />
        <g id="elurh9r96f4m">
          <path
            d="M167.44,204.61c-8.21,2.09-15.74-3.09-18.49-10.86a16.1,16.1,0,1,0,31.27-4.89C181.32,193.19,176.16,202.39,167.44,204.61Z"
            style={{
              opacity: 0.2,
              transformOrigin: "165.043px 199.596px",
            }}
            className="animable"
            id="elhur576stjad"
          />
        </g>
        <g id="el47p3hh2d3an">
          <circle
            cx={148.22}
            cy={189.72}
            r={10.65}
            style={{
              fill: "#213E60",
              transformOrigin: "148.22px 189.72px",
              transform: "rotate(-88.22deg)",
            }}
            className="animable"
            id="el854wcz6qjmq"
          />
        </g>
        <g id="el6l4m76y49ep">
          <circle
            cx={148.22}
            cy={189.72}
            r={10.65}
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.3,
              transformOrigin: "148.22px 189.72px",
              transform: "rotate(-88.22deg)",
            }}
            className="animable"
            id="elhsc1u93px4"
          />
        </g>
        <g id="elxr288qvbifs">
          <path
            d="M149.8,196.6c-5.43,1.38-10.41-2-12.22-7.18a10.64,10.64,0,1,0,20.67-3.24C159,189.05,155.57,195.13,149.8,196.6Z"
            style={{
              fill: "#213E60",
              opacity: 0.5,
              transformOrigin: "148.216px 193.27px",
            }}
            className="animable"
            id="elzqt8ijbeohc"
          />
        </g>
        <path
          d="M272.33,279.61c-.8,0-1.61,0-2.43-.05a.89.89,0,1,1,.06-1.78,58.61,58.61,0,0,0,8.79-.32.89.89,0,1,1,.22,1.77A55.15,55.15,0,0,1,272.33,279.61ZM261,278.82h-.12c-2.81-.37-5.8-.86-8.88-1.46a.9.9,0,0,1,.34-1.76c3,.6,6,1.09,8.77,1.44a.9.9,0,0,1-.11,1.79Zm26.47-1.8a.88.88,0,0,1-.81-.53.89.89,0,0,1,.45-1.18,16.71,16.71,0,0,0,2.41-1.3,12,12,0,0,0,2-1.54,11.81,11.81,0,0,0,2-2.44A.9.9,0,1,1,295,271a13.82,13.82,0,0,1-2.3,2.8,13.36,13.36,0,0,1-2.24,1.75,19.23,19.23,0,0,1-2.63,1.43A.94.94,0,0,1,287.49,277Zm-44-1.61a.83.83,0,0,1-.22,0c-2.81-.7-5.73-1.49-8.67-2.35a.91.91,0,0,1-.61-1.11.89.89,0,0,1,1.11-.61c2.92.85,5.81,1.64,8.6,2.34a.89.89,0,0,1,.66,1.08A.9.9,0,0,1,243.46,275.41Zm-17.18-5a.9.9,0,0,1-.28,0c-2.77-.91-5.62-1.9-8.48-2.94a.9.9,0,0,1-.54-1.14.89.89,0,0,1,1.15-.54c2.84,1,5.68,2,8.43,2.92a.9.9,0,0,1,.57,1.13A.88.88,0,0,1,226.28,270.4Zm-16.83-6.08a.74.74,0,0,1-.32-.07c-2.73-1.06-5.53-2.2-8.31-3.37a.89.89,0,1,1,.69-1.65c2.77,1.17,5.56,2.29,8.27,3.36a.9.9,0,0,1,.51,1.16A.91.91,0,0,1,209.45,264.32Zm86.69-1.22a.9.9,0,0,1-.9-.85,26.34,26.34,0,0,0-2.05-8.36.89.89,0,0,1,.5-1.16.88.88,0,0,1,1.16.49,27.93,27.93,0,0,1,2.18,8.94.89.89,0,0,1-.85.94ZM193,257.4a1,1,0,0,1-.37-.07c-2.68-1.2-5.42-2.45-8.15-3.73a.89.89,0,0,1,.76-1.62c2.72,1.27,5.45,2.52,8.12,3.71a.89.89,0,0,1-.36,1.71Zm-16.2-7.6a.93.93,0,0,1-.4-.09q-2.47-1.22-5-2.48c-1-.51-2-1-3-1.57a.89.89,0,0,1,.84-1.58c1,.53,2,1,3,1.55q2.49,1.26,4.95,2.48a.88.88,0,0,1,.41,1.19A.89.89,0,0,1,176.75,249.8Zm113.18-3.29a.91.91,0,0,1-.76-.43c-1.43-2.33-3.12-4.78-5-7.29a.89.89,0,0,1,.17-1.25.9.9,0,0,1,1.26.17c1.94,2.55,3.67,5,5.13,7.43a.9.9,0,0,1-.3,1.23A.89.89,0,0,1,289.93,246.51Zm-129.06-4.95a.84.84,0,0,1-.43-.11q-4-2.17-7.86-4.29a.89.89,0,1,1,.87-1.56q3.8,2.1,7.84,4.28a.89.89,0,0,1,.37,1.21A.9.9,0,0,1,160.87,241.56Zm-15.63-8.71a.92.92,0,0,1-.45-.12c-2.57-1.51-5.16-3.06-7.69-4.61a.89.89,0,1,1,.93-1.52c2.52,1.54,5.1,3.08,7.66,4.58a.9.9,0,0,1,.32,1.23A.89.89,0,0,1,145.24,232.85Zm133.94-.62a.92.92,0,0,1-.67-.31c-1.23-1.4-2.54-2.85-3.91-4.3-.69-.74-1.4-1.49-2.13-2.24a.89.89,0,1,1,1.28-1.24c.74.75,1.45,1.5,2.16,2.25,1.37,1.47,2.7,2.93,3.95,4.35a.91.91,0,0,1-.68,1.49ZM130,223.52a.92.92,0,0,1-.48-.14c-2.51-1.59-5-3.24-7.52-4.88a.89.89,0,1,1,1-1.49c2.48,1.64,5,3.27,7.5,4.86a.9.9,0,0,1-.48,1.65Zm136.77-4.15a.85.85,0,0,1-.61-.25c-2.09-2-4.3-4-6.58-6a.9.9,0,0,1,1.19-1.34c2.29,2,4.52,4.07,6.62,6.07a.89.89,0,0,1,0,1.26A.86.86,0,0,1,266.74,219.37Zm-151.69-5.74a.86.86,0,0,1-.51-.16c-2.47-1.7-4.93-3.44-7.33-5.17a.9.9,0,1,1,1.05-1.45c2.38,1.72,4.84,3.45,7.29,5.15a.9.9,0,0,1,.23,1.25A.88.88,0,0,1,115.05,213.63Zm-14.52-10.47A.9.9,0,0,1,100,203c-2.41-1.82-4.79-3.67-7.1-5.49a.9.9,0,1,1,1.12-1.4c2.29,1.81,4.66,3.65,7.06,5.46a.89.89,0,0,1-.54,1.61ZM86.51,192a.9.9,0,0,1-.58-.21c-2.33-2-4.62-3.92-6.8-5.85a.9.9,0,0,1-.08-1.27.89.89,0,0,1,1.26-.07c2.17,1.92,4.45,3.88,6.77,5.82a.89.89,0,0,1-.57,1.58ZM73.12,180.16a.94.94,0,0,1-.62-.25c-2.23-2.12-4.38-4.24-6.39-6.31a.9.9,0,0,1,0-1.27.91.91,0,0,1,1.27,0c2,2.05,4.13,4.16,6.35,6.26a.91.91,0,0,1,0,1.27A.92.92,0,0,1,73.12,180.16ZM60.67,167.3A.87.87,0,0,1,60,167c-2.08-2.37-4-4.71-5.73-7A.9.9,0,0,1,55.69,159c1.7,2.22,3.6,4.53,5.65,6.87a.89.89,0,0,1-.67,1.48ZM49.89,153a.88.88,0,0,1-.76-.42,55.4,55.4,0,0,1-4.19-8.06.89.89,0,1,1,1.65-.68,54.38,54.38,0,0,0,4.06,7.8.89.89,0,0,1-.29,1.23A.9.9,0,0,1,49.89,153Zm-6.3-16.55a.89.89,0,0,1-.89-.85v-.11c0-.37,0-.74,0-1.09a14.65,14.65,0,0,1,2.12-7.9.9.9,0,0,1,1.52,1,12.75,12.75,0,0,0-1.85,6.94c0,.32,0,.65,0,1v.14a.89.89,0,0,1-.86.93Zm70-7.4a.9.9,0,0,1-.28,0c-2.89-1-5.75-1.85-8.51-2.66a.89.89,0,1,1,.5-1.71c2.78.81,5.67,1.71,8.57,2.67a.89.89,0,0,1,.57,1.13A.88.88,0,0,1,113.61,129.09Zm-17.17-5-.22,0c-3-.75-5.9-1.41-8.69-2a.89.89,0,0,1-.7-1,.9.9,0,0,1,1-.7c2.81.55,5.76,1.22,8.77,2a.89.89,0,0,1-.21,1.76Zm-44-1.71a.91.91,0,0,1-.82-.53.9.9,0,0,1,.46-1.18,31.55,31.55,0,0,1,8.9-2.24.88.88,0,0,1,1,.79.89.89,0,0,1-.78,1,29.74,29.74,0,0,0-8.39,2.1A.92.92,0,0,1,52.39,122.37Zm26.49-1.71h-.12c-3.11-.41-6.08-.66-8.82-.76a.9.9,0,1,1,.06-1.79c2.8.1,5.82.36,9,.77a.9.9,0,0,1,.78,1A.89.89,0,0,1,78.88,120.66Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "169.869px 198.841px",
          }}
          id="elfhkmyis4n7j"
          className="animable"
        />
        <path
          d="M132.06,337.71a13.46,13.46,0,0,1-4.61-.8.89.89,0,0,1,.61-1.68,11.64,11.64,0,0,0,4,.69h0a15.2,15.2,0,0,0,4.21-.63l.27.85.19.88a17.15,17.15,0,0,1-4.67.69Zm12.43-4.7a.88.88,0,0,1-.73-.38.9.9,0,0,1,.21-1.25,50.44,50.44,0,0,0,5.52-4.56c.39-.36.78-.74,1.18-1.13a.89.89,0,0,1,1.25,1.28l-1.2,1.16a53.09,53.09,0,0,1-5.72,4.72A.86.86,0,0,1,144.49,333Zm-23.64-1.51a.87.87,0,0,1-.72-.36A32,32,0,0,1,116,323a.9.9,0,0,1,.54-1.15.89.89,0,0,1,1.14.55,30.54,30.54,0,0,0,3.9,7.72.89.89,0,0,1-.19,1.25A.88.88,0,0,1,120.85,331.5Zm36.46-10.88a.9.9,0,0,1-.68-1.47c1.78-2.14,3.6-4.51,5.42-7a.89.89,0,0,1,1.45,1c-1.84,2.56-3.69,5-5.5,7.14A.89.89,0,0,1,157.31,320.62Zm-42.76-5.7a.9.9,0,0,1-.88-.73c-.53-2.75-1-5.75-1.26-8.94a.89.89,0,0,1,1.78-.17c.3,3.13.72,6.08,1.24,8.77a.9.9,0,0,1-.71,1Zm53.26-8.78a.87.87,0,0,1-.49-.14.9.9,0,0,1-.26-1.24c1.55-2.4,3.12-4.95,4.67-7.58a.89.89,0,0,1,1.22-.32.9.9,0,0,1,.32,1.23c-1.56,2.65-3.15,5.22-4.71,7.64A.88.88,0,0,1,167.81,306.14Zm-55.07-9a.89.89,0,0,1-.89-.87c0-1.73-.08-3.53-.08-5.37,0-1.19,0-2.39,0-3.61a.91.91,0,0,1,.91-.88.89.89,0,0,1,.88.91c0,1.21,0,2.4,0,3.58,0,1.82,0,3.61.08,5.32a.89.89,0,0,1-.87.92Zm64.16-6.4a.8.8,0,0,1-.42-.11.88.88,0,0,1-.36-1.21c1.38-2.55,2.78-5.2,4.14-7.9a.9.9,0,0,1,1.6.81c-1.38,2.71-2.78,5.38-4.17,7.94A.89.89,0,0,1,176.9,290.74Zm-63.85-11.48H113a.9.9,0,0,1-.84-.95c.17-2.89.4-5.9.68-8.94a.91.91,0,0,1,1-.81.9.9,0,0,1,.81,1c-.28,3-.51,6-.68,8.89A.89.89,0,0,1,113.05,279.26Zm72-4.47a.92.92,0,0,1-.39-.09.9.9,0,0,1-.42-1.19c1.25-2.64,2.51-5.37,3.73-8.11a.89.89,0,1,1,1.63.73c-1.22,2.75-2.49,5.49-3.74,8.15A.91.91,0,0,1,185,274.79Zm7.29-16.34a.87.87,0,0,1-.35-.07.9.9,0,0,1-.48-1.17c1.14-2.71,2.28-5.49,3.38-8.26a.9.9,0,0,1,1.16-.51.91.91,0,0,1,.5,1.17c-1.1,2.78-2.24,5.57-3.39,8.29A.87.87,0,0,1,192.29,258.45Zm6.59-16.63a1.12,1.12,0,0,1-.31,0,.91.91,0,0,1-.53-1.16c1-2.77,2.07-5.59,3.05-8.39a.9.9,0,0,1,1.69.6c-1,2.8-2,5.64-3.06,8.42A.89.89,0,0,1,198.88,241.82Zm6-16.87a.88.88,0,0,1-.85-1.17c.93-2.8,1.86-5.66,2.74-8.5a.9.9,0,0,1,1.13-.59.89.89,0,0,1,.58,1.12c-.89,2.86-1.82,5.73-2.75,8.53A.89.89,0,0,1,204.83,225Zm5.34-17.07a.73.73,0,0,1-.25,0,.9.9,0,0,1-.61-1.11c.84-2.86,1.66-5.75,2.44-8.58a.89.89,0,0,1,1.1-.63.9.9,0,0,1,.62,1.1c-.78,2.85-1.6,5.74-2.44,8.61A.9.9,0,0,1,210.17,207.88Zm4.72-17.24-.22,0a.88.88,0,0,1-.64-1.08c.3-1.18.59-2.35.88-3.53.43-1.72.84-3.44,1.25-5.14a.89.89,0,1,1,1.74.41c-.41,1.71-.82,3.43-1.25,5.16-.29,1.18-.59,2.36-.89,3.54A.9.9,0,0,1,214.89,190.64Zm4.11-17.4-.19,0a.9.9,0,0,1-.68-1.07c.63-2.94,1.24-5.88,1.8-8.74a.89.89,0,1,1,1.75.34c-.56,2.88-1.17,5.83-1.8,8.78A.9.9,0,0,1,219,173.24Zm3.42-17.56h-.15a.9.9,0,0,1-.73-1c.51-2.94,1-5.91,1.42-8.8a.9.9,0,0,1,1-.76.91.91,0,0,1,.75,1c-.43,2.91-.91,5.89-1.42,8.85A.9.9,0,0,1,222.42,155.68ZM225.05,138h-.11a.9.9,0,0,1-.78-1c.37-3,.69-6,1-8.87a.9.9,0,0,1,1.79.17c-.27,2.9-.6,5.9-1,8.92A.89.89,0,0,1,225.05,138Zm1.64-17.81h-.06a.89.89,0,0,1-.84-.94c.18-3.06.3-6,.35-8.9a.88.88,0,0,1,.91-.88.89.89,0,0,1,.88.91c-.05,2.88-.17,5.9-.35,9A.89.89,0,0,1,226.69,120.18Zm-63.85-11.49a1,1,0,0,1-.43-.11.9.9,0,0,1-.36-1.21c1.47-2.7,3-5.32,4.43-7.81a.89.89,0,1,1,1.54.9c-1.46,2.48-2.94,5.09-4.4,7.76A.88.88,0,0,1,162.84,108.69ZM227,102.31a.89.89,0,0,1-.89-.87c-.1-3.1-.28-6.09-.55-8.86a.89.89,0,1,1,1.78-.18c.27,2.82.46,5.84.56,9a.91.91,0,0,1-.87.92Zm-55.05-9a.92.92,0,0,1-.48-.14.89.89,0,0,1-.27-1.24c1.69-2.61,3.39-5.11,5.06-7.43a.91.91,0,0,1,1.25-.21.9.9,0,0,1,.2,1.25c-1.65,2.3-3.34,4.77-5,7.36A.91.91,0,0,1,171.94,93.29Zm53.25-8.76a.9.9,0,0,1-.88-.72,59.12,59.12,0,0,0-2.24-8.51.89.89,0,0,1,.54-1.14.9.9,0,0,1,1.15.54,61.78,61.78,0,0,1,2.31,8.77.9.9,0,0,1-.71,1Zm-42.75-5.72a.88.88,0,0,1-.57-.2.9.9,0,0,1-.12-1.26c2.05-2.47,4.1-4.72,6.09-6.68A.89.89,0,0,1,189.09,72c-1.94,1.91-4,4.12-6,6.54A.9.9,0,0,1,182.44,78.81ZM218.9,67.94a.89.89,0,0,1-.72-.37,18.14,18.14,0,0,0-2-2.3,13,13,0,0,0-4.5-2.86.89.89,0,1,1,.61-1.68A14.65,14.65,0,0,1,217.43,64a18.29,18.29,0,0,1,2.19,2.54.88.88,0,0,1-.19,1.25A.93.93,0,0,1,218.9,67.94Zm-23.62-1.51a.89.89,0,0,1-.52-1.62A28,28,0,0,1,203,60.67a.89.89,0,0,1,.52,1.71h0a26.26,26.26,0,0,0-7.67,3.88A.9.9,0,0,1,195.28,66.43Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "169.85px 199.171px",
          }}
          id="elgbat98g6foj"
          className="animable"
        />
        <path
          d="M84.82,252.85q-4.68,0-9-.18a.9.9,0,0,1,.08-1.79c2.84.12,5.82.19,8.87.19a.91.91,0,0,1,.91.89A.88.88,0,0,1,84.82,252.85Zm8.94-.16a.9.9,0,0,1,0-1.79c2.89-.1,5.88-.26,8.91-.46a.9.9,0,0,1,1,.84.89.89,0,0,1-.83.95c-3.05.2-6.06.36-9,.46ZM67,252.06h-.09c-3.14-.3-6.15-.7-8.93-1.18a.89.89,0,0,1,.3-1.76c2.74.47,5.71.86,8.8,1.16a.9.9,0,0,1,.81,1A.91.91,0,0,1,67,252.06Zm44.67-.54a.9.9,0,0,1-.09-1.79c2.93-.27,5.91-.59,8.88-.94a.9.9,0,0,1,1,.79.89.89,0,0,1-.78,1c-3,.35-6,.67-8.92.94Zm17.77-2.09a.89.89,0,0,1-.13-1.78c2.89-.41,5.86-.85,8.83-1.33a.89.89,0,1,1,.29,1.76c-3,.48-6,.93-8.87,1.34Zm-80-.5-.24,0a50.74,50.74,0,0,1-8.51-3.21.89.89,0,1,1,.79-1.6,49.59,49.59,0,0,0,8.21,3.09.89.89,0,0,1-.25,1.75Zm97.7-2.35a.89.89,0,0,1-.16-1.77c2.66-.49,5.39-1,8.11-1.55l.66-.13a.89.89,0,0,1,.36,1.75l-.66.14c-2.74.54-5.48,1.06-8.15,1.55Zm17.56-3.45a.89.89,0,0,1-.18-1.77c3-.61,5.91-1.25,8.71-1.92a.9.9,0,0,1,1.08.67.89.89,0,0,1-.67,1.07c-2.81.67-5.76,1.32-8.76,1.93ZM33.8,240.57a.92.92,0,0,1-.67-.29l-.11-.13a14,14,0,0,1-3.63-8.46.9.9,0,0,1,1.79-.11A12.18,12.18,0,0,0,34.37,239l.09.1a.9.9,0,0,1-.06,1.26A.88.88,0,0,1,33.8,240.57ZM182,239a.9.9,0,0,1-.24-1.76c1-.26,1.94-.54,2.89-.82,1.94-.51,3.84-1,5.74-1.54a.89.89,0,1,1,.47,1.72c-1.9.53-3.81,1-5.73,1.55l-2.9.82A.85.85,0,0,1,182,239Zm17.23-4.82a.9.9,0,0,1-.25-1.76c2.86-.84,5.73-1.72,8.54-2.61a.9.9,0,0,1,.54,1.71c-2.82.89-5.7,1.77-8.58,2.62A.73.73,0,0,1,199.25,234.17Zm17.06-5.39a.89.89,0,0,1-.84-.61A.9.9,0,0,1,216,227c2.82-.95,5.66-1.93,8.43-2.93a.89.89,0,0,1,1.15.54.9.9,0,0,1-.54,1.14c-2.79,1-5.64,2-8.47,2.95A.93.93,0,0,1,216.31,228.78Zm-184-4.85a.85.85,0,0,1-.4-.1.88.88,0,0,1-.39-1.2,35.79,35.79,0,0,1,5.26-7.47.89.89,0,0,1,1.26-.08.9.9,0,0,1,.07,1.27,34.23,34.23,0,0,0-5,7.09A.9.9,0,0,1,32.32,223.93Zm200.83-1.21a.9.9,0,0,1-.32-1.73c2.8-1.08,5.6-2.18,8.3-3.29a.89.89,0,1,1,.68,1.65c-2.72,1.12-5.52,2.23-8.34,3.31A.87.87,0,0,1,233.15,222.72Zm16.56-6.8a.91.91,0,0,1-.82-.53.89.89,0,0,1,.46-1.18c2.76-1.22,5.5-2.47,8.12-3.71a.89.89,0,1,1,.76,1.62c-2.63,1.25-5.38,2.5-8.16,3.72A.94.94,0,0,1,249.71,215.92ZM43.88,210.43a.9.9,0,0,1-.58-1.58c2.12-1.82,4.52-3.68,7.12-5.54a.89.89,0,1,1,1,1.45c-2.56,1.83-4.91,3.66-7,5.45A.93.93,0,0,1,43.88,210.43Zm222-2.19a.88.88,0,0,1-.79-.48.9.9,0,0,1,.38-1.21c2.72-1.39,5.36-2.81,7.86-4.22a.89.89,0,0,1,.87,1.56c-2.51,1.42-5.17,2.85-7.91,4.26A1,1,0,0,1,265.87,208.24ZM58.38,200a.89.89,0,0,1-.47-1.65c2.43-1.52,5-3.07,7.73-4.58a.89.89,0,0,1,1.22.34.9.9,0,0,1-.34,1.22c-2.68,1.5-5.25,3-7.66,4.54A.94.94,0,0,1,58.38,200Zm223.07-.52a.89.89,0,0,1-.48-1.65c2.62-1.65,5.11-3.31,7.39-4.95a.89.89,0,0,1,1.25.21.88.88,0,0,1-.21,1.24c-2.31,1.66-4.82,3.35-7.48,5A.89.89,0,0,1,281.45,199.44ZM74,191.17a.89.89,0,0,1-.41-1.69c2.58-1.33,5.29-2.66,8-4a.91.91,0,0,1,1.2.42.89.89,0,0,1-.43,1.19c-2.75,1.31-5.44,2.63-8,3.95A1,1,0,0,1,74,191.17Zm222-2.21a.86.86,0,0,1-.67-.32.89.89,0,0,1,.09-1.26c.9-.76,1.75-1.53,2.55-2.28,1.38-1.3,2.65-2.6,3.77-3.87a.9.9,0,1,1,1.34,1.19c-1.16,1.3-2.46,2.64-3.88,4-.82.77-1.7,1.56-2.61,2.34A.94.94,0,0,1,295.93,189Zm11.51-13.56a.93.93,0,0,1-.4-.09.9.9,0,0,1-.4-1.2,21.6,21.6,0,0,0,1.06-2.55,14.74,14.74,0,0,0,.87-4.83q0-.39,0-.78a.9.9,0,0,1,1.79-.12q0,.45,0,.9a16.64,16.64,0,0,1-1,5.41,21.9,21.9,0,0,1-1.15,2.76A.89.89,0,0,1,307.44,175.4ZM306.06,159a.91.91,0,0,1-.67-.3,22.47,22.47,0,0,0-6.89-5.05.89.89,0,0,1,.8-1.6,24.36,24.36,0,0,1,7.44,5.47.9.9,0,0,1-.09,1.26A.88.88,0,0,1,306.06,159Zm-15.51-8.43a1.09,1.09,0,0,1-.25,0,79.82,79.82,0,0,0-8.63-1.94.9.9,0,0,1,.31-1.77,84.47,84.47,0,0,1,8.82,2,.9.9,0,0,1-.25,1.76ZM273,147.39h-.09c-2.81-.28-5.8-.49-8.87-.62a.89.89,0,0,1-.86-.93.92.92,0,0,1,.93-.86c3.11.14,6.13.35,9,.63a.89.89,0,0,1-.09,1.78Zm-26.81-.65a.9.9,0,0,1,0-1.79c3-.11,6-.16,8.84-.16h.14a.9.9,0,0,1,0,1.79H255c-2.83,0-5.78,0-8.77.16Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "169.91px 198.82px",
          }}
          id="eldglbe9sjm4"
          className="animable"
        />
        <path
          d="M40.1,201.91a10.27,10.27,0,1,1-7.93,12.17A10.28,10.28,0,0,1,40.1,201.91Z"
          style={{
            fill: "#213E60",
            transformOrigin: "42.2195px 211.959px",
          }}
          id="elq7vaztdn95g"
          className="animable"
        />
        <g id="elbdgjnrptgn">
          <path
            d="M40.1,201.91a10.27,10.27,0,1,1-7.93,12.17A10.28,10.28,0,0,1,40.1,201.91Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.2,
              transformOrigin: "42.2195px 211.959px",
            }}
            className="animable"
            id="el1i1zbls8fq"
          />
        </g>
        <g id="el6wk6arxlas">
          <path
            d="M48.68,214.1c-1.58,5.17-6.9,7.56-12,6.48a10.27,10.27,0,1,0,7.7-18.67C47.06,202.75,50.36,208.61,48.68,214.1Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.15,
              transformOrigin: "44.6058px 212.07px",
            }}
            className="animable"
            id="elhu06qtwtrgi"
          />
        </g>
        <g id="elbb6q19lfx64">
          <circle
            cx={227.07}
            cy={103.86}
            r={10.27}
            style={{
              fill: "#213E60",
              transformOrigin: "227.07px 103.86px",
              transform: "rotate(-67.5deg)",
            }}
            className="animable"
            id="ela5ulf4k0c0p"
          />
        </g>
        <g id="elkdb9ajiz9ep">
          <circle
            cx={227.07}
            cy={103.86}
            r={10.27}
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.5,
              transformOrigin: "227.07px 103.86px",
              transform: "rotate(-67.5deg)",
            }}
            className="animable"
            id="el6o9omm7c1px"
          />
        </g>
        <g id="elst4czyux9fl">
          <path
            d="M223.64,109.74c-4.73-2.61-6-8.31-3.85-13.12A10.27,10.27,0,1,0,236.47,108C235.08,110.5,228.66,112.52,223.64,109.74Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.35,
              transformOrigin: "226.635px 105.377px",
            }}
            className="animable"
            id="eltozcauwsyvk"
          />
        </g>
        <path
          d="M290.79,248a10.27,10.27,0,1,1,.64-14.51A10.27,10.27,0,0,1,290.79,248Z"
          style={{
            fill: "#213E60",
            transformOrigin: "283.855px 240.425px",
          }}
          id="elrjjsau8w30m"
          className="animable"
        />
        <g id="elgj7giz0uuwb">
          <path
            d="M290.79,248a10.27,10.27,0,1,1,.64-14.51A10.27,10.27,0,0,1,290.79,248Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.5,
              transformOrigin: "283.855px 240.425px",
            }}
            className="animable"
            id="elof2j8558jb9"
          />
        </g>
        <g id="elm9i27j1kg9i">
          <path
            d="M277.2,241.85c-1.27-5.25,2.1-10,7.08-11.7a10.27,10.27,0,1,0,2.86,20C284.37,250.8,278.54,247.43,277.2,241.85Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.35,
              transformOrigin: "280.374px 240.412px",
            }}
            className="animable"
            id="elowb9bsz1ef"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter id="active" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id="hover" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#ff0000" floodOpacity={0.5} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
        <feColorMatrix
          type="matrix"
          values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
        />
      </filter>
    </defs>
  </svg>
);
export default SKillsSVG;
